export default {
  services_number_title: "Nombre de services au choix",
  additional_information_after_booking_title:
    "Informations supplémentaires dans les e-mails de réservation",
  additional_information_after_booking_subtitle:
    "Nous les ajoutons aux e-mails de réservation créée, modifiée et à venir.",
  additional_information_after_booking_dummy_text:
    "Ceci est un texte d’exemple qui sera remplacé par les informations supplémentaires après la réservation, si elles ont été renseignées dans les paramètres du service.",
  plugins_storage_100gb_cd_base_pro_name: "Stockage de fichiers 100 Go",
  plugins_storage_500gb_cd_base_pro_name: "Stockage de fichiers 500 Go",
  plugins_storage_100gb_cd_base_pro_description:
    "Plus d’espace pour vos fichiers. Gagnez 100 Go supplémentaires pour échanger des fichiers avec vos clients et recevoir des pièces jointes via les formulaires de réservation. Une solution idéale pour fluidifier la communication et améliorer le service client.",
  plugins_storage_500gb_cd_base_pro_description:
    "Un espace maximal pour vos fichiers. Profitez de 500 Go de stockage pour échanger des fichiers avec vos clients et recevoir des pièces jointes via les formulaires de réservation, sans aucune limite. Indispensable pour les entreprises en pleine croissance qui misent sur le professionnalisme et le confort.",
  bookings_this_month: "Réservations ce mois-ci",
  bookings_all_processed: "Toutes les réservations",
  simple_store_product_transactions_this_month: "Produits vendus ce mois-ci",
  files_storage_usage: "Stockage de fichiers utilisé",
  files_storage_usage_from_available_prefix: "sur un total de",
  not_available_in_standard_plan:
    "Fonctionnalité non disponible dans le plan Standard",
  ai_tokens_usage: "Tokens IA utilisés",
  ai_tokens_usage_from_available_prefix: "sur un total de",
  ai_tokens_resets_at: "Réinitialisation",
  cancel_reason_dropdown_label: "Motif d’annulation de l’abonnement",
  cancel_subscription_category_1_title: "Problèmes techniques",
  cancel_subscription_category_1_reason_1_title:
    "Pannes ou interruptions fréquentes",
  cancel_subscription_category_1_reason_2_title: "Lenteur du système",
  cancel_subscription_category_1_reason_3_title:
    "Interface difficile à utiliser",
  cancel_subscription_category_1_reason_4_title:
    "Problèmes avec les intégrations (par ex. système de paiement, calendriers externes)",
  cancel_subscription_category_1_reason_5_title:
    "Inquiétudes liées à la sécurité (par ex. fuites de données)",
  cancel_subscription_category_1_reason_6_title:
    "Problèmes avec l’application mobile des employés (par ex. plantages, bugs)",
  cancel_subscription_category_2_title:
    "Changements personnels ou professionnels",
  cancel_subscription_category_2_reason_1_title:
    "Changement de modèle économique (par ex. besoin réduit de réservations)",
  cancel_subscription_category_2_reason_2_title:
    "Contraintes budgétaires ou difficultés financières",
  cancel_subscription_category_2_reason_3_title:
    "Trop de travail pour gérer le système",
  cancel_subscription_category_2_reason_4_title:
    "Fermeture ou réduction de mon activité",
  cancel_subscription_category_2_reason_5_title:
    "Pas assez de temps pour gérer les réservations",
  cancel_subscription_category_3_title: "Prix et concurrence",
  cancel_subscription_category_3_reason_1_title:
    "Alternatives moins chères disponibles",
  cancel_subscription_category_3_reason_2_title:
    "Hausse de prix ou changement du modèle de facturation",
  cancel_subscription_category_4_title: "Problèmes d’expérience utilisateur",
  cancel_subscription_category_4_reason_1_title:
    "Difficultés à naviguer dans le système",
  cancel_subscription_category_4_reason_2_title:
    "Fonctionnalités essentielles manquantes",
  cancel_subscription_category_4_reason_3_title:
    "Trop complexe pour mon équipe ou mon activité",
  cancel_subscription_category_4_reason_4_title:
    "Support client lent ou peu utile",
  cancel_subscription_category_4_reason_5_title:
    "Options de personnalisation limitées",
  cancel_subscription_category_4_reason_6_title:
    "Processus de configuration ou de prise en main compliqué",
  cancel_subscription_category_5_title: "Facteurs externes et liés au marché",
  cancel_subscription_category_5_reason_1_title:
    "Évolution des tendances du marché (par ex. passage aux réservations via les réseaux sociaux)",
  cancel_subscription_category_5_reason_2_title:
    "Crise ou ralentissement économique",
  cancel_subscription_category_5_reason_3_title: "Changements réglementaires",
  cancel_subscription_category_6_title: "Autre",
  cancel_subscription_category_6_reason_1_title:
    "Un motif absent de cette liste",
  cancel_subscription_category_6_reason_2_title: "Je préfère ne pas répondre",
  cancel_plan_and_delete_data: "Annuler et supprimer mes données",
  cancel_plan_do_nothing: "Ne rien faire",
  cancel_plan_and_keep_data_confirmation_label:
    "Voulez-vous vraiment annuler votre abonnement tout en conservant vos données ?",
  cancel_plan_and_keep_data_confirmation_info:
    "L’abonnement sera annulé à la fin de la période de facturation déjà payée. Vos données resteront stockées en toute sécurité sur nos serveurs et pourront être restaurées à tout moment lors de la réactivation de l’abonnement.",
  scheduled_cancel_keeps_data_info:
    "Votre plan sera annulé, mais vos données seront conservées",
  no_just_checking_title: "Non, je regarde simplement",
  payment_deadline_before_start_variable:
    "Délai de paiement avant le début de chaque réservation récurrente",
  send_payment_reminder_before_start_variable:
    "Moment d’envoi du rappel de paiement avant la réservation",
  variable_service_reschedule_deadline_before_start:
    "Délai de report avant le début de la réservation",
  variable_service_cancel_deadline_before_start:
    "Délai d’annulation avant le début de la réservation",
  variable_customer_private_notes: "Notes privées sur le client",
  booking_awaiting_payment_full_description:
    "Informations complètes sur le paiement requis",
  booking_awaiting_payment_full_description_example:
    "Votre réservation sera annulée si le paiement n’est pas effectué dans les 30 min. Cliquez ci-dessous pour accéder à votre réservation et effectuer le paiement.",
  recurring_meeting_in_the_past_warning:
    "Vous ne pouvez pas créer une réunion récurrente avec des dates de début dans le passé. Choisissez une date de début dans le futur ou décochez l’option « Cet événement se répète ».",
  booking_overlaps_dialog_title: "Conflit détecté dans le calendrier",
  booking_overlaps_dialog_message:
    "Lors de la vérification de la disponibilité, nous avons détecté que le créneau sélectionné entre en conflit avec des réservations existantes ou des dates bloquées. Détails du conflit :",
  booking_overlaps_count: "Nombre de réservations en conflit",
  unavailable_slot_overlaps_count: "Nombre de dates bloquées en conflit",
  booking_overlaps_dialog_question: "Voulez-vous continuer malgré tout ?",
  selected_date: "Date sélectionnée",
  single_booking: "Réservation unique",
  external_api_service_not_enabled_error:
    "La fonctionnalité API n’est pas disponible sur ce compte.",
  integration_auth_code_expired_error:
    "La connexion n'a pas pu être finalisée car l'autorisation a expiré. Cliquez à nouveau sur « Connecter » et terminez la connexion sans longues pauses.",
  google_calendar_disconnected_info:
    "Google Calendar est déconnecté, car Google ne donne pas à Calendesk l’accès à votre agenda. En général, certaines autorisations n’ont pas été cochées lors de la connexion. Connectez à nouveau votre compte et cochez sur l’écran de Google toutes les autorisations demandées.",
  google_calendar_reconnect: "Reconnecter",
  outlook_mailbox_not_available_error:
    "Le calendrier de ce compte Microsoft n'a pas pu être connecté. La cause peut être une boîte aux lettres hébergée sur un serveur de l'entreprise plutôt que dans Microsoft 365, un compte sans boîte active ou une boîte supprimée. Vérifiez-le avec votre administrateur Microsoft 365.",
  service_not_available_at_selected_time:
    "Le service n’est pas disponible à l’heure sélectionnée.",
  service_not_available_pool_full:
    "Le service n’est pas disponible à cette heure : aucun élément n’est libre dans l’ensemble « @{pool} » (occupés : @{used} sur @{capacity}).",
  service_not_available_pool_rule:
    "Le service n’est pas disponible à cette heure : les éléments libres de l’ensemble « @{pool} » sont prévus pour d’autres réservations.",
  service_not_available_resource_taken:
    "Le service n’est pas disponible à cette heure : la ressource « @{resource} » est occupée par une autre réservation.",
  offline_mode: "Vous êtes hors ligne",
  offline_description:
    "L’application nécessite une connexion internet pour fonctionner.",
  retry: "Réessayer",
  checking_connection: "Vérification de la connexion...",
  waiting_for_connection: "En attente de connexion",
  "2fa_verify_title": "Authentification à deux facteurs",
  "2fa_verify_description":
    "Entrez le code à 6 chiffres de votre application d’authentification ou utilisez un code de récupération :",
  "2fa_recovery_code_label": "Code de récupération",
  "2fa_use_recovery_code": "Utiliser un code de récupération",
  "2fa_use_app_code": "Utiliser le code de l’application",
  "2fa_verify_incorrect_error": "Le code 2FA est incorrect. Réessayez.",
  "2fa_session_expired_error": "Votre session 2FA a expiré. Reconnectez-vous.",
  "2fa_verification_cancelled":
    "L’authentification à deux facteurs a été annulée. Réessayez.",
  enable_2fa: "Activer la 2FA",
  enable_2fa_title: "Activer la vérification en deux étapes",
  disable_2fa: "Désactiver la 2FA",
  disable_2fa_title: "Désactiver la vérification en deux étapes",
  "2fa_manual_setup": "Impossible de scanner ? Entrez ce code manuellement :",
  "2fa_recovery_codes_title": "Codes de récupération",
  "2fa_download_codes": "Télécharger les codes",
  "2fa_disable_description":
    "Vous êtes sur le point de désactiver la vérification en deux étapes. Votre compte sera moins sécurisé.",
  "2fa_disable_warning":
    "La désactivation de la vérification en deux étapes réduira la sécurité de votre compte.",
  "2fa_verify_to_disable": "Vérifiez votre identité",
  "2fa_verify_to_disable_description":
    "Entrez un code de votre application d’authentification ou utilisez un code de récupération pour désactiver la vérification en deux étapes.",
  warning: "Avertissement",
  current_password: "Mot de passe actuel",
  incorrect_password: "Mot de passe incorrect. Réessayez.",
  "2fa_setup_failed": "La configuration de la 2FA a échoué",
  "2fa_activation_failed": "L’activation de la 2FA a échoué",
  "2fa_verification_code": "Code de vérification",
  "2fa_disabled_success": "La 2FA a été désactivée",
  "2fa_disable_failed": "La désactivation de la 2FA a échoué",
  "2fa_step_1_password_title": "Entrez votre mot de passe",
  "2fa_step_1_scan_title": "Scannez le code QR",
  "2fa_step_2_verify_title": "Vérifiez la configuration",
  "2fa_authenticator_apps_required": "Application d’authentification requise",
  "2fa_setup_secure_subtitle":
    "Choisissez et installez une application 2FA sécurisée pour protéger votre compte",
  "2fa_apps_installation_note":
    "Installez l’une de ces applications sur votre téléphone avant de poursuivre la configuration.",
  "2fa_scan_with_app":
    "Scannez ce code QR avec votre application d’authentification",
  "2fa_enter_code_from_app":
    "Entrez le code à 6 chiffres de votre application d’authentification",
  "2fa_recovery_codes_warning":
    "Conservez ces codes en lieu sûr. Chaque code ne peut être utilisé qu’une seule fois.",
  "2fa_enter_password_to_continue":
    "Entrez votre mot de passe actuel pour générer votre code QR unique",
  "2fa_enter_password_to_disable":
    "Entrez votre mot de passe actuel pour confirmer la désactivation de la 2FA",
  "2fa_disable_verification_description":
    "Entrez votre mot de passe actuel et un code de votre application d’authentification ou utilisez un code de récupération pour désactiver la vérification en deux étapes.",
  "2fa_recovery_codes_description":
    "Ces codes de secours vous permettent d’accéder à votre compte si vous perdez votre application d’authentification. Chaque code ne peut être utilisé qu’une seule fois, conservez-les donc en lieu sûr.",
  security_settings: "Paramètres de sécurité",
  security_settings_description:
    "Gérez les paramètres de sécurité de votre compte et vos méthodes d’authentification.",
  "2fa_security_title": "Vérification en deux étapes",
  "2fa_security_description":
    "Ajoutez un niveau de sécurité supplémentaire à votre compte avec la vérification en deux étapes.",
  reset_password_description:
    "Envoyez un lien de réinitialisation du mot de passe à votre adresse e-mail.",
  "2fa_enabled_success": "La 2FA a été activée",
  linkedin: "LinkedIn",
  profile_company_social_media_linkedin_label_input:
    "Lien vers un profil LinkedIn",
  logs_diff_linkedin: "Lien vers un profil LinkedIn",
  tiktok: "TikTok",
  profile_company_social_media_tiktok_label_input: "Lien vers un profil TikTok",
  logs_diff_tiktok: "Lien vers un profil TikTok",
  wb_linkedin: "URL LinkedIn",
  wb_tiktok: "URL TikTok",
  plugins_calendesk_chat_cd_base_standard_name: "Calendesk Chat",
  plugins_calendesk_chat_cd_base_standard_description:
    "Améliorez la communication avec vos clients grâce à Calendesk Chat. Offrez une assistance en temps réel, répondez aux questions et échangez avec vos clients directement depuis votre page de réservation. Parfait pour les entreprises qui veulent créer des relations plus solides avec leurs clients.",
  plugins_calendesk_chat_cd_base_pro_name: "Calendesk Chat",
  plugins_calendesk_chat_cd_base_pro_description:
    "Améliorez la communication avec vos clients grâce à Calendesk Chat. Offrez une assistance en temps réel, répondez aux questions et échangez avec vos clients directement depuis votre page de réservation. Parfait pour les entreprises qui veulent créer des relations plus solides avec leurs clients.",
  number_of_agents: "Nombre d’agents",
  agents_plural: "agents",
  integrations_category_customer_support: "Support client",
  chatwoot_title: "Calendesk Chat",
  chatwoot_description:
    "Gérez votre support par chat en direct. Accédez au tableau de bord, configurez les agents et consultez les conversations.",
  chatwoot_package_not_active:
    "Le pack Calendesk Chat n’est pas actif. Activez-le dans les paramètres de votre abonnement.",
  chatwoot_setup_title: "Configurez votre support par chat",
  chatwoot_setup_info:
    'Calendesk Chat est une application distincte, disponible sur <a href="https://chat.calendesk.com" target="_blank">chat.calendesk.com</a>, où vous gérerez les conversations avec vos clients.',
  chatwoot_setup_sso_warning:
    "Tous les administrateurs Calendesk ayant accès aux intégrations pourront se connecter au tableau de bord du chat.",
  chatwoot_setup_next_steps_title: "Après la configuration :",
  chatwoot_setup_next_step_1:
    'Un compte de chat sera créé sur <a href="https://chat.calendesk.com" target="_blank">chat.calendesk.com</a>',
  chatwoot_setup_next_step_2:
    "Les administrateurs pourront se connecter au tableau de bord du chat en un clic depuis le menu Calendesk",
  chatwoot_setup_next_step_3:
    "Vous pourrez ajouter le widget de chat à votre page de réservation : le code d’intégration se trouve dans le tableau de bord du chat",
  chatwoot_company_section_title: "Informations sur l’entreprise",
  chatwoot_admin_section_title: "Administrateur du chat",
  chatwoot_business_name: "Nom de l’entreprise",
  chatwoot_business_name_hint:
    "Visible par les clients dans le widget de chat et les notifications",
  chatwoot_admin_name: "Nom et prénom",
  chatwoot_admin_email: "E-mail",
  chatwoot_support_email: "E-mail du support client",
  chatwoot_support_email_placeholder: "par ex. support@votreentreprise.com",
  chatwoot_support_email_hint:
    "Vos clients verront cette adresse comme expéditeur des réponses e-mail de votre équipe",
  chatwoot_start_integration: "Configurer",
  chatwoot_integration_active: "Calendesk Chat est actif et prêt à l’emploi.",
  chatwoot_dashboard_info:
    'Gérez vos conversations, vos agents et vos paramètres dans le tableau de bord du chat sur <a href="https://chat.calendesk.com" target="_blank">chat.calendesk.com</a>.',
  chatwoot_sso_warning:
    "Tous les administrateurs Calendesk ayant accès aux intégrations peuvent se connecter au tableau de bord du chat en un clic.",
  chatwoot_open_dashboard: "Ouvrir le tableau de bord",
  chatwoot_agent_limit: "Postes d’agents",
  chatwoot_buy_more_agents:
    "Besoin de plus d’agents ? Passez à un pack supérieur",
  chatwoot_integration_success: "Calendesk Chat a été configuré.",
  chatwoot_integration_error:
    "La configuration de Calendesk Chat a échoué. Réessayez ou contactez le support.",
  chatwoot_sso_error:
    "Impossible d’ouvrir le tableau de bord du chat. Réessayez ou contactez le support.",
  chatwoot_suspend_button: "Suspendre",
  chatwoot_suspend_title: "Suspendre Calendesk Chat",
  chatwoot_suspend_warning:
    "La suspension désactivera le widget de chat sur le site web pour vos clients finaux, <strong>mais n’affecte ni l’activité du pack ni les frais associés</strong>.<br><br>Pour résilier le pack, allez dans <strong>Facturation → Abonnement</strong> et sélectionnez <strong>Désactiver</strong>.",
  chatwoot_suspend_confirm: "Suspendre",
  chatwoot_suspend_success: "Calendesk Chat a été suspendu.",
  chatwoot_suspend_error:
    "Impossible de suspendre Calendesk Chat. Réessayez ou contactez le support.",
  chatwoot_suspended_info:
    "Votre compte Calendesk Chat est actuellement suspendu.",
  chatwoot_suspended_data_preserved:
    "Toutes vos conversations et tous vos paramètres sont conservés et seront restaurés lors de la réactivation.",
  chatwoot_reactivate_button: "Réactiver",
  chatwoot_reactivation_success: "Calendesk Chat a été réactivé.",
  chatwoot_reactivation_error:
    "Impossible de réactiver Calendesk Chat. Réessayez ou contactez le support.",
  chatwoot_suspended_tooltip: "Suspendu : cliquez pour réactiver",
  chatwoot_agent_limit_exceeded:
    "Vous avez @{current} agents, mais votre pack n’en autorise que @{limit}.",
  chatwoot_agent_limit_contact_support:
    "Pour réactiver Calendesk Chat, contactez notre équipe de support. Nous vous aiderons à ajuster le nombre d’agents à la limite de votre pack.",
  contact_support: "Contacter l’assistance",
  chatwoot_min_agents_info:
    "Au moins @{count} agents sont requis selon votre configuration actuelle de Calendesk Chat.",
  chatwoot_close_confirm_title: "Fermer le formulaire ?",
  chatwoot_close_confirm_warning:
    "Les données saisies n’ont pas été enregistrées et seront perdues.",
  chatwoot_close_confirm_yes: "Fermer",
  chatwoot_close_confirm_no: "Revenir au formulaire",
  dialog_close_confirm_title: "Fermer ?",
  dialog_close_confirm_warning:
    "Les modifications non enregistrées seront perdues.",
  dialog_close_confirm_yes: "Fermer",
  dialog_close_confirm_no: "Annuler",
  reports: "Rapports",
  reports_granularity: "Regrouper par",
  reports_revenue: "Revenus et paiements",
  reports_bookings: "Réservations",
  reports_team: "Mon équipe",
  reports_customers: "Clients et ventes",
  reports_clients: "Clients",
  reports_subscriptions: "Abonnements",
  reports_products: "Produits",
  reports_tab_revenue: "Revenus",
  date_range: "Plage de dates",
  vs_previous_period: "vs période précédente",
  reports_revenue_timeline: "Évolution des revenus",
  reports_top_services: "Services les plus réservés",
  reports_top_products: "Top produits",
  reports_payment_providers: "Modes de paiement",
  reports_payment_methods_count: "Transactions par mode de paiement",
  reports_payment_methods_value: "Revenus par mode de paiement",
  reports_payment_timeline: "Évolution des paiements",
  reports_bookings_timeline: "Évolution des réservations",
  reports_by_service: "Par service",
  reports_by_employee: "Par employé",
  reports_by_delivery_type: "Par type de réalisation",
  reports_cancellation_reasons: "Motifs d’annulation",
  reports_by_day: "Par jour de la semaine",
  reports_by_hour: "Par heure",
  reports_heatmap: "Carte thermique des réservations",
  reports_employee_performance: "Performance de l’équipe",
  reports_service_ranking: "Classement des services",
  reports_by_category: "Par catégorie",
  reports_locations: "Lieux",
  reports_customer_segments: "Engagement des clients",
  reports_top_customers: "Meilleurs clients",
  reports_product_revenue_timeline: "Évolution des revenus des produits",
  reports_booking_revenue_timeline: "Évolution des revenus des réservations",
  reports_top_subscriptions: "Top abonnements",
  reports_subscription_timeline: "Évolution des nouveaux abonnements",
  reports_subscription_revenue_timeline:
    "Évolution des revenus des abonnements",
  reports_revenue_forecast: "Prévision des revenus",
  reports_bookings_forecast: "Prévision des réservations",
  reports_section_key_metrics: "Indicateurs clés",
  reports_section_key_metrics_tooltip:
    "<b>Indicateurs clés</b><br><br>Les principaux indicateurs de votre activité sur la période sélectionnée. Les flèches indiquent l’évolution par rapport à la période précédente de même durée.",
  reports_section_trends: "Tendances",
  reports_section_trends_tooltip:
    "<b>Tendances</b><br><br>L’évolution de vos revenus et de vos réservations sur la période sélectionnée.",
  reports_section_revenue: "Revenus",
  reports_section_revenue_tooltip:
    "<b>Revenus</b><br><br>Total des revenus de toutes les sources sur la période sélectionnée. Seuls les <b>paiements finalisés</b> sont comptabilisés.<br><br>Comprend :<br>• <b>Répartition des revenus</b> : réservations, abonnements et produits<br>• <b>Valeur moyenne par réservation</b> et <b>% de réservations payées</b><br>• <b>Évolution des revenus</b> : comment vos revenus ont évolué dans le temps<br>• <b>Top services, abonnements et produits</b> : classés par revenus<br>• <b>Modes de paiement</b> : nombre de transactions et revenus par mode",
  reports_section_bookings: "Réservations",
  reports_section_bookings_tooltip:
    "<b>Réservations</b><br><br>Statuts des réservations, volume dans le temps et répartition par service et par membre de l’équipe sur la période sélectionnée.<br><br>Comprend :<br>• <b>Répartition par statut</b> : réservations acceptées, terminées et annulées<br>• <b>Évolution des réservations</b> : variation du volume dans le temps<br>• <b>Revenus des réservations</b> : leur évolution dans le temps<br>• <b>Par service et par membre de l’équipe</b> : services les plus réservés et employés les plus sollicités",
  reports_section_patterns: "Habitudes de réservation",
  reports_section_patterns_tooltip:
    "<b>Habitudes de réservation</b><br><br>Quand vos clients préfèrent réserver. Utilisez ces données pour optimiser votre planning.<br><br>Comprend :<br>• <b>Carte thermique des heures de pointe</b> : jours et heures les plus chargés<br>• <b>Jour le plus chargé</b> : le jour de la semaine qui reçoit le plus de réservations<br>• <b>Par heure</b> : répartition des réservations sur la journée",
  reports_section_employees: "Mon équipe",
  reports_section_employees_tooltip:
    "<b>Mon équipe</b><br><br>La performance de chaque membre de l’équipe sur la période sélectionnée.<br><br>Comprend :<br>• <b>Réservations terminées</b> : nombre de réservations terminées par personne<br>• <b>Revenus générés</b> : revenus issus de leurs réservations<br>• <b>Taux de remplissage du planning</b> : part du temps disponible qui a été réservée",
  reports_section_services: "Services",
  reports_section_services_tooltip:
    "<b>Services</b><br><br>Les services les plus populaires et leurs revenus sur la période sélectionnée.<br><br>Comprend :<br>• <b>Réservations par service</b> : nombre de réservations acceptées et terminées<br>• <b>Revenus par service</b> : revenus générés",
  reports_section_locations: "Lieux",
  reports_section_locations_tooltip:
    "<b>Lieux</b><br><br>Répartition des résultats par lieu et par type de réalisation sur la période sélectionnée.",
  reports_section_customers: "Clients",
  reports_section_customers_tooltip:
    "<b>Clients</b><br><br>Qui réserve le plus souvent, qui dépense le plus et le niveau d’engagement de vos clients sur la période sélectionnée.<br><br>Comprend :<br>• <b>Nouveaux clients</b> : inscrits sur la période sélectionnée<br>• <b>Clients actifs</b> : au moins une réservation sur la période<br>• <b>Graphique d’engagement</b> : nouveaux clients, clients récurrents et habitués fidèles<br>• <b>Top clients</b> : ceux qui ont le plus dépensé sur la période sélectionnée",
  reports_section_customer_overview: "Clients",
  reports_section_customer_overview_tooltip:
    "<b>Clients</b><br><br>Ces valeurs couvrent tout votre historique et ne changent pas avec le filtre de dates.",
  reports_section_customer_activity: "Activité sur la période",
  reports_section_customer_activity_tooltip:
    "<b>Activité sur la période</b><br><br>Comment vos clients se sont engagés sur la période sélectionnée : réservations, rétention et préférences.",
  reports_section_products: "Produits",
  reports_section_products_tooltip:
    "<b>Produits</b><br><br>Ventes de produits, revenus dans le temps et meilleures ventes sur la période sélectionnée.<br><br>Comprend :<br>• <b>Revenus totaux des produits</b> sur la période sélectionnée<br>• <b>Évolution des revenus</b> : comment les ventes de produits ont évolué dans le temps<br>• <b>Top produits</b> : les meilleures ventes classées par revenus",
  reports_section_subscriptions: "Abonnements",
  reports_section_subscriptions_tooltip:
    "<b>Abonnements</b><br><br>Revenus, renouvellements et utilisation de vos plans d’abonnement sur la période sélectionnée.<br><br>Comprend :<br>• <b>Abonnements actifs</b> : nombre de clients ayant un plan actif en ce moment<br>• <b>Revenus</b> : montant gagné grâce aux abonnements sur la période sélectionnée<br>• <b>Taux de renouvellement</b> : nombre d’abonnés ayant payé plus d’une fois (plus il est élevé, plus vos clients reviennent)<br>• <b>Nouveaux abonnements</b> : nombre de nouveaux abonnements démarrés par période<br>• <b>Revenus des abonnements</b> : leur évolution dans le temps<br>• <b>Top abonnements</b> : les plans qui rapportent le plus<br>• <b>Utilisation</b> : vos abonnés utilisent-ils vraiment les réservations incluses ?",
  reports_section_payments: "Paiements",
  reports_section_payments_tooltip:
    "<b>Paiements</b><br><br>Données de transactions et répartition par mode de paiement sur la période sélectionnée.<br><br>Comprend :<br>• <b>Total des transactions</b> : nombre de paiements finalisés<br>• <b>% de réservations payées</b> : la part de vos réservations qui ont donné lieu à un paiement<br>• <b>Par mode de paiement</b> : nombre de transactions et revenus par mode",
  reports_section_booking_status: "Statut des réservations",
  reports_section_cancellation_reasons: "Motifs d’annulation",
  reports_section_peak_hours: "Heures de pointe",
  reports_section_peak_hours_tooltip:
    "<b>Comment lire ce graphique :</b><br><br><b>Lignes</b> = jours de la semaine<br><b>Colonnes</b> = heures de la journée (00:00–23:00)<br><br>Chaque cellule indique le <b>nombre total</b> de réservations acceptées et terminées prévues ce jour-là à cette heure sur <b>l’ensemble de la période sélectionnée</b>.<br><br><b>Exemple :</b> si vous avez sélectionné 3 mois, la cellule lundi 10:00 indique combien de réservations ont eu lieu un lundi à 10:00 sur l’ensemble de ces 3 mois.<br><br>🟦 Couleur plus foncée = plus de réservations",
  reports_section_busiest_day: "Jour le plus chargé de la semaine",
  stats_monday: "lundi",
  stats_tuesday: "mardi",
  stats_wednesday: "mercredi",
  stats_thursday: "jeudi",
  stats_friday: "vendredi",
  stats_saturday: "samedi",
  stats_sunday: "dimanche",
  stats_mon: "Lun",
  stats_tue: "Mar",
  stats_wed: "Mer",
  stats_thu: "Jeu",
  stats_fri: "Ven",
  stats_sat: "Sam",
  stats_sun: "Dim",
  reports_section_delivery_type: "Par type de réalisation",
  reports_section_peak_times: "Créneaux les plus demandés",
  reports_bookings_by_hour: "Réservations par heure",
  reports_bookings_by_service: "Services les plus réservés",
  reports_bookings_by_employee: "Membres de l’équipe les plus actifs",
  reports_booking_lead_time: "Anticipation des réservations",
  reports_bookings_by_location: "Réservations par lieu",
  reports_employee_performance_note:
    "Le taux de remplissage du planning affiche « -- » si aucune heure de travail n’est définie pour ce membre de l’équipe.",
  reports_customer_segments_chart: "Segments de clients",
  reports_customer_segments_note:
    "Répartit les clients actifs en trois groupes selon leur historique de réservations. La somme des trois correspond aux clients actifs.",
  reports_services_by_category: "Réservations par catégorie",
  reports_service_ranking_note:
    "Trié par nombre de réservations. Cliquez sur une colonne pour modifier le tri.",
  reports_mrr_trend: "Nouveaux abonnements",
  reports_subscription_usage: "Utilisation des abonnements",
  reports_subscription_usage_tooltip:
    "Vos abonnés utilisent-ils vraiment les réservations incluses dans leurs plans ?<br><br>• <b>Utilisation du quota de réservations</b> : si un plan comprend 10 réservations et qu’un client en a utilisé 3, cela fait 30 %. Il s’agit de la moyenne sur l’ensemble des abonnés.<br>• <b>Réservations non utilisées</b> : nombre total de réservations incluses que personne n’a utilisées. Un chiffre élevé signifie que vos abonnés passent à côté d’une partie de ce qu’ils ont payé.",
  stats_revenue: "Revenus",
  stats_bookings: "Réservations",
  stats_subscriptions: "Abonnements",
  stats_products: "Produits",
  stats_new_customers: "Nouveaux clients",
  stats_cancellation_rate: "Taux d’annulation",
  stats_avg_booking_value: "Valeur moy. par réservation",
  stats_total_revenue: "Revenus totaux",
  stats_from_bookings: "Réservations",
  stats_from_products: "Produits",
  stats_from_subscriptions: "Abonnements",
  stats_active_employees: "Employés actifs",
  stats_team_revenue: "Revenus de l’équipe",
  stats_schedule_fill_rate: "Taux de remplissage du planning",
  stats_total_booked_hours: "Total d’heures réservées",
  stats_total_bookings: "Total des réservations",
  stats_approved: "Acceptées",
  stats_done: "Terminées",
  stats_cancelled: "Annulées",
  stats_payment: "En attente de paiement",
  stats_status: "Statut",
  stats_service: "Service",
  stats_employee: "Employé",
  stats_delivery_type: "Type de réalisation",
  stats_share: "Part",
  stats_reason: "Motif",
  stats_cancellations: "Annulations",
  stats_category: "Catégorie",
  stats_location: "Lieu",
  stats_type: "Type",
  stats_provider: "Mode",
  stats_transactions: "Transactions",
  stats_value: "Total",
  stats_product: "Produit",
  stats_quantity: "Quantité",
  stats_subscription: "Abonnement",
  stats_customer: "Client",
  stats_email: "E-mail",
  stats_customers_served: "Clients pris en charge",
  stats_utilization: "Taux d’occupation",
  stats_available_hours: "Heures disponibles",
  stats_booked_hours: "Heures réservées",
  stats_unique_customers: "Clients uniques",
  stats_total_customers: "Total des clients",
  stats_active_customers: "Clients actifs",
  stats_returning_customers: "Clients récurrents",
  stats_retention_rate: "Taux de rétention",
  stats_customer_ltv: "Valeur client",
  stats_avg_days_between_visits: "Jours moy. entre réservations",
  stats_preferred_delivery: "Lieu préféré",
  stats_preferred_payment: "Paiement préféré",
  stats_total_spent: "Dépenses totales",
  stats_total_sold: "Total vendu",
  stats_product_revenue: "Revenus des produits",
  stats_active_subscriptions: "Abonnements actifs",
  stats_subscription_revenue: "Revenus des abonnements",
  stats_renewal_rate: "Taux de renouvellement",
  stats_active_users: "Utilisateurs actifs",
  stats_avg_utilization: "Utilisation du quota de réservations",
  stats_booking_limit_usage: "Utilisation du quota de réservations",
  stats_unused_booking_slots: "Réservations non utilisées",
  stats_unused_bookings: "Réservations non utilisées",
  stats_total_transactions: "Total des transactions",
  stats_total_value: "Valeur totale",
  stats_booking_payment_rate: "Taux de réservations payées",
  stats_method: "Mode",
  stats_day: "Jour",
  stats_hour: "Heure",
  stats_busiest_day: "Jour le plus actif",
  stats_busiest_hour: "Heure la plus active",
  stats_average_lead_time: "Jours d’anticipation (moy.)",
  stats_median_lead_time: "Jours d’anticipation (médiane)",
  stats_month: "Mois",
  stats_projected: "Prévision",
  stats_low_estimate: "Estimation basse",
  stats_high_estimate: "Estimation haute",
  stats_period: "Période",
  stats_count: "Nombre",
  stats_bookings_count: "Réservations",
  stats_name: "Nom",
  stats_cancellation_rate_tooltip:
    "À quelle fréquence les réservations sont annulées.<br><br><b>Calcul :</b> annulées ÷ (acceptées + terminées + annulées)<br><b>Exemple :</b> 10 réservations, 2 annulées = <b>20 %</b>",
  stats_customer_ltv_tooltip:
    "Montant total dépensé par un client chez vous, sur l’ensemble de son historique, pas seulement sur la période sélectionnée.",
  stats_utilization_tooltip:
    "Taux d’occupation moyen de votre équipe. Pour chaque employé : heures réservées ÷ heures disponibles.<br><br>Les <b>heures disponibles</b> proviennent du <b>Planning de disponibilité</b> de l’employé. Les jours de congé et les exceptions de dates sont pris en compte.<br><br>Exemple : un employé travaille du lundi au vendredi, de 9:00 à 17:00 (40 h/semaine). Si 30 heures sont réservées, l’occupation est de 75 %.",
  stats_booking_payment_rate_tooltip:
    "Pourcentage de réservations payées parmi toutes les réservations planifiées sur la période sélectionnée.<br><br>Comptées par date de service : une réservation créée aujourd’hui pour le mois de mai apparaît dans le rapport de mai.",
  stats_renewal_rate_tooltip:
    "Nombre d’abonnés ayant renouvelé leur plan après le premier paiement, signe de clients satisfaits.",
  stats_unused_booking_slots_tooltip:
    "Le nombre total de réservations que les abonnés auraient pu effectuer (selon les limites de leur plan), mais qu’ils n’ont pas faites.<br><br><b>Exemple :</b> 3 abonnés ont chacun un plan avec 10 réservations/mois. L’un en a utilisé 7, un autre 3, le dernier 0. Cela fait 3 + 7 + 10 = <b>20 réservations non utilisées</b>.<br><br>Un chiffre élevé peut signifier que vos limites sont trop généreuses ou que les abonnés ont besoin d’un rappel pour réserver.",
  stats_active_subscriptions_tooltip:
    "Nouveaux abonnements démarrés sur la période sélectionnée. Ce n’est <b>pas</b> le nombre total d’abonnés actifs.",
  stats_avg_utilization_tooltip:
    "Certains plans d’abonnement incluent un nombre défini de réservations (par exemple « 10 réservations par mois »). Ce chiffre montre quel pourcentage de ces réservations incluses vos abonnés ont réellement utilisé.<br><br><b>Exemple :</b> un client achète un plan avec 10 réservations/mois mais ne réserve que 3 fois → 30 % d’utilisation.<br><br>Un pourcentage faible signifie que les abonnés n’utilisent pas pleinement ce qu’ils ont payé. Seules les réservations acceptées et terminées sont comptées.",
  stats_new_customers_tooltip:
    "Nouveaux clients inscrits sur la période sélectionnée. Basé sur la date de création du compte.",
  stats_total_revenue_tooltip:
    "Revenus totaux sur la période sélectionnée provenant :<br>• des réservations<br>• des abonnements<br>• des ventes de produits<br><br>Seuls les <b>paiements finalisés</b> sont comptés, selon la date de paiement.",
  stats_from_bookings_tooltip:
    "Revenus des paiements de réservations sur la période sélectionnée. Seuls les <b>paiements finalisés</b> sont comptés.",
  stats_from_products_tooltip:
    "Revenus des achats ponctuels de produits sur la période sélectionnée.",
  stats_from_subscriptions_tooltip:
    "Revenus des paiements de plans d’abonnement sur la période sélectionnée.",
  stats_total_bookings_tooltip:
    "Total des réservations <b>acceptées</b> et <b>terminées</b> sur la période sélectionnée. Les réservations <b>annulées</b> et <b>en attente de paiement</b> ne sont pas comptées.",
  stats_approved_tooltip:
    "Nombre de réservations <b>acceptées</b> sur la période sélectionnée.",
  stats_done_tooltip:
    "Nombre de réservations <b>terminées</b> sur la période sélectionnée.",
  stats_cancelled_tooltip:
    "Réservations <b>annulées</b> sur la période sélectionnée, par le client ou par vous.",
  stats_active_employees_tooltip:
    "Membres de l’équipe ayant au moins une réservation acceptée ou terminée sur la période sélectionnée.",
  stats_team_revenue_tooltip:
    "Revenus totaux des réservations de toute l’équipe sur la période sélectionnée. Seuls les paiements finalisés sont comptés.",
  stats_schedule_fill_rate_tooltip:
    "Quelle part du temps disponible de votre équipe est remplie par des réservations.<br><br><b>Comment ça marche :</b><br>1. Pour chaque membre de l’équipe, nous parcourons chaque jour de la période sélectionnée<br>2. Pour chaque jour, nous vérifions son planning : les exceptions de dates (jours de congé, horaires spéciaux) priment sur le planning hebdomadaire<br>3. Nous additionnons les heures réservées (réservations acceptées et terminées)<br>4. Taux de remplissage = heures réservées ÷ heures disponibles<br>5. Nous faisons la moyenne sur tous les membres de l’équipe<br><br><b>Exemple :</b> Anna a 40 h disponibles, 20 h réservées → 50 %. Marc a 40 h disponibles, 30 h réservées → 75 %. Moyenne = <b>62,5 %</b><br><br>Les membres sans planning sont ignorés. Affiche « -- » si personne n’a de planning défini.",
  stats_total_booked_hours_tooltip:
    "Nombre total d’heures consacrées aux réservations par toute l’équipe sur la période sélectionnée.",
  stats_customers_served_tooltip:
    "Nombre de clients différents avec lesquels ce membre de l’équipe a travaillé sur la période sélectionnée.",
  stats_available_hours_tooltip:
    "Nombre d’heures que ce membre de l’équipe pouvait travailler sur la période sélectionnée, selon son planning.<br><br><b>Comment ça marche :</b> nous parcourons chaque jour de la période sélectionnée. Si une exception est définie pour ce jour (par exemple un jour de congé), elle s’applique. Sinon, le planning hebdomadaire habituel s’applique.<br><br><b>Exemple :</b> lun.–ven. 9:00–17:00. Période = du lundi au dimanche → 5 jours ouvrés × 8 h = <b>40 h</b>. Si le mercredi est marqué comme jour de congé, cela devient 4 × 8 h = <b>32 h</b>.<br><br>Affiche « -- » si aucun planning n’est défini.",
  stats_booked_hours_tooltip:
    "Heures de travail réellement remplies par des réservations sur la période sélectionnée.",
  stats_total_tooltip:
    "Nombre total de clients inscrits chez vous, depuis le début, pas seulement sur la période sélectionnée.",
  stats_new_tooltip:
    "Clients qui ont réservé pour la première fois sur la période sélectionnée : ils n’avaient aucune réservation auparavant.",
  stats_active_tooltip:
    "Clients ayant au moins une réservation <b>acceptée</b> ou <b>terminée</b> sur la période sélectionnée.",
  stats_returning_tooltip:
    "Clients qui avaient une réservation avant la période sélectionnée et qui sont revenus pendant celle-ci.",
  stats_ltv_tooltip:
    "Montant total moyen dépensé par un client depuis son inscription, sur l’ensemble de son historique, pas seulement sur la période sélectionnée.",
  stats_preferred_delivery_type_tooltip:
    "Le type de lieu le plus souvent réservé par vos clients, par exemple Google Meet, adresse, téléphone ou Microsoft Teams.",
  stats_total_customers_tooltip:
    "Nombre total de clients inscrits, depuis le début, pas seulement sur la période sélectionnée.",
  stats_preferred_payment_method_tooltip:
    "Le mode de paiement que vos clients utilisent le plus souvent pour payer leurs réservations.",
  stats_active_customers_tooltip:
    "Clients ayant au moins une réservation sur la période sélectionnée.",
  stats_returning_customers_tooltip:
    "Clients qui avaient des réservations avant la période sélectionnée et qui sont revenus pendant celle-ci. Avec <b>Depuis le début</b> sélectionné, ce chiffre sera 0.",
  stats_retention_rate_tooltip:
    "Quel pourcentage de clients actifs avait déjà réservé chez vous.<br><br><b>Calcul :</b> récurrents ÷ actifs × 100<br><b>Exemple :</b> 10 actifs, 6 récurrents = <b>60 %</b>",
  stats_avg_days_between_visits_tooltip:
    "Nombre moyen de jours entre les réservations des clients qui reviennent plus d’une fois.",
  stats_total_sold_tooltip:
    "Nombre de produits vendus sur la période sélectionnée.",
  stats_product_revenue_tooltip:
    "Revenus totaux des ventes de produits sur la période sélectionnée.",
  stats_subscription_revenue_tooltip:
    "Revenus totaux des paiements de plans d’abonnement sur la période sélectionnée.",
  stats_active_users_tooltip:
    "Abonnés ayant effectué au moins une réservation avec leur plan d’abonnement sur la période sélectionnée.",
  stats_total_value_tooltip:
    "Somme de toutes les transactions de paiement <b>finalisées</b> (réservations, produits et abonnements) sur la période sélectionnée.",
  stats_busiest_day_tooltip:
    "Le jour de la semaine avec le plus de réservations sur la période sélectionnée.",
  stats_busiest_hour_tooltip:
    "L’heure de la journée avec le plus de réservations sur la période sélectionnée.",
  stats_peak_times_tooltip:
    "Le jour et l’heure avec le plus de réservations <b>acceptées</b> et <b>terminées</b> sur la période sélectionnée.",
  stats_bookings_by_hour_tooltip:
    "Répartition des réservations selon les heures de la journée sur la période sélectionnée.",
  stats_bookings_by_service_tooltip:
    "Les services qui ont reçu le plus de réservations sur la période sélectionnée.",
  stats_bookings_by_employee_tooltip:
    "Les membres de l’équipe qui ont géré le plus de réservations sur la période sélectionnée.",
  stats_booking_lead_time_tooltip:
    "Avec quelle anticipation vos clients réservent : le nombre de jours entre la création de la réservation et sa date.",
  stats_bookings_by_location_tooltip:
    "Répartition des réservations entre vos lieux sur la période sélectionnée.",
  stats_average_lead_time_tooltip:
    "Le nombre moyen de jours entre la création d’une réservation et sa date.",
  stats_median_lead_time_tooltip:
    "Le nombre médian de jours entre la création d’une réservation et sa date. Moins sensible aux valeurs extrêmes que la moyenne.",
  stats_low_estimate_tooltip:
    "La fourchette basse de la prévision : vos résultats pourraient se situer à ce niveau si la prochaine période est plus calme que d’habitude.",
  stats_high_estimate_tooltip:
    "La fourchette haute de la prévision : le scénario optimiste pour la prochaine période.",
  stats_booking_status_tooltip:
    "Répartition de vos réservations par statut (<b>acceptées</b>, <b>terminées</b> et <b>annulées</b>) sur la période sélectionnée.",
  stats_avg_booking_value_tooltip:
    "Le montant moyen payé par réservation sur la période sélectionnée.<br><br><b>Calcul :</b> revenus des réservations ÷ nombre de réservations payées",
  stats_mrr_tooltip:
    "Revenus totaux des paiements de plans d’abonnement sur la période sélectionnée. Affiche la somme de toutes les transactions d’abonnement payées, pas un montant mensuel normalisé.",
  stats_top_clients_tooltip:
    "Les clients qui ont dépensé le plus sur la période sélectionnée, classés par revenus totaux.",
  stats_top_service_tooltip:
    "Le service avec le plus de réservations sur la période sélectionnée.",
  stats_bookings_timeline_tooltip:
    "Évolution du nombre de réservations sur la période sélectionnée. Inclut les réservations <b>acceptées</b> et <b>terminées</b>.<br><br><b>Prévision :</b> la ligne en pointillés couvre les périodes à venir : réservations déjà planifiées (<b>acceptées</b> ou <b>en attente de paiement</b>).",
  stats_peak_hours_heatmap_tooltip:
    "Carte thermique montrant quand ont lieu la plupart des réservations, par jour de la semaine et heure de la journée. Cellules plus foncées = plus de réservations.",
  stats_booking_revenue_tooltip:
    "Revenus des seuls paiements de réservations sur la période sélectionnée, hors ventes de produits et abonnements.",
  stats_total_transactions_tooltip:
    "Nombre total de transactions de paiement traitées sur la période sélectionnée, toutes sources confondues.",
  stats_revenue_timeline_tooltip:
    "Revenus détaillés par source : réservations, abonnements et produits. Seuls les paiements finalisés sont comptés, selon la date de paiement. Cliquez sur les éléments de la légende pour afficher ou masquer les lignes.<br><br><b>Prévision</b> : les lignes en pointillés montrent les revenus projetés, issus des réservations déjà payées ou en attente de paiement, plus les revenus estimés des abonnements actifs.",
  stats_revenue_top_services_table_tooltip:
    "Services classés par revenus sur la période sélectionnée.",
  stats_revenue_top_products_table_tooltip:
    "Produits classés par revenus sur la période sélectionnée.",
  stats_payment_providers_chart_tooltip:
    "Nombre de transactions <b>finalisées</b> par mode de paiement (par exemple Stripe, espèces, carte) sur la période sélectionnée.",
  stats_payment_methods_count_chart_tooltip:
    "Nombre de transactions traitées via chaque mode de paiement sur la période sélectionnée.",
  stats_payment_methods_value_chart_tooltip:
    "Revenus totaux encaissés via chaque mode de paiement sur la période sélectionnée.",
  stats_booking_status_chart_tooltip:
    "Réservations par statut (<b>acceptées</b>, <b>terminées</b>, <b>annulées</b> et <b>en attente de paiement</b>) sur la période sélectionnée.",
  stats_cancellation_reasons_chart_tooltip:
    "Les motifs d’annulation les plus fréquents sur la période sélectionnée.",
  stats_busiest_day_chart_tooltip:
    "Les jours de la semaine avec le plus de réservations sur la période sélectionnée.",
  stats_delivery_type_chart_tooltip:
    "Répartition des réservations par type de lieu (sur place, en ligne, par téléphone, etc.) sur la période sélectionnée.",
  stats_customer_segments_chart_tooltip:
    "Le niveau d’engagement de vos clients actifs sur la période sélectionnée :<br>• <b>Première visite</b> : première réservation, aucun historique<br>• <b>De retour</b> : avaient déjà réservé, une visite sur cette période<br>• <b>Fidèles</b> : avaient déjà réservé et sont venus 2 fois ou plus sur cette période",
  stats_top_customers_table_tooltip:
    "Total dépensé sur la période sélectionnée : inclut tous les paiements du client (réservations, abonnements et produits).",
  stats_employee_table_tooltip:
    "Vue d’ensemble des performances de chaque membre de l’équipe : réservations, heures et occupation sur la période sélectionnée.",
  stats_service_table_tooltip:
    "Vue d’ensemble des performances de chaque service : réservations et revenus sur la période sélectionnée.",
  stats_services_by_category_tooltip:
    "Nombre de réservations acceptées et terminées par catégorie de services sur la période sélectionnée.",
  stats_booking_revenue_timeline_tooltip:
    "Évolution des revenus de réservations sur la période sélectionnée.",
  stats_subscription_revenue_timeline_tooltip:
    "Évolution des revenus d’abonnements sur la période sélectionnée.",
  stats_product_revenue_timeline_tooltip:
    "Évolution des revenus de produits sur la période sélectionnée.",
  stats_subscription_timeline_tooltip:
    "Nombre de nouveaux abonnements démarrés par période.",
  stats_top_subscriptions_table_tooltip:
    "Plans d’abonnement classés par revenus sur la période sélectionnée.",
  stats_top_products_table_tooltip:
    "Produits classés par revenus sur la période sélectionnée.",
  stats_not_assigned: "Non attribué",
  stats_low: "Faible",
  stats_medium: "Moyenne",
  stats_high: "Élevée",
  stats_insufficient: "Données insuffisantes",
  stats_type_name: "Type de lieu",
  stats_new_subscriptions: "Nouveaux abonnements",
  stats_new: "Nouveaux",
  stats_returning: "Récurrents",
  stats_first_time: "Première visite",
  stats_first_time_tooltip:
    "Clients sans réservation avant la période sélectionnée : c’est leur première visite.",
  stats_came_back: "De retour",
  stats_came_back_tooltip:
    "Clients qui avaient déjà réservé avant la période sélectionnée et qui ont réservé une fois pendant celle-ci.",
  stats_loyal: "Fidèles",
  stats_loyal_tooltip:
    "Clients qui avaient déjà réservé avant la période sélectionnée et qui ont réservé 2 fois ou plus pendant celle-ci.",
  stats_staff: "Employé",
  stats_payment_timeout: "Paiement expiré",
  stats_calendar_sync: "Synchronisation du calendrier",
  stats_in_person: "Adresse",
  stats_phone: "Téléphone",
  stats_other: "Autre",
  stats_stripe: "Stripe",
  stats_cash: "Espèces",
  stats_card: "Carte",
  stats_transfer: "Virement",
  stats_google_meet: "Google Meet",
  stats_zoom: "Zoom",
  stats_microsoft_teams: "Microsoft Teams",
  stats_skype: "Skype",
  stats_whatsapp: "WhatsApp",
  stats_client: "Client",
  stats_no_payment: "Paiement expiré",
  stats_external: "Synchronisation du calendrier",
  bulk_operation_progress: "Traitement : @{done} sur @{total}",
  bulk_operation_counting: "Comptage des enregistrements...",
  bulk_action_delete_events: "Suppression des événements",
  bulk_action_delete_users: "Suppression des utilisateurs",
  bulk_action_update_users: "Mise à jour des utilisateurs",
  bulk_action_export_users: "Exportation des utilisateurs",
  bulk_action_add_to_group: "Ajout aux groupes",
  bulk_action_remove_from_group: "Retrait des groupes",
  bulk_action_send_notification: "Envoi des notifications",
  bulk_action_update_bookings: "Mise à jour des réservations",
  bulk_action_export_events: "Exportation des événements",
  bulk_action_export_unavailable_booking_slots:
    "Exportation des dates bloquées",
  bulk_action_update_employees: "Mise à jour des employés",
  bulk_action_delete_employees: "Suppression des employés",
  bulk_action_delete_resources: "Suppression des ressources",
  bulk_action_delete_tags: "Suppression des étiquettes",
  bulk_action_delete_groups: "Suppression des groupes",
  bulk_action_delete_locations: "Suppression des lieux",
  bulk_action_delete_availability_schedules:
    "Suppression des plannings de disponibilité",
  bulk_action_delete_subscriptions: "Suppression des abonnements",
  bulk_action_delete_store_products: "Suppression des produits",
  bulk_action_delete_store_transactions: "Suppression des transactions",
  bulk_action_delete_user_subscriptions: "Suppression des abonnements clients",
  bulk_action_cancel_user_subscriptions: "Résiliation des abonnements clients",
  bulk_action_delete_newsletter: "Suppression des adresses de la newsletter",
  bulk_action_export_newsletter: "Export de la newsletter",
  bulk_action_delete_websites: "Suppression des sites web",
  bulk_action_disable_websites: "Désactivation des sites web",
  bulk_action_delete_mobile_apps: "Suppression des applications mobiles",
  bulk_action_export_employees: "Exportation des employés",
  bulk_notification_sending: "Envoi des notifications...",
  bulk_export_generating: "Génération du fichier...",
  bulk_export_sent_to_email: "Fichier envoyé à votre adresse e-mail",
  bulk_export_sent_to_email_with_errors:
    "Fichier envoyé à votre adresse e-mail. Traités : @{processed}, échecs : @{failed}.",
  download_csv: "Télécharger le CSV",
  selection_all_on_page:
    "Les @{amount} enregistrements de cette page sont sélectionnés.",
  selection_select_all_records:
    "Sélectionner les @{total} enregistrements de toutes les pages",
  selection_all_records_selected:
    "Les @{total} enregistrements de toutes les pages sont sélectionnés.",
  your_overview: "Votre vue d’ensemble",
  add_widget: "Ajouter un widget",
  widget_group_revenue: "Revenus",
  widget_group_bookings: "Réservations",
  widget_group_clients: "Clients",
  widget_group_team: "Mon équipe",
  widget_group_subscriptions: "Abonnements",
  widget_group_products: "Produits",
  widget_revenue_kpi: "Revenus",
  widget_bookings_kpi: "Réservations",
  widget_new_clients_kpi: "Nouveaux clients",
  widget_cancellation_rate: "Taux d’annulation",
  widget_top_clients: "Meilleurs clients",
  widget_peak_hours_heatmap: "Heures de pointe",
  widget_avg_booking_value: "Valeur moy. par réservation",
  widget_payment_method: "Mode de paiement préféré",
  widget_bookings_timeline: "Évolution des réservations",
  widget_booking_status: "Statut des réservations",
  widget_busiest_day: "Jour le plus actif",
  widget_busiest_hour: "Heure la plus active",
  widget_avg_lead_time: "Anticipation moyenne",
  widget_active_clients: "Clients actifs",
  widget_retention_rate: "Taux de rétention",
  widget_employee_utilization: "Occupation du planning",
  widget_top_service: "Meilleur service",
  widget_active_subscriptions: "Abonnements actifs",
  widget_mrr: "Revenus des abonnements",
  widget_product_revenue: "Revenus des produits",
  widget_booking_revenue: "Revenus de réservations",
  widget_total_transactions: "Total des transactions",
  widget_payment_conversion: "Taux de réservations payées",
  widget_revenue_timeline: "Évolution des revenus",
  widget_revenue_top_services_table: "Top services par revenus",
  widget_revenue_top_products_table: "Top produits par revenus",
  widget_payment_providers_chart: "Modes de paiement",
  widget_booking_status_chart: "Répartition des réservations par statut",
  widget_cancellation_reasons_chart: "Motifs d’annulation",
  widget_busiest_day_chart: "Réservations par jour de la semaine",
  widget_delivery_type_chart: "Répartition par mode de réalisation",
  widget_customer_segments_chart: "Segments de clients",
  widget_top_customers_table: "Top clients (tableau complet)",
  widget_employee_table: "Performance des employés",
  widget_service_table: "Performance des services",
  widget_subscription_timeline: "Évolution des nouveaux abonnements",
  widget_subscription_revenue_timeline: "Évolution des revenus des abonnements",
  widget_top_subscriptions_table: "Top plans d’abonnement",
  widget_product_revenue_timeline: "Évolution des revenus de produits",
  widget_top_products_table: "Top produits",
  widget_booking_revenue_timeline: "Évolution des revenus des réservations",
  widget_bookings_by_service_table: "Réservations par service",
  widget_bookings_by_employee_table: "Membres de l’équipe les plus actifs",
  widget_bookings_by_hour_chart: "Réservations par heure",
  widget_locations_table: "Réservations par lieu",
  widget_total_clients: "Nombre total de clients",
  widget_customer_ltv: "Valeur vie client (LTV)",
  widget_returning_clients: "Clients récurrents",
  widget_avg_days_between_visits: "Délai moyen entre les visites (jours)",
  widget_first_time_clients: "Nouveaux clients (première visite)",
  widget_loyal_clients: "Clients fidèles",
  widget_services_by_category_chart: "Réservations par catégorie",
  widget_renewal_rate: "Taux de renouvellement",
  widget_subscription_utilization: "Utilisation des abonnements",
  widget_unused_booking_slots: "Créneaux non utilisés",
  widget_total_products_sold: "Produits vendus",
  restore_defaults: "Rétablir les valeurs par défaut",
  restore_defaults_warning:
    "Votre tableau de bord sera réinitialisé avec les widgets par défaut. Votre disposition actuelle sera perdue.",
  drag_to_reorder: "Faites glisser pour réorganiser",
  tooltip_add_widget: "Ajouter un nouveau widget à votre tableau de bord",
  tooltip_edit_layout: "Réorganiser ou supprimer des widgets",
  tooltip_restore_defaults: "Rétablir la disposition par défaut des widgets",
  tooltip_save_layout: "Enregistrer la disposition actuelle des widgets",
  tooltip_remove_widget: "Supprimer ce widget",
  add_more_widgets: "Ajouter d’autres widgets",
  all_time: "Depuis le début",
  remove_from_group: "Supprimer du groupe",
  change_status_to_approved: "Marquer comme acceptée",
  change_status_to_payment: "Marquer comme en attente de paiement",
  change_status_to_cancelled: "Marquer comme annulée",
  change_status_to_done: "Marquer comme terminée",
  bulk_operation_already_active:
    "Vous avez déjà une opération groupée en cours. Attendez qu’elle se termine.",
  go_to_fakturownia: "Accéder aux paramètres @{invoicing}",
  invoice_no_integration_tooltip:
    "Facturation activée, mais l’intégration @{invoicing} n’est pas active",
  affiliate: "Programme de parrainage",
  affiliate_page_title: "Programme de parrainage",
  affiliate_join_title: "Rejoignez le programme de parrainage",
  affiliate_join_description:
    "Partagez votre lien unique et gagnez une récompense pour chaque nouveau client qui s’abonne à Calendesk.",
  affiliate_accept_terms: "J’accepte le règlement du programme de parrainage",
  affiliate_terms_link_text: "Lire le règlement",
  affiliate_join_button: "Rejoindre le programme",
  affiliate_balance_title: "Solde de parrainage",
  affiliate_link_title: "Votre lien de parrainage",
  affiliate_link_description:
    "Partagez ce lien pour parrainer de nouveaux clients et commencer à gagner.",
  affiliate_copy_link: "Copier le lien",
  affiliate_link_copied: "Le lien a été copié dans le presse-papiers.",
  affiliate_request_payout: "Demander un versement",
  affiliate_payout_method_title: "Choisissez un mode de versement",
  affiliate_payout_balance_credit: "Avoir sur l’abonnement",
  affiliate_payout_balance_credit_description:
    "Utilisez vos gains comme avoir pour réduire le coût de votre abonnement.",
  affiliate_payout_bank_transfer: "Virement bancaire",
  affiliate_payout_bank_transfer_info:
    "Pour recevoir un virement bancaire (min. {minAmount} net), envoyez une facture à support@calendesk.com après avoir soumis votre demande.",
  affiliate_payout_bank_transfer_below_min:
    "Le virement bancaire nécessite au moins {minAmount}. Gagnez encore un peu ou utilisez l’option d’avoir sur l’abonnement.",
  affiliate_payout_confirm: "Confirmer le versement",
  affiliate_payout_success: "Votre demande de versement a été envoyée.",
  affiliate_join_success: "Vous avez rejoint le programme de parrainage.",
  affiliate_no_referrals:
    "Aucun parrainage pour le moment. Partagez votre lien pour commencer à gagner.",
  affiliate_no_payouts: "Aucune transaction pour le moment.",
  affiliate_referrals_title: "Parrainages",
  affiliate_payouts_title: "Historique des transactions",
  affiliate_status_pending: "En attente",
  affiliate_status_rewarded: "Récompensé",
  affiliate_status_rejected: "Refusé",
  affiliate_status_approved: "Accepté",
  affiliate_status_completed: "Terminé",
  affiliate_payout_method_balance: "Avoir sur l’abonnement",
  affiliate_payout_method_bank: "Virement bancaire",
  affiliate_payout_method_adjustment: "Ajustement de solde",
  affiliate_welcome_bonus_banner:
    "Vous avez un bonus de bienvenue : {amount} de réduction sur votre premier abonnement.",
  affiliate_welcome_bonus_applied: "Bonus de bienvenue : -{amount}",
  affiliate_welcome_bonus_plan_note: "-{amount} sur votre premier paiement",
  first_payment: "Premier paiement",
  affiliate_welcome_bonus_dashboard_title: "Un bonus de bienvenue vous attend",
  affiliate_welcome_bonus_dashboard_description:
    "Profitez de {amount} de réduction sur votre premier abonnement Calendesk.",
  affiliate_welcome_bonus_dashboard_cta: "Choisir un plan",
  affiliate_column_tenant: "Client",
  affiliate_column_registered: "Inscription",
  affiliate_column_subscribed: "Abonnement",
  affiliate_column_status: "Statut",
  affiliate_column_reward: "Récompense",
  affiliate_column_date: "Date",
  affiliate_column_amount: "Montant",
  affiliate_column_method: "Type",
  affiliate_column_note: "Motif",
  affiliate_modal_headline: "Gagnez de l’argent en recommandant Calendesk",
  affiliate_modal_cta_dismiss: "Peut-être plus tard",
  affiliate_accept_terms_with_link_prefix: "J’accepte le",
  affiliate_accept_terms_with_link_anchor:
    "règlement du programme de parrainage",
  affiliate_total_earned: "Total gagné",
  affiliate_total_paid: "Total versé",
  affiliate_hero_badge_new: "NOUVEAU",
  affiliate_hero_badge_label: "Programme de parrainage pour votre entreprise",
  affiliate_hero_headline_main: "Partagez votre lien. Gagnez sur chaque",
  affiliate_hero_headline_accent: "réservation.",
  affiliate_hero_subhead:
    "Chaque nouveau client que vous amenez vous rapporte une commission, versée automatiquement. Suivez tout en direct dans votre espace Calendesk.",
  affiliate_hero_cta_primary: "Rejoindre le programme",
  affiliate_hero_cta_secondary: "Voir le règlement",
  affiliate_hero_headline:
    "Recommandez Calendesk : 50 PLN pour vous et 50 PLN pour la nouvelle entreprise !",
  affiliate_hero_lead:
    "Acceptez le règlement, rejoignez le programme et récupérez votre lien de parrainage. Pour chaque client qui crée un compte Calendesk et paie un abonnement, vous recevez une récompense. L’entreprise parrainée y gagne aussi : elle reçoit un bonus de bienvenue.",
  affiliate_hero_fine_print:
    "Le programme se déroule du 01.04.2026 au 31.03.2028. Plafond de 2 000 PLN brut pour les participants sans entreprise enregistrée. Versements en PLN, USD, EUR ou GBP.",
  affiliate_reward_you_label: "Vous recevez",
  affiliate_reward_you_amount: "50 PLN",
  affiliate_reward_you_suffix: "net",
  affiliate_reward_you_note: "pour chaque nouvelle entreprise sur Calendesk",
  affiliate_reward_new_label: "La nouvelle entreprise reçoit",
  affiliate_reward_new_amount: "50 PLN",
  affiliate_reward_new_suffix: "net",
  affiliate_reward_new_note: "code de réduction sur l’abonnement Calendesk",
  affiliate_preview_copy: "Copier",
  affiliate_preview_saldo_label: "Solde · ce mois-ci",
  affiliate_preview_delta: "+7 parrainages",
  affiliate_preview_last_reward_title: "Dernière récompense",
  affiliate_preview_paid_out: "Versée",
  affiliate_preview_recent_title: "Parrainages récents",
  affiliate_preview_recent_count: "7 ce mois-ci",
  affiliate_preview_col_business: "Entreprise",
  affiliate_preview_col_reward: "Récompense",
  affiliate_preview_col_status: "Statut",
  affiliate_preview_status_reward: "RÉCOMPENSE",
  affiliate_preview_status_30days: "30 JOURS",
  affiliate_hero_preview_link_title: "Votre lien de parrainage",
  affiliate_hero_preview_link_description:
    "Partagez-le avec vos clients et vos amis. La commission est pour vous.",
  affiliate_hero_preview_this_month: "Ce mois-ci",
  affiliate_hero_preview_trend: "+34 % vs mois dernier",
  affiliate_hero_preview_recent_title: "Parrainages récents",
  affiliate_hero_preview_recent_count: "12 ce mois-ci",
  affiliate_hero_sample_data:
    "Données d’exemple. Vos chiffres réels apparaîtront après votre adhésion.",
  affiliate_hero_preview_label: "Aperçu",
  affiliate_announcement_title: "50 PLN pour vous, 50 PLN pour vos amis !",
  affiliate_announcement_description:
    "Partagez votre lien. Quand une nouvelle entreprise paie un abonnement, vous recevez chacun 50 PLN.",
  affiliate_announcement_description_2:
    "Encaissez votre récompense par virement bancaire ou utilisez-la pour payer votre propre compte Calendesk.",
  affiliate_announcement_cta_learn_more: "En savoir plus",
  affiliate_announcement_cta_dismiss: "Peut-être plus tard",
  affiliate_hero_benefit_1:
    "Gagnez sur chaque nouvel abonnement. Parrainages illimités*",
  affiliate_hero_benefit_2:
    "L’entreprise parrainée reçoit un code de réduction sur son abonnement",
  affiliate_hero_benefit_3:
    "Suivi des parrainages en direct dans votre espace Calendesk",
  affiliate_suspended_title: "Votre programme de parrainage est suspendu",
  affiliate_suspended_message:
    "Les nouveaux versements sont en pause et l’équipe Calendesk vérifie votre compte. Contactez le support si vous avez des questions.",
  affiliate_rejection_cancelled_before_30d:
    "Le client parrainé a résilié avant la fin de la période de qualification de 30 jours.",
  affiliate_rejection_duplicate_tenant:
    "Le client parrainé avait déjà un compte dans notre système.",
  affiliate_rejection_fraud:
    "Parrainage signalé comme non autorisé ou frauduleux.",
  affiliate_rejection_lifetime_cap_exceeded:
    "Votre programme a atteint le plafond de gains autorisé.",
  affiliate_rejection_note_label: "Note du support :",
  affiliate_leave_program: "Quitter le programme de parrainage",
  affiliate_leave_dialog_title: "Quitter le programme de parrainage ?",
  affiliate_leave_dialog_warning:
    "Vous ne recevrez plus de nouvelles récompenses et votre lien de parrainage cessera de fonctionner.",
  affiliate_leave_dialog_rejoin_hint:
    "Vous pouvez revenir à tout moment. Votre code et votre historique sont conservés.",
  affiliate_leave_dialog_confirm: "Quitter le programme",
  affiliate_leave_success: "Vous avez quitté le programme de parrainage.",
  affiliate_preview_copy_locked:
    "Acceptez le règlement et rejoignez le programme pour générer votre lien.",
  affiliate_code_title: "Votre code de parrainage",
  affiliate_code_description:
    "Vos clients peuvent saisir ce code lors de l’achat de leur premier abonnement.",
  affiliate_copy_code: "Copier le code",
  affiliate_code_copied: "Le code a été copié dans le presse-papiers.",
  affiliate_terms_title: "Vos conditions",
  affiliate_terms_description:
    "Conditions individuelles convenues avec Calendesk. Elles priment sur les conditions standard du programme.",
  affiliate_terms_reward_monthly: "Récompense par client avec un plan mensuel",
  affiliate_terms_reward_yearly: "Récompense par client avec un plan annuel",
  affiliate_terms_amount_net: "{amount} net",
  affiliate_terms_percent_yearly:
    "{percent} % de ce que le client paie HT pour la première année",
  affiliate_terms_percent_monthly:
    "{percent} % de ce que le client paie HT pour les 3 premiers mois",
  affiliate_terms_discount: "Réduction pour le client",
  affiliate_terms_discount_value:
    "{amount} sur le premier paiement de l’abonnement",
  affiliate_terms_qualification: "Période de qualification",
  affiliate_terms_qualification_value:
    "{days} jours à compter du premier paiement du client",
  affiliate_terms_payout: "Versement",
  affiliate_terms_payout_value:
    "À partir de {amount} net, par virement sur présentation de votre facture",
  affiliate_terms_own_tax_id:
    "Le client achète l’abonnement avec ses propres données et son propre numéro fiscal. Un compte payé avec votre numéro fiscal, ou avec un numéro fiscal qui a déjà payé, ne donne droit à aucune récompense.",
  affiliate_contact_title: "Votre contact chez Calendesk",
  affiliate_contact_description:
    "Une question sur vos conditions, vos clients ou vos versements ? Écrivez à votre contact.",
  affiliate_column_plan: "Plan",
  affiliate_column_source: "Origine",
  affiliate_column_qualifies_at: "Qualification le",
  affiliate_plan_month: "Mensuel",
  affiliate_plan_year: "Annuel",
  affiliate_source_link: "Lien",
  affiliate_source_code: "Code",
  affiliate_source_admin: "Ajouté par Calendesk",
  affiliate_rejection_cancelled_before_qualification:
    "Le client parrainé a résilié avant la fin de la période de qualification.",
  affiliate_rejection_refunded:
    "Le paiement du client parrainé a été remboursé.",
  affiliate_rejection_not_covered_by_payments:
    "Les paiements nets du client pendant la période de qualification sont inférieurs à la récompense.",
  affiliate_rejection_returning_customer:
    "Le client a déjà payé Calendesk auparavant (même adresse e-mail ou même numéro fiscal).",
  affiliate_rejection_partner_account:
    "Le compte appartient à un partenaire Calendesk ou a été payé avec votre numéro fiscal.",
  fakturownia_department_id_title: "ID du département",
  fakturownia_department_id_hint:
    "Laissez vide pour utiliser le département par défaut.",
  fakturownia_department_id_description:
    "ID numérique du département @{invoicing} qui doit émettre les factures depuis Calendesk. Chaque département peut avoir ses propres données de vendeur et ses propres mentions par défaut : utile quand un même compte @{invoicing} gère plusieurs canaux de vente (par ex. Shopify + Calendesk).",
  fakturownia_additional_settings_title: "Paramètres supplémentaires",
  fakturownia_additional_settings_subtitle:
    "Ces champs sont facultatifs et ne sont pas nécessaires pour une intégration standard. Remplissez-les uniquement si vous voulez personnaliser l’émission des factures.",
  fakturownia_credentials_error:
    "Impossible de se connecter à @{invoicing} avec ces identifiants. Vérifiez le jeton API et l’URL du compte.",
  fakturownia_department_id_single_hint:
    "Votre compte @{invoicing} ne possède qu’un seul département. Créez un autre département dans @{invoicing} pour y diriger les factures séparément.",
  fakturownia_department_id_no_results:
    "Aucun département trouvé sur ce compte @{invoicing}.",
  google_calendar_auth_error:
    "Google Calendar n’a pas pu être connecté, car l’accès a été refusé ou toutes les autorisations requises n’ont pas été accordées. Réessayez et autorisez l’accès à votre calendrier.",
  outlook_calendar_auth_error:
    "Le calendrier Outlook n’a pas pu être connecté, car l’accès a été refusé ou toutes les autorisations requises n’ont pas été accordées. Réessayez et autorisez l’accès à votre calendrier.",
  gov_status_demo_ok: "Démo (acceptée)",
  availability_status: "Statut",
  availability_period: "Période",
  availability_status_active: "Actif",
  availability_status_active_tooltip:
    "Ce planning est actuellement actif et appliqué à au moins un employé ou un service.",
  availability_status_planned: "À venir",
  availability_status_planned_tooltip:
    "Ce planning deviendra actif à une date future, en fonction de sa période d’affectation.",
  availability_status_inactive: "Inactif",
  availability_status_inactive_tooltip:
    "Ce planning a été actif par le passé, mais sa période d’affectation est déjà terminée.",
  availability_status_unassigned: "Non affecté",
  availability_status_unassigned_tooltip:
    "Ce planning n’est affecté à aucun employé ni à aucun service.",
  availability_period_none: "–",
  availability_period_indefinite: "Sans limite",
  availability_period_various: "Périodes multiples",
  availability_period_no_start: "Depuis toujours",
  availability_period_no_end: "Sans limite",
  availability_period_assigned_to: "Affecté à",
  edit_schedule: "Modifier le planning",
  services_and_categories: "Services et catégories",
  included_in_selected_category: "Inclus dans la catégorie sélectionnée",
  availability_schedule_color: "Couleur du planning",
  availability_schedule_color_tooltip:
    "La couleur du planning dans l’aperçu des disponibilités. Définissez-la pour distinguer les plannings lorsqu’un employé ou un service en a plusieurs.",
  employee_color_tooltip:
    "Cette couleur marque les réservations de l’employé dans le calendrier. Définissez-la pour repérer d’un coup d’œil à qui appartient chaque réservation.",
  availability_period_from: "Date de début",
  availability_period_to: "Date de fin",
  availability_period_no_end_date: "Sans date de fin",
  availability_period_no_start_date: "Sans date de début",
  availability_period_days: "@{count} jours",
  availability_period_day_one: "1 jour",
  availability_assign_type_locked:
    "Ce planning est déjà affecté à des employés ou à des services. Impossible de combiner les deux types dans un même planning.",
  availability_overlap_title: "Périodes qui se chevauchent",
  availability_schedules: "Plannings de disponibilité",
  availability_calendar_preview: "Aperçu des plannings",
  availability_calendar_select_target:
    "Sélectionnez un employé ou un service pour afficher l’aperçu.",
  availability_calendar_no_schedule: "Aucun planning",
  availability_calendar_day_off: "Jour de repos",
  availability_exception_hours_prefilled:
    "Heures copiées depuis votre planning standard pour ce jour de la semaine. Vous pouvez les ajuster uniquement pour cette exception.",
  availability_schedule_created:
    "Le planning a été créé. Affectez-le à des employés ou à des services pour que les clients puissent réserver.",
  availability_exception_day_off:
    "Jour de repos selon la semaine standard. Ajoutez des heures pour rendre ce jour disponible.",
  availability_calendar_show_for: "Afficher la disponibilité pour",
  availability_preview_info:
    "L’aperçu montre quel planning s’applique chaque jour et quelles heures en résultent. Les créneaux réservables par les clients se trouvent dans le calendrier des réservations.",
  availability_view_team: "Planning d’équipe",
  availability_view_year: "Année",
  availability_view_month: "Mois",
  availability_test_info:
    "Testez la disponibilité telle que les clients la voient : choisissez un lieu, un service et un employé. Les créneaux libres proviennent du même moteur de réservation que votre page de réservation.",
  availability_test_location_online: "En ligne",
  availability_test_location_phone: "Téléphone",
  availability_test_no_location: "Sans lieu",
  availability_test_any_employee: "N’importe quel employé",
  availability_test_variant: "Option",
  availability_view_day: "Jour",
  availability_view_week: "Semaine",
  availability_test_morning: "Matin",
  availability_test_afternoon: "Après-midi",
  availability_test_evening: "Soir",
  availability_test_free_slots: "créneaux libres",
  availability_test_available_employees: "employés disponibles",
  availability_test_first_slot: "prochain créneau",
  availability_test_no_slots: "Aucun créneau",
  availability_test_none_short: "Aucun",
  availability_test_pick_service:
    "Choisissez un service pour tester la disponibilité",
  availability_test_unbookable:
    "Les clients ne verront aucun créneau ici. Vérifiez le planning de cet employé dans l’onglet Aperçu des plannings, ou ses heures de travail.",
  availability_test_week_hint:
    "Une ligne entière sans créneaux signifie que l’employé n’est réservable à aucun moment de la semaine.",
  availability_test_past_period:
    "Impossible de réserver dans le passé. Choisissez aujourd’hui ou une date ultérieure.",
  availability_test_past_day: "Passé",
  availability_preview_profile_hours_info:
    "Cet employé n’a aucun planning affecté. Les heures de travail définies dans son profil s’appliquent (l’ancienne version du planning de travail).",
  availability_preview_profile_hours_short: "Heures de travail du profil",
  availability_preview_service_fallback_info:
    "Ce service n’a pas de planning propre. Les créneaux disponibles proviennent des plannings des employés qui le proposent.",
  availability_preview_service_fallback_short: "Plannings des employés",
  previous_month: "Mois précédent",
  next_month: "Mois suivant",
  availability_calendar_no_availability_hint:
    "Ce jour est en dehors du planning. Les clients ne verront aucun créneau disponible.",
  availability_period_title: "Période de validité",
  availability_period_dialog_info:
    "Définissez la période pendant laquelle le planning s’applique à cette affectation. Pour un même employé ou un même service, les périodes des plannings ne peuvent pas se chevaucher.",
  availability_set_period: "Définir la période de validité",
  availability_timeline_caption_single:
    "Chronologie des plannings de cette affectation (@{year})",
  availability_timeline_caption_multi_employees:
    "Chronologie pour @{count} employés sélectionnés (@{year})",
  availability_timeline_caption_multi_services:
    "Chronologie pour @{count} services sélectionnés (@{year})",
  availability_overlap_days: "Jours qui se chevauchent",
  availability_today_short: "aujourd’hui",
  availability_schedule_label: "Planning",
  availability_overlap_conflict_target:
    "« @{target} » a déjà le planning « @{name} » sur cette période (@{from} – @{to}).",
  availability_overlap_resolve_hint:
    "Modifiez cette période ou raccourcissez les périodes des plannings ci-dessus pour enregistrer vos modifications.",
  copy_suffix: "(copie)",
  availability_schedule_duplicated: "Le planning a été dupliqué",
  availability_unassign_employees_first:
    "Annulez d’abord l’affectation des employés",
  availability_unassign_services_first:
    "Annulez d’abord l’affectation des services",
  availability_schedule_timezone_differs_info:
    "Les heures de ce planning utilisent le fuseau horaire @{timezone}, différent du vôtre (@{user_timezone}). Par exemple, 09:00 dans ce planning correspond à @{example} pour vous.",
  availability_timezone_previous_day: "la veille",
  availability_timezone_next_day: "le lendemain",
  availability_timezone_differs_tooltip:
    "Ce planning utilise un fuseau horaire différent du vôtre (@{timezone}).",
  employee_working_hours_timezone_info:
    "Ces heures utilisent le fuseau horaire de votre entreprise (@{timezone}), différent du vôtre (@{user_timezone}).",
  color_group_pastel: "Pastel",
  color_group_solid: "Couleurs vives",
  wb_settings_group_website: "Site web et SEO",
  wb_settings_group_booking: "Réservations",
  wb_settings_group_client_account: "Compte client",
  wb_settings_group_header_footer: "En-tête et pied de page",
  wb_settings_group_advanced: "Intégrations et paramètres avancés",
  wb_settings_filter: "Rechercher un paramètre",
  wb_settings_filter_empty: "Aucun paramètre ne correspond à votre recherche.",
  wb_hide_booking_prices: "Masquer les prix dans les réservations des clients",
  wb_hide_booking_prices_tooltip:
    "Une fois connectés, les clients ne voient pas les prix dans la liste de leurs réservations.",
  wb_hide_payments: "Masquer la section paiements dans le compte client",
  wb_hide_payments_tooltip:
    "Les clients connectés ne verront ni l’onglet paiements, ni leur historique de transactions, ni la section de la carte enregistrée.",
  wb_hide_profile_billing_data:
    "Masquer les données de facturation dans le compte client",
  wb_hide_profile_billing_data_tooltip:
    "Les clients ne peuvent pas renseigner leurs données de facturation dans les paramètres de leur compte. Les formulaires d’inscription et de réservation restent inchangés.",
  wb_hide_profile_photo_upload: "Désactiver le changement de photo de profil",
  wb_hide_profile_photo_upload_tooltip:
    "Les clients ne peuvent pas ajouter leur propre photo de profil dans leur compte.",
  wb_favicon_url_tooltip:
    "L’icône affichée sur l’onglet du navigateur. Copiez l’URL depuis la galerie de photos : cliquez sur l’aperçu d’une image, son adresse s’affiche en bas.",
  wb_og_image_url_tooltip:
    "L’image affichée quand quelqu’un partage un lien vers votre site, par exemple sur Facebook (og:image). Copiez l’URL depuis la galerie de photos : cliquez sur l’aperçu d’une image, son adresse s’affiche en bas.",
  wb_newsletter_success_url_tooltip:
    "L’adresse vers laquelle le client est redirigé après son inscription à la newsletter. Laissez le champ vide pour qu’il reste sur la page.",
  wb_account_activation_success_url_tooltip:
    "L’adresse vers laquelle le client arrive après avoir cliqué sur le lien d’activation reçu par e-mail.",
  wb_section_group_content: "Contenu",
  wb_section_group_offer: "Offre",
  wb_section_group_booking_flow: "Parcours de réservation",
  wb_section_group_form: "Formulaire",
  wb_section_group_account: "Compte client",
  wb_section_group_menu: "Pages et navigation",
  wb_section_group_company: "Données de l’entreprise et réseaux sociaux",
  wb_section_group_images: "Images et galerie",
  wb_section_group_map: "Carte",
  wb_section_group_appearance: "Apparence",
  wb_section_group_other: "Autres",
  wb_section_group_booking_form: "Formulaire de réservation",
  html_editor_tooltip_fullscreen: "Plein écran",
  html_editor_tooltip_fullscreen_exit: "Quitter le plein écran",
  wb_setting_tooltip_help_link: "Cliquez pour ouvrir le guide",
  wb_enable_discounts_tooltip:
    "Au moment de payer une réservation, un abonnement ou un produit, les clients voient un champ pour un code de réduction. Vous créez les codes directement dans Stripe, dans la section des réductions.",
  wb_enable_discounts_tooltip_url:
    "https://calendesk.com/help/how-do-you-create-discount-codes",
  wb_hide_booking_employees_tooltip:
    "Les clients ne voient aucun nom d’employé pendant la réservation, ils choisissent seulement un service et un créneau. Ce paramètre ne concerne que le site : vérifiez donc aussi vos modèles de notifications dans le panneau Calendesk et supprimez-y les données des employés si les clients ne doivent pas les voir.",
  wb_hide_time_zone_tooltip:
    "Les clients ne voient pas le sélecteur de fuseau horaire à côté du calendrier. Les heures s’affichent dans le fuseau détecté depuis leur navigateur et, si ce fuseau n’est pas pris en charge, dans celui de votre entreprise (@{timeZone}).",
  gdpr_fields: "Consentements du client",
  gdpr_field_required: "consentement obligatoire",
  wb_account_title_tooltip:
    "Titre au-dessus des liens du compte client dans le pied de page. En dessous, le client voit la connexion et la création de compte, puis, une fois connecté, ses réservations et ses paramètres.",
  wb_align_center_tooltip:
    "Place le contenu de la section au milieu de sa hauteur plutôt qu’en haut. La différence se voit surtout dans les sections hautes avec peu de texte.",
  wb_any_employee_enabled_tooltip:
    "Coché : l’étape du choix de l’employé se remplit automatiquement avec « n’importe quelle personne » et le client passe directement au choix du créneau ; le bouton « Modifier » lui permet toujours de choisir une personne précise. Décoché : le client choisit lui-même une personne dans une liste où « n’importe quelle personne » est la première option.",
  wb_book_now_label_tooltip:
    "Votre propre texte sur le bouton sur lequel le client clique pour confirmer le créneau choisi. Si vous laissez le champ vide, le bouton affiche le libellé standard « Réserver ».",
  wb_booking_dynamic_form_tooltip:
    "Ajoutez vos propres questions au formulaire de réservation, par exemple un champ de remarques ou une pièce jointe. Vous pouvez associer chaque champ à certains services : le client ne le voit alors qu’en réservant ces services.",
  wb_button_tooltip:
    "Le bouton de cette section. Définissez son libellé et la page vers laquelle le client est dirigé après le clic.",
  wb_button_size_tooltip:
    "La taille des boutons de la barre supérieure de votre site. Choisissez de XS (très petits) à XL (très grands).",
  wb_buttons_tooltip:
    "Les boutons affichés dans cette section. Chacun a son propre libellé et mène le client vers la page de votre choix.",
  wb_buttons_position_tooltip:
    "Définit la position des boutons dans la section : au bord gauche, au centre ou à droite.",
  wb_calendar_max_date_tooltip:
    "Le client peut consulter et réserver des créneaux au plus tard jusqu’au jour choisi. Le calendrier n’affiche aucune date au-delà.",
  wb_calendar_min_date_tooltip:
    "Le client ne voit les créneaux disponibles qu’à partir du jour choisi. Les dates antérieures ne peuvent être ni consultées ni réservées, pratique par exemple quand les réservations ouvrent à une date précise.",
  wb_color_bg_tooltip:
    "La couleur de fond de la plupart des sections de votre site. Les sections avec l’option « Inverser les couleurs » activée utilisent le second fond à la place.",
  wb_color_bg_2_tooltip:
    "La couleur de fond de secours. Elle apparaît dans les sections avec l’option « Inverser les couleurs » activée, ce qui vous permet d’alterner deux couleurs de fond sur la page.",
  wb_color_primary_tooltip:
    "La couleur principale de votre site. Vous la verrez sur les boutons, les liens et les éléments mis en avant, par exemple dans le calendrier de réservation.",
  wb_color_text_tooltip:
    "La couleur du texte dans les sections avec le premier fond. Choisissez-en une qui se détache nettement de la couleur de fond, sinon le texte sera difficile à lire.",
  wb_color_text_2_tooltip:
    "La couleur du texte dans les sections avec le second fond. Veillez à un contraste net avec la couleur du second fond.",
  wb_column_width_tooltip:
    "La part de la largeur de la section qu’occupe un avis sur ordinateur. Indiquez un pourcentage, par exemple 50 affiche deux avis côte à côte et 33 en affiche trois. Sur téléphone, les avis occupent toujours toute la largeur.",
  wb_company_address_tooltip:
    "L’adresse de votre entreprise affichée dans le pied de page, dans la partie contact.",
  wb_company_email_tooltip:
    "L’adresse e-mail dans le pied de page. Quand le client clique dessus, un nouveau message qui vous est adressé s’ouvre.",
  wb_company_name_tooltip:
    "Le nom de votre entreprise affiché dans la barre supérieure de la page. Écrivez-le tel que les clients doivent le voir.",
  wb_company_phone_tooltip:
    "Le numéro de téléphone dans le pied de page. Sur téléphone, le client peut le toucher pour vous appeler directement.",
  wb_company_slogan_tooltip:
    "Un court slogan pour votre entreprise, affiché sous le logo dans la section de réservation. Une phrase qui dit au client ce que vous faites.",
  wb_container_fluid_tooltip:
    "Étire le contenu de la section sur toute la largeur de la fenêtre du navigateur. Désactivé : le contenu reste dans une colonne plus étroite au centre, ce qui paraît généralement plus sobre sur les grands écrans.",
  wb_count_places_in_dates_tooltip:
    "Pour les services de groupe, le client voit à côté de la date le nombre total de places libres au lieu du nombre de créneaux libres. Cela ne fonctionne que pour les services auxquels plusieurs personnes peuvent participer.",
  wb_custom_code_tooltip:
    "Un espace pour votre propre code, par exemple un script de chat, de statistiques ou de pixel publicitaire. Le code collé fonctionne sur toutes les sous-pages. Cette option s’adresse aux utilisateurs avancés.",
  wb_cycle_tooltip:
    "Les photos de la galerie défilent toutes seules, sans clic. Vous réglez la vitesse dans le champ « Vitesse de changement en millisecondes ».",
  wb_dark_mode_tooltip:
    "Passe tout le site en couleurs sombres. Associez-y des fonds sombres et des couleurs de texte claires pour que tout reste lisible.",
  wb_date_label_tooltip:
    "Votre propre libellé pour le champ où le client choisit le jour de la réservation, par exemple « Choisissez le jour de votre réservation ».",
  wb_description_tooltip:
    "Texte affiché sous le titre de la section. Décrivez brièvement ce que vous proposez ou ce que le client trouvera dans cette partie de la page.",
  wb_elevation_tooltip:
    "L’intensité de l’ombre sous la barre supérieure du site, de 0 (aucune ombre) à 24 (ombre marquée). L’ombre sépare visuellement la barre du contenu de la page.",
  wb_email_form_success_url_tooltip:
    "Après l’envoi du formulaire, le client est dirigé vers l’adresse indiquée ici, par exemple une page de remerciement. Quand vous la définissez, le message d’envoi du formulaire n’est pas affiché.",
  wb_email_sent_tooltip:
    "Le texte qui remplace le formulaire après son envoi, par exemple « Merci, nous revenons vers vous très vite ». Un client redirigé vers une autre adresse ne le verra pas.",
  wb_email_subject_tooltip:
    "Ce texte apparaît comme objet de l’e-mail contenant les réponses du formulaire. Choisissez quelque chose de reconnaissable, par exemple « Demande depuis le site », pour retrouver facilement ces messages dans votre boîte.",
  wb_employee_info_label_tooltip:
    "Un court texte affiché au-dessus de la liste des employés, par exemple « Choisissez la personne avec qui vous voulez réserver ». Il n’apparaît que lorsque le client a le choix, c’est-à-dire quand plusieurs personnes réalisent le service.",
  wb_employee_label_tooltip:
    "Votre propre libellé pour la liste déroulante où le client choisit un employé, par exemple « Spécialiste » ou « Thérapeute ».",
  wb_employee_list_tooltip:
    "Choisissez les employés à afficher dans cette section de la page. Le client ne voit que les personnes sélectionnées, dans l’ordre de la liste.",
  wb_employee_search_tooltip:
    "Un champ de recherche par nom de famille apparaît au-dessus de la liste des employés. Le client ne le voit que lorsqu’il y a au moins cinq employés dans la liste.",
  wb_end_calendar_time_tooltip:
    "La dernière heure visible dans le calendrier hebdomadaire de votre page. Les heures suivantes ne sont pas affichées, réglez-la pour couvrir vos heures de travail.",
  wb_expand_collapse_service_panels_tooltip:
    "La liste des services est repliée par catégories et le client déplie le groupe qui l’intéresse d’un clic. Utile quand vous avez beaucoup de services et qu’une longue liste devient illisible.",
  wb_facebook_tooltip:
    "Le lien vers votre profil Facebook. Une fois saisi, une icône Facebook apparaît sur la page et mène à votre profil.",
  wb_features_tooltip:
    "Une liste d’éléments affichés dans cette section sous forme de vignettes, par exemple les atouts de votre offre ou les avis de vos clients. Chaque élément a son titre, sa description et son image.",
  wb_forgotten_password_confirmation_modal_tooltip:
    "Paramètres du message que le client voit après avoir demandé un nouveau mot de passe. Il confirme que le lien de réinitialisation est parti à l’adresse e-mail indiquée.",
  wb_forgotten_password_modal_tooltip:
    "Paramètres de la fenêtre où le client saisit son e-mail pour définir un nouveau mot de passe pour son compte client.",
  wb_forgotten_password_modal_confirmation_subtitle_tooltip:
    "Le contenu du message affiché après l’envoi de l’e-mail de changement de mot de passe. Dites au client que le lien se trouve dans sa boîte de réception et ce qu’il doit faire si l’e-mail n’est pas arrivé.",
  wb_forgotten_password_modal_confirmation_title_tooltip:
    "Titre du message que le client voit après avoir demandé un nouveau mot de passe, par exemple : « Consultez votre boîte de réception »",
  wb_forgotten_password_subtitle_tooltip:
    "Texte sous le titre de la fenêtre de changement de mot de passe. Expliquez au client qu’après avoir saisi son e-mail, il recevra un lien pour définir un nouveau mot de passe.",
  wb_forgotten_password_title_tooltip:
    "Titre de la fenêtre où le client demande à changer son mot de passe. Restez bref, par exemple : « Mot de passe oublié ? »",
  wb_form_tooltip:
    "Composez les champs du formulaire de contact, par exemple un champ de message, une adresse e-mail ou une pièce jointe. Tout ce que le client saisit vous parvient par e-mail.",
  wb_form_position_tooltip:
    "Choisissez de quel côté de la section se trouve le formulaire : à gauche ou à droite. Sur téléphone, la même option décide de l’ordre : « à gauche » affiche le formulaire au-dessus du contenu, « à droite » en dessous.",
  wb_gallery_distance_tooltip:
    "L’espace entre les photos de la galerie, en pixels. Une plage raisonnable va de 0 à 50. Plus l’espace est grand, plus les photos deviennent étroites.",
  wb_gallery_height_tooltip:
    "La hauteur de la galerie en pixels, par exemple 200 pour un bandeau bas et 500 pour une grande galerie. Toutes les photos s’ajustent à cette hauteur.",
  wb_gallery_image_number_tooltip:
    "Le nombre de photos visibles côte à côte sur ordinateur avant que la galerie ne défile. En général, 1 à 4 fonctionne bien.",
  wb_gallery_mobile_image_number_tooltip:
    "Le nombre de photos visibles côte à côte sur téléphone. Sur un petit écran, mieux vaut laisser 1, au maximum 2.",
  wb_gallery_style_tooltip:
    "L’apparence des commandes de la galerie. Le style 1 place les flèches et les points sur les photos, le style 2 les met sous la galerie, le style 3 fonctionne comme le 1 mais sans la barre sombre sous les points.",
  wb_gallery_width_tooltip:
    "La part de la largeur de la section qu’occupe la galerie sur ordinateur. Indiquez un pourcentage de 10 à 100, par exemple 50 pour la moitié de la largeur. Sur téléphone, la galerie occupe toujours toute la largeur.",
  wb_gdpr_fields_tooltip:
    "Ajoutez les consentements que le client coche à la création de son compte, par exemple un consentement marketing. Vous pouvez marquer chacun comme obligatoire. Nous enregistrons le texte du consentement et la décision du client avec son compte.",
  wb_google_tag_id_tooltip:
    "L’identifiant de votre conteneur Google Tag Manager, par exemple GTM-XXXXXX. Une fois saisi, vous pouvez collecter des statistiques de visite et connecter les outils Google.",
  wb_height_tooltip:
    "La hauteur de la section en pixels, par exemple 400 pour une section basse et 700 pour une section qui remplit presque tout l’écran. Quand il y a plus de contenu, la section s’agrandit d’elle-même.",
  wb_hide_arrows_tooltip:
    "Masque les flèches qui permettent de faire défiler la galerie. Activez cette option quand les photos ne doivent changer qu’automatiquement.",
  wb_hide_booking_time_to_tooltip:
    "Le client ne voit que l’heure de début, sans l’heure de fin ni la durée. Utile quand la durée réelle du service diffère parfois de celle définie dans le système.",
  wb_hide_delimiters_tooltip:
    "Masque les points sous la galerie qui permettent de passer directement à une photo donnée. La galerie paraît alors plus épurée.",
  wb_hide_footer_tooltip:
    "Masque le pied de page en bas de toutes les sous-pages, avec les coordonnées et les icônes des réseaux sociaux.",
  wb_hide_header_tooltip:
    "Masque la barre supérieure avec le logo et le menu sur toutes les sous-pages. Utile quand vous intégrez la page dans un autre site.",
  wb_hide_login_tooltip:
    "Désactive la connexion sur tout le site. Le client ne voit ni boutons de connexion ni sections accessibles après connexion, et fait tout sans compte client.",
  wb_hide_signup_tooltip:
    "Désactive la création de nouveaux comptes clients. Les clients qui ont déjà un compte peuvent toujours se connecter, mais personne de nouveau ne peut s’inscrire.",
  wb_html_code_tooltip:
    "Votre propre code HTML affiché comme contenu de cette section. Utilisez-le quand les sections toutes faites ne suffisent pas et que vous voulez ajouter un élément personnalisé.",
  wb_image_contain_tooltip:
    "Affiche la photo entière sans recadrage, même si des marges vides restent sur les côtés. Désactivé : la photo remplit tout le cadre, mais ses bords peuvent être coupés.",
  wb_image_height_tooltip:
    "La hauteur de la photo en pixels, par exemple 200. La photo sera ajustée à cette hauteur.",
  wb_image_hide_tooltip:
    "Désactive la photo de cette section sur tous les appareils. Le contenu occupe l’espace libéré.",
  wb_image_hide_on_mobile_tooltip:
    "Masque la photo uniquement sur téléphone, pour qu’elle ne prenne pas de place sur un petit écran. Sur ordinateur, la photo reste affichée.",
  wb_image_margin_bottom_tooltip:
    "L’espace vide sous la photo, en pixels. Une plage raisonnable va de 0 à 50. Une valeur plus élevée éloigne le texte de la photo.",
  wb_image_position_tooltip:
    "La position de la photo par rapport au contenu de la section : à gauche, à droite ou au centre, en haut ou en bas.",
  wb_image_rounded_tooltip:
    "Le degré d’arrondi des coins de la photo : des coins nets, en passant par un léger arrondi, jusqu’au cercle complet. Le cercle convient bien aux photos de personnes.",
  wb_image_to_right_tooltip:
    "Place la photo à droite du texte. Visible sur ordinateur ; sur téléphone, la photo et le texte se placent toujours l’un sous l’autre.",
  wb_image_width_tooltip:
    "La largeur de la photo en pixels, jusqu’à 1200. Sur téléphone, la photo remplit toujours toute la largeur de l’écran.",
  wb_image_zoom_on_click_tooltip:
    "Après un clic, la photo de la galerie s’ouvre agrandie en plein écran. Le client peut en regarder les détails.",
  wb_init_calendar_title_tooltip:
    "Le titre de l’écran où le client choisit un service, par exemple « Que souhaitez-vous réserver ? ». Il disparaît dès que le client choisit un service.",
  wb_initial_location_select_tooltip:
    "Le champ du lieu est rempli d’emblée avec le premier lieu disponible, le client peut le modifier. Quand l’option est désactivée, le client doit choisir un lieu avant de voir les créneaux disponibles.",
  wb_initial_service_selection_tooltip:
    "Avant le calendrier, le client choisit un service sur un écran séparé, avec la liste regroupée par catégories. Avec un seul service sans options, cet écran n’apparaît pas.",
  wb_instagram_tooltip:
    "Le lien vers votre profil Instagram. Une fois saisi, une icône Instagram apparaît sur la page et mène à votre profil.",
  wb_interval_tooltip:
    "La fréquence à laquelle la galerie change de photo toute seule, en millisecondes. 1000 correspond à une seconde ; 4000 à 8000 fonctionne généralement bien. Nécessite l’option « Changement automatique » activée.",
  wb_interval_minutes_tooltip:
    "L’intervalle entre les lignes d’heures du calendrier hebdomadaire, par exemple toutes les 15 ou toutes les 30 minutes. Une valeur plus petite donne une grille plus dense et une vue de la journée plus détaillée.",
  wb_invert_colors_tooltip:
    "Inverse les couleurs de cette section : le premier fond devient le second et la couleur du texte s’adapte en conséquence. La section se distingue ainsi de ses voisines.",
  wb_latitude_tooltip:
    "Le premier des deux nombres qui situent un lieu sur la carte, par exemple 52.2297. Ouvrez Google Maps, faites un clic droit sur votre lieu : tout en haut du menu, vous verrez les deux nombres, et un clic dessus les copie dans le presse-papiers. Saisissez ici le premier, avec un point à la place de la virgule.",
  wb_linkedin_tooltip:
    "Le lien vers votre profil LinkedIn. Une fois saisi, une icône LinkedIn apparaît sur la page et mène à votre profil.",
  wb_location_search_tooltip:
    "Un champ de recherche par nom apparaît au-dessus de la liste des lieux. Le client ne le voit que lorsqu’il y a au moins cinq lieux dans la liste.",
  wb_login_modal_tooltip:
    "Paramètres de la fenêtre où le client se connecte à son compte client. Vous y modifiez les textes affichés dans cette fenêtre.",
  wb_login_subtitle_tooltip:
    "Un court texte que le client voit en haut de la fenêtre de connexion, juste sous le titre. Vous pouvez y accueillir le client ou expliquer à quoi sert le compte.",
  wb_longitude_tooltip:
    "Le second des nombres copiés depuis Google Maps, par exemple 21.0122, celui après la virgule. Saisissez-le avec un point à la place de la virgule.",
  wb_main_pages_number_tooltip:
    "Définissez combien de pages apparaissent dans le menu supérieur comme boutons séparés. Le client trouve les autres pages dans la liste déroulante à côté.",
  wb_map_maker_hide_tooltip:
    "Masque le repère rouge qui indique votre position. La carte reste affichée, simplement sans le lieu marqué.",
  wb_menu_column_1_tooltip:
    "Pages affichées dans la première colonne de liens du pied de page. Le client y accède en un clic.",
  wb_menu_column_2_tooltip:
    "Pages affichées dans la deuxième colonne de liens du pied de page, à côté de la première.",
  wb_menu_title_tooltip:
    "Titre au-dessus de la liste de liens du pied de page, par exemple « Liens rapides » ou « Menu ». Le client le voit au-dessus de la première colonne de pages.",
  wb_more_pages_button_tooltip:
    "Le libellé du bouton qui déplie les pages supplémentaires dans le menu supérieur quand elles ne tiennent pas toutes comme onglets séparés.",
  wb_newsletter_input_placeholder_tooltip:
    "Le texte affiché dans le champ d’e-mail vide de la section newsletter, par exemple « Votre adresse e-mail ». Il indique au client quoi saisir.",
  wb_newsletter_success_message_tooltip:
    "Ce message apparaît sur la page quand un client s’inscrit à la newsletter, par exemple « Consultez votre boîte de réception et confirmez l’inscription ». Le client reçoit alors un e-mail avec un lien de confirmation.",
  wb_only_services_with_subscriptions_tooltip:
    "Le client ne voit que les services de son abonnement actif. Attention : sans abonnement et après déconnexion, la liste est vide.",
  wb_page_list_tooltip:
    "Choisissez les pages qui apparaissent comme éléments du menu. Le client les voit dans l’ordre défini ici.",
  wb_primary_language_tooltip:
    "La langue dans laquelle les clients voient votre page, par exemple les boutons, les formulaires et la vue de réservation.",
  wb_privacy_policy_page_tooltip:
    "Indiquez la page contenant votre politique de confidentialité. Le client l’ouvre en cliquant sur le lien de la note affichée à la création d’un compte.",
  wb_redirect_after_login_tooltip:
    "Choisissez la page sur laquelle le client arrive juste après s’être connecté, par exemple la page de réservation.",
  wb_redirect_after_signup_tooltip:
    "Choisissez la page sur laquelle le client arrive juste après avoir créé un compte, par exemple la page de réservation.",
  wb_redirect_logo_tooltip:
    "Choisissez la page qui s’ouvre quand quelqu’un clique sur le logo dans le menu supérieur. C’est généralement la page d’accueil.",
  wb_regulations_page_tooltip:
    "Indiquez la page contenant vos conditions d’utilisation. Le client l’ouvre en cliquant sur le lien de la note sur l’acceptation des conditions à la création d’un compte.",
  wb_require_billing_data_tooltip:
    "Le client doit fournir ses données de facturation pour terminer la réservation. Cela ne fonctionne que si l’affichage des données de facturation est activé dans le formulaire.",
  wb_require_phone_number_tooltip:
    "Le client ne peut pas terminer la réservation sans indiquer un numéro de téléphone. Cela ne fonctionne que si le champ du téléphone est visible dans le formulaire.",
  wb_section_text_tooltip:
    "Texte affiché dans la section avec le formulaire. Expliquez-y au client à quoi sert le formulaire et ce qui se passe après l’envoi.",
  wb_select_date_hour_tooltip:
    "Votre propre texte affiché au-dessus du calendrier des créneaux disponibles, par exemple « Choisissez le créneau qui vous convient ».",
  wb_select_date_title_label_tooltip:
    "Le titre au-dessus du calendrier à l’étape où le client choisit le jour et l’heure, par exemple « Choisissez un créneau ».",
  wb_select_employees_title_label_tooltip:
    "Le titre au-dessus de la liste des employés à l’étape où le client choisit une personne, par exemple « Avec qui souhaitez-vous réserver ? ».",
  wb_select_locations_title_label_tooltip:
    "Le titre au-dessus de la liste des lieux à l’étape où le client choisit le lieu, par exemple « Où souhaitez-vous réserver ? ».",
  wb_select_services_title_label_tooltip:
    "Le titre au-dessus de la liste des services à l’étape où le client choisit un service, par exemple « Choisissez un service ».",
  wb_selected_services_tooltip:
    "Le titre au-dessus de la liste des créneaux que le client a ajoutés au panier, par exemple « Vos créneaux sélectionnés ». Visible uniquement quand le panier de réservation est activé.",
  wb_selection_order_tooltip:
    "Vous décidez dans quel ordre le client passe les étapes de réservation : service, lieu, employé. Avec plusieurs lieux, mieux vaut commencer par cette étape.",
  wb_separate_online_locations_tooltip:
    "Le client choisit une application précise : Google Meet, Zoom, Teams ou WhatsApp. Sans cette option, il voit une seule entrée « en ligne » pour toutes les rencontres à distance.",
  wb_service_label_tooltip:
    "Votre propre libellé pour la liste déroulante où le client choisit un service, par exemple « Consultation » ou « Type de séance ».",
  wb_service_list_tooltip:
    "Laissez le champ vide et la section affiche tous vos services, y compris ceux que vous ajouterez plus tard. Dès que vous choisissez des services précis, chaque nouveau service doit être ajouté ici.",
  wb_service_search_tooltip:
    "Un champ de recherche par nom apparaît au-dessus de la liste des services. Le client ne le voit que lorsqu’il y a au moins cinq services dans la liste.",
  wb_show_active_button_tooltip:
    "Met en évidence dans le menu supérieur le nom de la page où se trouve le client, pour qu’il se repère plus facilement.",
  wb_show_billing_data_tooltip:
    "Le client voit dans le formulaire une option pour indiquer ses données de facturation, en tant qu’entreprise ou particulier. Il décide de les remplir ou non, sauf si vous les définissez aussi comme obligatoires.",
  wb_show_booked_slots_tooltip:
    "Les créneaux réservés restent visibles dans le calendrier, barrés et impossibles à sélectionner. Le client voit ainsi que la journée est très demandée, au lieu d’une liste de créneaux vide.",
  wb_show_company_name_tooltip:
    "Décidez si le nom de votre entreprise s’affiche à côté du logo dans la barre supérieure. Désactivez-le si le logo seul suffit.",
  wb_show_expand_collapse_button_tooltip:
    "Quand une journée compte beaucoup de créneaux libres, le client ne voit que les six premiers et un bouton pour déplier le reste. La liste reste ainsi plus courte et plus lisible.",
  wb_show_name_surname_tooltip:
    "Quand vous l’activez, le client indique son prénom et son nom lors de la réservation. Quand vous la désactivez, les champs disparaissent et l’adresse e-mail suffit.",
  wb_show_phone_number_tooltip:
    "Quand vous l’activez, un champ de numéro de téléphone apparaît dans le formulaire de réservation. Utile si vous appelez vos clients ou leur envoyez des SMS.",
  wb_show_remind_password_link_tooltip:
    "Quand l’option est activée, le client voit sur la page de connexion un lien pour réinitialiser son mot de passe. Un clic ouvre une fenêtre où il saisit son e-mail et reçoit un lien pour en définir un nouveau.",
  wb_show_service_column_tooltip:
    "À côté du calendrier, le client voit un panneau récapitulant le service choisi : nom, prix et durée. Quand l’option est désactivée, seul le calendrier des créneaux reste.",
  wb_show_service_description_tooltip:
    "Sous le service choisi, le client voit sa description issue du panneau Calendesk. Les descriptions longues sont raccourcies et le client déplie le texte complet avec le lien « Afficher plus ».",
  wb_show_sign_in_button_tooltip:
    "Affiche dans le menu supérieur un bouton qui ouvre la fenêtre de connexion au compte client. Seules les personnes non connectées le voient.",
  wb_show_sign_up_button_tooltip:
    "Affiche dans le menu supérieur un bouton qui ouvre la fenêtre de création d’un compte client. Seules les personnes non connectées le voient.",
  wb_sign_in_button_tooltip:
    "Le texte et l’apparence du bouton de connexion dans le menu supérieur. Vous y modifiez par exemple le libellé du bouton et son style.",
  wb_sign_up_button_tooltip:
    "Le texte et l’apparence du bouton de création de compte dans le menu supérieur. Vous y modifiez par exemple le libellé du bouton et son style.",
  wb_sign_up_modal_tooltip:
    "Paramètres de la fenêtre où le client crée un compte client. Vous y activez notamment la note sur les conditions d’utilisation et les données de facturation.",
  wb_sign_up_terms_info_tooltip:
    "Lors de l’inscription, le client voit une note indiquant qu’en créant un compte il accepte les conditions d’utilisation et la politique de confidentialité. Indiquez les deux pages ci-dessous, sinon les liens de cette note ne fonctionneront pas.",
  wb_start_calendar_time_tooltip:
    "La première heure visible dans le calendrier hebdomadaire de votre page. Les heures antérieures ne sont pas affichées, réglez-la sur le début de votre journée de travail.",
  wb_subtitle_tooltip:
    "Une courte ligne sous le titre de la section. L’endroit idéal pour une phrase qui prolonge le titre.",
  wb_summary_headline_tooltip:
    "Le titre de la fenêtre que le client voit juste après avoir réservé, par exemple « Merci pour votre réservation ! ».",
  wb_summary_text_tooltip:
    "Le texte de la fenêtre de confirmation de réservation, sous le titre. Dites au client ce qui se passe ensuite, par exemple qu’il recevra un e-mail de confirmation.",
  wb_text_tooltip:
    "Le texte principal de cette section. Vous pouvez le mettre en forme, par exemple en gras ou avec des listes.",
  wb_text_hide_tooltip:
    "Masque le texte affiché à côté du formulaire. Le formulaire occupe alors plus de place.",
  wb_text_margin_bottom_tooltip:
    "L’espace vide sous le texte de l’avis, en pixels. Une plage raisonnable va de 0 à 50.",
  wb_tiktok_tooltip:
    "Un lien vers votre profil TikTok. Une fois le lien saisi, une icône TikTok apparaît sur la page et mène à votre profil.",
  wb_title_tooltip:
    "Le titre principal de cette section. Votre client le voit affiché en grand en haut de la section.",
  wb_twitter_tooltip:
    "Un lien vers votre profil sur X (anciennement Twitter). Une fois le lien saisi, une icône X apparaît sur la page et mène à votre profil.",
  wb_use_booking_cart_tooltip:
    "Le client peut ajouter plusieurs créneaux au panier, y compris pour des services différents, et tout réserver d’un coup avec une seule confirmation. Sans le panier, chaque créneau est réservé séparément.",
  wb_view_flat_tooltip:
    "Supprime l’ombre des cadres de réservation, qui prennent alors un aspect plat et minimaliste. Désactivé : les cadres ont une ombre légère.",
  wb_view_rounded_tooltip:
    "Le degré d’arrondi des coins des cadres de réservation et du calendrier : des angles vifs à un arrondi prononcé.",
  wb_website_description_tooltip:
    "Une description de votre page pour les moteurs de recherche comme Google. Le client la voit sous le nom de la page dans les résultats de recherche et lors du partage d’un lien, mais pas sur la page elle-même.",
  wb_youtube_tooltip:
    "Un lien vers votre chaîne YouTube. Une fois le lien saisi, une icône YouTube apparaît sur la page et mène à la chaîne.",
  wb_zoom_tooltip:
    "Le niveau de zoom de la carte, sur une échelle de 1 à 20. La valeur 12 montre une ville entière, 16 montre une rue et ses environs.",
  custom_duration_value: "Autre valeur…",
  payment_authentication_failed_error:
    "Votre banque n’a pas confirmé le paiement. Réessayez et confirmez le paiement dans votre application bancaire. Si le problème persiste, utilisez une autre carte ou contactez-nous par chat.",
  insufficient_funds_error:
    "Votre carte n’a pas assez de fonds, la banque a donc refusé le paiement. Rechargez le compte ou utilisez une autre carte, puis réessayez.",
  card_declined_error:
    "Votre banque a refusé le paiement avec cette carte. Utilisez une autre carte ou demandez le motif à votre banque. Si vous avez besoin d’aide, écrivez-nous par chat.",
  wb_auto_save_short: "Enregistrement auto",
  wb_save_status_saving: "Enregistrement...",
  wb_save_status_saved_at: "Enregistré à @{time}",
  wb_save_status_error: "Échec de l'enregistrement",
  wb_save_retry: "Réessayer",
  wb_change_history: "Historique des modifications",
  wb_step_generic: "Réglage modifié",
  wb_step_moved_section: "Section déplacée",
  wb_step_added_section: "Section ajoutée",
  wb_step_added_page: "Page ajoutée",
  wb_step_updated_page: "Page modifiée",
  wb_booking_dynamic_form: "Champs du formulaire de réservation",
  wb_form: "Champs du formulaire",
  wb_buttons: "Boutons",
  wb_buttons_position: "Position des boutons",
  wb_form_position: "Position du formulaire",
  wb_image_position: "Position des images",
  hide_client_facing_ids_checkbox:
    "Masquer les numéros d’identifiant des réservations et des transactions pour les clients",
  hide_client_facing_ids_tooltip:
    "<b>Quels numéros sont masqués ?</b><br>Numéros de réservations, d’abonnements, de produits achetés, de transactions et de paiements.<br><br><b>Où vos clients ne les verront-ils plus ?</b><br>• dans la confirmation de réservation sur le site<br>• dans l’espace client : réservations, paiements, abonnements<br>• dans les e-mails par défaut<br>• sur la page de paiement Stripe<br>• dans le nom des lignes de facture (le numéro de facture reste inchangé)<br><br>Dans le panneau d’administration, vous voyez toujours tous les numéros. Si vous ajoutez vous-même le numéro de réservation à votre modèle de notification, il continuera de fonctionner.",
  variable_employee_title: "Poste de l’employé",
  employee_example_title: "Spécialiste senior",
  news: "Actualités",
  no_news_yet: "Aucune actualité pour le moment",
  mark_all_news_as_read: "Tout marquer comme lu",
  news_read_more: "En savoir plus",
  menu: "Menu",
  news_unread_tooltip: "Actualités - non lues : @{amount}",
  news_intro_title: "Nouveau : les actualités",
  news_intro_text:
    "Désormais, tous les changements et actualités de Calendesk se trouvent sous cette cloche.",
  spotlight_got_it: "Compris",
  mobile_menu_intro_title: "Nouveau : menu en bas",
  mobile_menu_intro_text:
    "Le menu, le calendrier, les nouvelles réservations, les ventes et les clients se trouvent maintenant dans la barre en bas.",
  merge_clients_title: "Fusionner les clients",
  merge_clients_single_title: "Fusionner avec un autre client",
  merge_clients_target_label: "Compte à conserver",
  merge_clients_add_client: "Ajouter un client à fusionner",
  merge_clients_account_summary: "Réservations : @{bookings}",
  merge_clients_warning:
    "Les autres comptes seront supprimés et leurs adresses e-mail ne permettront plus de se connecter. Toutes les réservations et l'historique des notifications seront transférés vers le compte conservé. Le client ne recevra aucun message. Les notes des fiches seront regroupées. Les champs vides du compte conservé seront complétés avec les données des autres comptes, et ce qui ne peut pas être transféré sera ajouté à la note. Cette opération est irréversible.",
  merge_clients_refusal_has_payments:
    "Ce compte comporte des paiements ou des abonnements et ne peut pas être fusionné.",
  merge_clients_refusal_not_client:
    "Ce compte appartient à un employé et ne peut pas être fusionné.",
  merge_clients_success: "Clients fusionnés.",
  merge_clients_selection_hint: "Sélectionnez de 2 à 5 comptes clients.",
  merge_clients_confirm: "Fusionner",
  max_user_bookings_period: "Sur quelle période ?",
  max_user_bookings_period_info:
    "Exemple : une limite de 1 avec une période de 30 jours signifie qu’un client peut réserver ce service à nouveau au plus tôt 30 jours après sa visite précédente. C’est la date de la visite qui compte, pas le jour de la réservation. La page de réservation de vos clients bloque les réservations au-delà de la limite. Dans le panneau d’administration et l’application mobile des employés, vous pouvez quand même ajouter des réservations, un avertissement s’affichera simplement.",
  booking_limit_dialog_title: "Limite de réservations atteinte",
  booking_limit_dialog_message:
    "Limite de réservations pour ce service : @{max} par client. La limite est déjà atteinte. Voulez-vous vraiment créer la réservation ?",
  booking_limit_dialog_message_period:
    "Limite de réservations pour ce service : @{max} par client sur une période de @{period}. La limite est déjà atteinte. Voulez-vous vraiment créer la réservation ?",
  logs_diff_max_user_bookings_period:
    "Période de la limite de réservations par client",
  "account_email-change": "Changement d’adresse e-mail - confirmation",
  "account_email-change_info":
    "Message avec un lien de confirmation, envoyé à la nouvelle adresse lorsqu’un client change son e-mail. Le changement ne prend effet qu’après le clic sur le lien.",
  "account_email-change_email_subject_client":
    "Confirmez votre nouvelle adresse e-mail pour [COMPANY_NAME]",
  "account_email-change_email_text_client":
    "<h1>Confirmez votre nouvelle adresse e-mail</h1><p>Nous avons reçu une demande de changement de l’adresse e-mail de votre compte [COMPANY_NAME] vers [NEW_EMAIL]. Cliquez ci-dessous pour confirmer la nouvelle adresse. Le changement ne prendra effet qu’après votre confirmation. Si vous n’êtes pas à l’origine de cette demande, ignorez ce message.</p>",
  "account_email-change_email_cta_button_client":
    "Confirmer la nouvelle adresse",
  "account_email-changed": "Changement d’adresse e-mail - notification",
  "account_email-changed_info":
    "Message d’information envoyé à l’ancienne adresse après un changement d’e-mail confirmé.",
  "account_email-changed_email_subject_client":
    "L’adresse e-mail de votre compte [COMPANY_NAME] a été modifiée",
  "account_email-changed_email_text_client":
    "<h1>Adresse e-mail modifiée</h1><p>L’adresse e-mail de votre compte [COMPANY_NAME] a été remplacée par [NEW_EMAIL]. Si vous n’êtes pas à l’origine de ce changement, contactez-nous immédiatement.</p>",
  variable_new_email: "Nouvelle adresse e-mail",
  email_change_pending_banner:
    "Le changement de votre adresse e-mail attend une confirmation. Nous avons envoyé un lien à @{email}. Tant que vous n’avez pas cliqué, le compte garde l’adresse actuelle.",
  email_change_pending_sent_info:
    "Nous avons envoyé un lien de confirmation à @{email}. L’adresse e-mail changera après le clic sur ce lien.",
  email_change_cancel_button: "Annuler le changement",
  email_change_resend_success: "Le lien a été renvoyé.",
  email_change_resend_too_soon:
    "Nous venons d’envoyer le lien. Patientez quelques secondes et réessayez.",
  email_change_cancel_success: "Le changement d’adresse e-mail a été annulé.",
  email_change_confirm_success:
    "Votre adresse e-mail a été modifiée. Connectez-vous avec la nouvelle adresse.",
  email_change_confirm_error:
    "Le lien de confirmation a expiré ou n’est pas valide. Connectez-vous et renvoyez-le depuis les paramètres de votre profil.",
  account_activation_completed:
    "Votre compte est actif. Connectez-vous pour commencer.",
  email_change_confirm_taken_error:
    "Cette adresse e-mail est déjà utilisée par un autre compte. Connectez-vous et recommencez le changement avec une autre adresse.",
  email_change_no_pending:
    "Aucun changement d’adresse e-mail n’attend de confirmation.",
  notification_category_14: "Changement d'adresse e-mail",
  wb_employee_selection_mode: "Choix de l’employé lors de la réservation",
  wb_employee_selection_mode_any_person_first:
    "Le client choisit une personne, « n’importe quelle personne » figure dans la liste",
  wb_employee_selection_mode_specific_only:
    "Le client choisit une personne précise",
  wb_employee_selection_mode_auto_assign:
    "Passer l’étape de sélection, attribuer automatiquement",
  wb_employee_selection_mode_tooltip:
    "Détermine le fonctionnement de l’étape du choix de l’employé. « Le client choisit une personne » affiche la liste avec « n’importe quelle personne » comme première option. « Le client choisit une personne précise » masque l’option « n’importe quelle personne », le client doit donc choisir quelqu’un dans la liste. « Passer l’étape de sélection » remplit l’étape avec « n’importe quelle personne » et amène le client directement au choix du créneau ; le bouton « Modifier » permet toujours de choisir une personne précise.",
  customer_captcha_enabled_checkbox:
    "Protéger les formulaires de réservation, d’inscription et de connexion avec Google reCAPTCHA",
  customer_captcha_enabled_tooltip:
    "<b>À quoi ça sert ?</b><br>Google reCAPTCHA tourne en arrière-plan et bloque les robots qui remplissent ton agenda de fausses réservations ou tentent de deviner les mots de passe de tes clients. Tes clients n’ont rien à cliquer.<br><br><b>Que se passe-t-il si tu le désactives ?</b><br>Ta page de réservation ne charge plus les scripts Google et ne dépose aucun cookie Google, ce qui est plus simple à déclarer dans ta politique de cookies. En contrepartie, tes formulaires perdent le filtre anti-robots. Si tu le désactives, active au-dessus la confirmation par e-mail pour les réservations, pour que toute personne réservant sans compte confirme son adresse.",
  wb_cookie_banner_enabled: "Afficher une bannière de cookies sur le site",
  wb_cookie_banner_enabled_tooltip:
    "Les visiteurs décident eux-mêmes s'ils acceptent les statistiques et la publicité. Jusque-là, Google Tag Manager et votre code personnalisé attendent, et seul ce dont le site a besoin fonctionne (connexion, réservations, paiements, protection des formulaires). Chaque texte de la bannière se modifie ci-dessous.",
  wb_cookie_banner_edit_texts: "Paramètres de la bannière cookies",
  wb_google_tag_mode: "Google Tag Manager se lance",
  wb_google_tag_mode_tooltip:
    "Choisissez « Tout de suite » seulement si vous avez défini dans votre compte Google Tag Manager quelles balises exigent un consentement. Sinon le conteneur attend que le visiteur accepte les statistiques ou la publicité.",
  wb_google_tag_mode_after_consent:
    "Après l'accord du visiteur pour les cookies",
  wb_google_tag_mode_immediately:
    "Tout de suite, en transmettant le choix du visiteur à Google",
  wb_custom_code_mode: "Le code ci-dessous se lance",
  wb_custom_code_mode_tooltip:
    'Un extrait peut attendre un autre consentement que le reste. Ajoutez-lui data-category="analytics", "marketing" ou "functionality" et il ne dépend plus que de ce consentement, par exemple <script data-category="marketing" src="...">. Fonctionne dans script, link et style. Meta se lance toujours.',
  wb_custom_code_mode_always: "Tout de suite, sans demander le consentement",
  wb_custom_code_mode_functionality:
    "Après consentement aux fonctions supplémentaires",
  wb_custom_code_mode_analytics: "Après consentement aux statistiques",
  wb_custom_code_mode_marketing: "Après consentement à la publicité",
  wb_custom_code_blocked_info:
    "Extraits sans catégorie propre : @{count}. Tous attendent un consentement, vérifiez donc qu'il n'y a pas parmi eux une police, un style ou un chat.",
  wb_custom_code_mode_hint_always:
    "Ce code se lance chez chaque visiteur, même s'il refuse les cookies. Ne laissez ici que du code qui ne suit personne.",
  wb_custom_code_mode_hint_consent:
    'Si un visiteur refuse les cookies, ce code ne se lance pas. Pour qu\'un extrait fonctionne toujours, ajoutez-lui data-category="necessary" :\n<script ... data-category="necessary">',
  wb_cookie_banner_title: "Titre de la bannière",
  wb_cookie_banner_description: "Texte de la bannière",
  wb_cookie_banner_accept_all_button: "Bouton « Tout accepter »",
  wb_cookie_banner_reject_all_button: "Bouton « Tout refuser »",
  wb_cookie_banner_settings_button: "Bouton « Paramètres »",
  wb_cookie_banner_privacy_policy_page: "Page de politique de confidentialité",
  wb_cookie_banner_privacy_policy_url:
    "Adresse de la politique de confidentialité",
  wb_cookie_banner_privacy_policy_url_tooltip:
    "Lien vers une politique de confidentialité en dehors de ce site. S'il est renseigné, il remplace la page ci-dessus.",
  wb_cookie_banner_privacy_policy_link:
    "Texte du lien vers la politique de confidentialité",
  wb_cookie_banner_block_page:
    "Bloquer la page jusqu'à la décision du visiteur",
  wb_cookie_banner_block_page_tooltip:
    "Désactivé par défaut : les visiteurs peuvent réserver avant de répondre à la bannière.",
  wb_cookie_banner_preferences_title: "Titre de la fenêtre des paramètres",
  wb_cookie_banner_save_button: "Bouton « Enregistrer »",
  wb_cookie_banner_necessary_title: "Nécessaires, titre",
  wb_cookie_banner_necessary_description: "Nécessaires, description",
  wb_cookie_banner_functionality_title: "Fonctions supplémentaires, titre",
  wb_cookie_banner_functionality_description:
    "Fonctions supplémentaires, description",
  wb_cookie_banner_analytics_title: "Statistiques, titre",
  wb_cookie_banner_analytics_description: "Statistiques, description",
  wb_cookie_banner_marketing_title: "Publicité, titre",
  wb_cookie_banner_marketing_description: "Publicité, description",
  wb_cookie_banner_default_title: "Ce site utilise des cookies",
  wb_cookie_banner_default_description:
    "Les cookies sont de petits fichiers enregistrés dans votre navigateur. Les cookies nécessaires font fonctionner la connexion, les réservations et les paiements et sont toujours actifs. Avec votre accord, nous utilisons aussi des cookies pour les statistiques de visite et pour adapter la publicité. Vous pouvez modifier ou retirer votre accord à tout moment dans les paramètres des cookies.",
  wb_cookie_banner_default_accept_all_button: "Tout accepter",
  wb_cookie_banner_default_reject_all_button: "Tout refuser",
  wb_cookie_banner_default_settings_button: "Paramètres des cookies",
  wb_cookie_banner_default_privacy_policy_link: "Politique de confidentialité",
  wb_cookie_banner_default_preferences_title: "Paramètres de confidentialité",
  wb_cookie_banner_default_save_button: "Enregistrer mes choix",
  wb_cookie_banner_default_necessary_title: "Nécessaires",
  wb_cookie_banner_default_necessary_description:
    "Ces cookies sont indispensables au fonctionnement du site et ne peuvent pas être désactivés. Ils sont déposés en réponse à vos actions, comme la connexion, une réservation, un paiement (Stripe) ou l'envoi d'un formulaire (protection reCAPTCHA). Vous pouvez les bloquer dans votre navigateur, mais des parties du site cesseront alors de fonctionner. Ils ne stockent aucune donnée permettant de vous identifier.",
  wb_cookie_banner_default_functionality_title: "Fonctions supplémentaires",
  wb_cookie_banner_default_functionality_description:
    "Ces cookies ajoutent des fonctions supplémentaires au site, comme un chat, une carte ou des vidéos intégrées. Ils peuvent être déposés par les fournisseurs de ces services. Sans votre accord, ces fonctions peuvent ne pas fonctionner ou fonctionner de façon limitée.",
  wb_cookie_banner_default_analytics_title: "Statistiques",
  wb_cookie_banner_default_analytics_description:
    "Ces cookies comptent les visites et les sources de trafic afin de mesurer et d'améliorer le fonctionnement du site, par exemple avec Google Analytics. Ils montrent quelles pages sont les plus visitées et comment les visiteurs se déplacent sur le site. Les données sont agrégées et anonymes. Sans votre accord, votre visite n'est pas comptée dans les statistiques.",
  wb_cookie_banner_default_marketing_title: "Publicité",
  wb_cookie_banner_default_marketing_description:
    "Ces cookies sont déposés par des partenaires publicitaires, par exemple Google Ads ou Meta. Ils établissent un profil de vos centres d'intérêt et vous montrent des publicités adaptées sur d'autres sites. Ils ne stockent pas directement de données personnelles, mais reconnaissent votre navigateur et votre appareil. Sans votre accord, les publicités seront moins pertinentes.",
  wb_cookie_banner_enabled_info:
    "La bannière est active. Les textes, les catégories, le lien de confidentialité et le retour aux paramètres se trouvent sous le bouton ci-dessous, ou cliquez sur la bannière dans l'aperçu. Les réglages qui dépendent de la bannière portent une barre colorée à gauche.",
  wb_cookie_banner_preview_edit:
    "Cliquez pour ouvrir les paramètres de la bannière cookies",
  wb_section_preview_edit: "Cliquez pour ouvrir les paramètres de la section",
  wb_navbar_preview_edit: "Cliquez pour ouvrir les paramètres de l'en-tête",
  wb_footer_preview_edit: "Cliquez pour ouvrir les paramètres du pied de page",
  wb_cookie_banner_section_bar: "Barre de cookies",
  wb_cookie_banner_section_link: "Lien vers la politique de confidentialité",
  wb_cookie_banner_section_preferences: "Fenêtre des paramètres",
  wb_cookie_banner_privacy_policy_target: "Où mène le lien ?",
  wb_cookie_banner_privacy_policy_target_none: "Pas de lien",
  wb_cookie_banner_privacy_policy_target_page: "Une page de ce site",
  wb_cookie_banner_privacy_policy_target_url: "Une adresse externe",
  wb_cookie_banner_default_preferences_description:
    "Pendant votre visite, votre navigateur peut enregistrer ou lire des informations, le plus souvent sous forme de cookies. Elles peuvent concerner vous, vos préférences ou votre appareil et ne vous identifient généralement pas directement. Ci-dessous, vous choisissez les types de cookies que vous acceptez. En bloquer certains peut limiter des parties du site.",
  wb_cookie_banner_preferences_description:
    "Fenêtre des paramètres, texte d'introduction",
  wb_cookie_banner_categories: "Catégories proposées au visiteur",
  wb_cookie_banner_categories_tooltip:
    "Décochez une catégorie pour la masquer dans la fenêtre des paramètres. Une catégorie masquée n'est jamais acceptée, donc le code qui lui est attribué ne s'exécute jamais. Google Tag Manager en mode « après consentement » ne démarre qu'avec un accord pour les statistiques ou la publicité : gardez-en au moins une si vous l'utilisez.",
  wb_cookie_banner_category_hidden: "masquée",
  wb_cookie_banner_reopen:
    "Comment le visiteur revient-il aux paramètres des cookies ?",
  wb_cookie_banner_reopen_icon:
    "Une petite icône cookie dans le coin de la page",
  wb_cookie_banner_reopen_link:
    "Un lien que j'ajoute moi-même (menu, pied de page ou bouton)",
  wb_cookie_banner_reopen_both: "Les deux : l'icône et mon propre lien",
  wb_cookie_banner_reopen_link_info:
    "L'icône est toujours visible : le visiteur peut changer d'avis à tout moment sans rien faire de votre côté. Si vous préférez un lien dans le pied de page ou le menu, ajoutez une entrée de menu ou une page de redirection avec cette adresse :",
  wb_cookie_banner_reopen_link_missing:
    "Rien sur votre site ne mène encore aux paramètres des cookies. Ajoutez une entrée de menu, un lien de pied de page ou un bouton avec l'adresse ci-dessus, sinon le visiteur ne peut pas changer d'avis.",
  wb_cookie_banner_reopen_tooltip:
    "Le visiteur peut modifier ou retirer son consentement à tout moment. Choisissez l'icône, un lien placé par vous (par exemple dans le pied de page, comme la plupart des sites) ou les deux.",
  employee_no_panel_access: "Sans accès au panneau",
  guest_retention_days_label: "Supprimer après combien de jours ?",
  guest_retention_anchor_label: "À partir de quand compter les jours ?",
  guest_retention_anchor_last_booking:
    "à partir de la dernière réservation de cette personne (recommandé)",
  guest_retention_anchor_record_created:
    "à partir de la première réservation de cette personne",
  client_password_min_length_label: "Longueur minimale du mot de passe",
  client_password_classes_label: "Types de caractères obligatoires",
  client_password_class_upper: "Majuscule",
  client_password_class_lower: "Minuscule",
  client_password_class_digit: "Chiffre",
  client_password_class_special: "Caractère spécial",
  client_password_breach_check_checkbox:
    "Refuser les mots de passe connus des fuites de données",
  client_password_breach_check_tooltip:
    "Nous vérifions si le mot de passe est apparu dans des fuites de données publiques. Seul un fragment de l’empreinte du mot de passe est transmis au service de vérification, jamais le mot de passe lui-même ni l’adresse e-mail. Si le service ne répond pas, le mot de passe est accepté sans cette vérification.",
  client_password_email_similarity_checkbox:
    "Le mot de passe ne doit pas contenir la partie de l’adresse e-mail située avant « @ »",
  client_password_email_similarity_tooltip:
    "Nous vérifions la partie de l’adresse située avant « @ », sans tenir compte de la casse. Pour <b>anna.kowalska@example.com</b>, le mot de passe <b>Anna.Kowalska2024!</b> est refusé, tandis que <b>Kowalska2024!</b> est accepté. Si cette partie compte moins de 4 caractères (par ex. <b>jk@</b>), la règle ne bloque rien.",
  client_password_settings_tooltip:
    "Les règles s’appliquent sur la page de réservation et dans l’application client. Les mots de passe de vos employés ne changent pas.",
  settings_privacy: "Confidentialité",
  privacy_account_card_title: "Que voit le client une fois connecté ?",
  privacy_account_card_description:
    "Actuellement, un client connecté voit toutes les réservations faites avec son adresse e-mail, y compris celles d’avant la création de son compte.",
  privacy_account_switch:
    "Ne montrer au client que les réservations faites depuis la création de son compte",
  privacy_account_warning:
    "Les réservations, paiements et fichiers plus anciens restent dans votre panneau, mais disparaissent du compte client. Chaque nouveau client ne pourra se connecter qu’après avoir cliqué sur le lien reçu par e-mail. Les clients qui ont un compte mais n’ont jamais confirmé leur adresse devront la confirmer lors de leur prochaine connexion : il suffit de cliquer sur le lien de l’e-mail ou d’utiliser « Mot de passe oublié ». Une personne qui a réservé sans compte s’inscrit, car « Mot de passe oublié » ne lui enverra rien. Les membres de l’équipe ne sont pas concernés.",
  privacy_account_example_caption:
    "Exemple : Anne a réservé sans compte, puis en a créé un plus tard.",
  privacy_account_example_now: "Actuellement",
  privacy_account_example_after: "Avec cette option",
  privacy_account_example_booking_before: "3 mars : réservation sans compte",
  privacy_account_example_signup: "10 mai : Anne crée son compte",
  privacy_account_example_booking_after:
    "2 octobre : réservation depuis son compte",
  privacy_account_example_hidden: "visible uniquement dans votre panneau",
  guest_retention_example_last_booking:
    "Exemple : une personne réserve aujourd’hui sans compte. Si elle ne réserve plus rien, nous supprimerons ses données la nuit suivant le @{date}, mais jamais avant la date de sa réservation.",
  guest_retention_example_record_created:
    "Exemple : une personne réserve aujourd’hui pour la première fois sans compte. Nous supprimerons ses données la nuit suivant le @{date}, même si elle réserve à nouveau entre-temps, mais jamais avant la date d’une réservation.",
  guest_retention_timeline_label: "Comment fonctionne la suppression ?",
  guest_retention_timeline_booking: "Réservation sans compte",
  guest_retention_timeline_booking_last:
    "à compter de la dernière réservation de cette personne",
  guest_retention_timeline_booking_first:
    "à compter de la première réservation de cette personne",
  guest_retention_timeline_wait: "@{days} jour passe|@{days} jours passent",
  guest_retention_timeline_wait_detail:
    "et il ne reste aucune réservation à venir",
  guest_retention_timeline_delete: "La nuit, nous supprimons ses données",
  guest_retention_timeline_delete_detail:
    "nom, coordonnées, messages envoyés, fichiers et avis",
  guest_retention_timeline_kept:
    "La réservation reste, sans données personnelles",
  guest_retention_timeline_kept_detail:
    "prestation, employé et date, pour que vos statistiques restent justes",
  guest_retention_advanced_title: "Paramètres avancés",
  guest_retention_scope_checkbox:
    "Supprimer aussi les données de la personne des anciennes réservations sans compte, même si elle a créé un compte ensuite",
  guest_retention_scope_hint:
    "Exemple : Anne a réservé le 3 mars sans compte, puis a créé un compte le 10 mai. Après le délai choisi, la réservation du 3 mars reste dans votre panneau sans ses données (seulement la prestation, l’employé et la date) et n’est plus liée à son compte. Son compte et ses réservations à partir du 10 mai ne changent pas. Les réservations avec paiement ne sont pas touchées.",
  guest_retention_scope_why:
    "Pourquoi ? Quelqu’un d’autre a pu faire cette réservation avec son adresse e-mail, et elle ne la voit pas dans son compte : il n’y a donc aucune raison d’y garder ses données.",
  guest_retention_never_title: "Qui ne supprimons-nous jamais ?",
  guest_retention_never_account: "Les clients avec un compte",
  guest_retention_never_payment: "Les clients avec un paiement",
  guest_retention_never_subscription: "Les clients avec un abonnement",
  guest_retention_never_upcoming: "Les clients avec une réservation à venir",
  guest_retention_never_manual: "Les clients ajoutés dans le panneau",
  client_password_preview_title:
    "Comment ces règles s’appliquent-elles à des exemples ?",
  client_password_preview_email:
    "Pour une cliente avec l’adresse @{email}. Les fuites ne sont vérifiées qu’au moment où le client choisit son mot de passe.",
  client_password_preview_passes: "accepté",
  client_password_preview_too_short: "trop court (au moins @{min} caractères)",
  client_password_preview_missing: "manque : @{what}",
  client_password_preview_has_email: "contient une partie de l’adresse e-mail",
  guest_retention_scope_table_label: "Ce que change cette option",
  guest_retention_scope_table_booking: "La réservation du 3 mars",
  guest_retention_scope_table_unchecked: "Non cochée",
  guest_retention_scope_table_checked: "Cochée",
  guest_retention_scope_table_account: "Dans le compte d’Anne",
  guest_retention_scope_table_panel: "Dans votre panneau",
  guest_retention_scope_table_hidden:
    "Invisible, car l’option « Ne montrer au client que les réservations faites depuis la création de son compte » est activée",
  guest_retention_scope_table_kept:
    "Reste avec les données d’Anne, sans limite",
  guest_retention_scope_table_removed:
    "Après @{days} jour, elle reste sans ses données : seulement la prestation, l’employé et la date|Après @{days} jours, elle reste sans ses données : seulement la prestation, l’employé et la date",
  guest_retention_scope_requires_account_history:
    "Ne fonctionne que si l’option « Ne montrer au client que les réservations faites depuis la création de son compte » est activée dans « Que voit le client une fois connecté ? ».",
  guest_retention_dpo_title:
    "Détails pour votre délégué à la protection des données",
  guest_retention_dpo_details:
    "<b>Que supprimons-nous ?</b> Les données de la personne (nom, e-mail, téléphone, adresse), les e-mails et SMS qui lui ont été envoyés, les entrées du journal d’activité, les pièces jointes et les avis. Chaque réservation reste sous forme d’entrée sans données personnelles : prestation, employé, date et statut.<br><br><b>Qui ne supprimons-nous pas ?</b> Les personnes ayant un compte, une demande de compte ou au moins une connexion. Les personnes ayant un paiement, un abonnement ou une réservation à venir. Les employés, les clients ajoutés dans le panneau sans réservation et toute personne dont les données sont apparues avant la première activation de l’option.<br><br><b>Sauvegardes</b> Les données supprimées disparaissent des sauvegardes sous 21 jours.<br><br><b>Preuve de suppression</b> La liste « Suppressions de données » indique chaque passage : date, personnes supprimées, réservations sans données personnelles, personnes ignorées (paiement ou réservation à venir) et erreurs. Nous n’enregistrons que des chiffres. Pendant 90 jours, nous conservons une empreinte irréversible des adresses e-mail supprimées, afin de confirmer sur demande qu’une adresse a bien été supprimée. « Essai » désigne un passage qui n’a rien supprimé.",
  privacy_retention_confirm_preview_bookings:
    "Nous retirerons aussi les données de @{bookings} anciennes réservations de clients qui ont créé un compte plus tard.",
  client_password_extra_rules_title: "Règles supplémentaires",
  client_password_policy_empty:
    "Impossible d’enregistrer uniquement le minimum de 8 caractères sans autre règle. Cochez au moins un type de caractères, augmentez la longueur minimale ou activez l’une des règles supplémentaires.",
  client_password_weaker_than_default:
    "Ces règles sont plus souples que les règles actuelles : la page de réservation acceptera des mots de passe sans les types de caractères décochés.",
  logs_diff_account_requested_at: "Compte demandé",
  logs_diff_account_requested_via: "Compte demandé via",
  account_request_via_signup_form: "inscription sur le site",
  account_request_via_booking_form: "formulaire de réservation",
  account_request_via_store_form: "boutique",
  account_request_via_admin_panel: "panneau (employé)",
  account_request_via_password_reset: "réinitialisation du mot de passe",
  account_request_via_backfill: "compte antérieur au changement",
  account_status_account: "Compte",
  account_status_pending: "En attente de confirmation",
  account_status_guest: "Sans compte",
  account_status_blocked: "Bloqué",
  account_status_filter: "Compte",
  account_status_account_details: "Compte confirmé le @{date}",
  account_status_pending_details:
    "Compte demandé le @{date} (@{via}), adresse pas encore confirmée",
  account_status_guest_details: "Réserve sans compte",
  retention_forecast_kept: "Nous ne supprimons pas ces données : @{reason}.",
  retention_forecast_due_tonight: "Nous supprimerons les données cette nuit.",
  retention_forecast_due_after:
    "Nous supprimerons les données au plus tôt la nuit suivant le @{date}.",
  retention_forecast_due_after_booking:
    "Nous supprimerons les données au plus tôt la nuit suivant le @{date}, une fois la date de la réservation passée.",
  retention_forecast_reason_account: "le client a un compte",
  retention_forecast_reason_account_request: "le client a demandé un compte",
  retention_forecast_reason_staff: "c’est un membre de l’équipe",
  retention_forecast_reason_before_enabled:
    "les données datent d’avant l’activation de la suppression",
  retention_forecast_reason_logged_in: "le client s’est connecté sur le site",
  retention_forecast_reason_no_booking: "le client n’a aucune réservation",
  retention_forecast_reason_managed_by_staff:
    "une réservation de ce client a été ajoutée par l’équipe ou par un import",
  event_customer_removed: "Données du client supprimées",
  retention_forecast_reason_payment: "le client a un paiement",
  retention_forecast_reason_subscription: "le client a un abonnement",
  privacy_account_confirm_warning:
    "Les clients ne verront dans leur compte que les réservations faites depuis sa création, et les nouveaux clients ne pourront se connecter qu’après avoir confirmé leur e-mail. Une personne qui a réservé sans compte doit s’inscrire. Toutes les réservations restent dans votre panneau.",
  privacy_account_confirm_unconfirmed:
    "Clients avec un compte qui confirmeront leur adresse lors de leur prochaine connexion : @{count}.",
  privacy_retention_card_title:
    "Suppression des données des personnes sans compte",
  privacy_retention_card_description:
    "Actuellement, les données des personnes qui réservent sans compte restent dans le système sans limite de durée.",
  privacy_retention_switch:
    "Supprimer ces données automatiquement après un délai choisi",
  privacy_retention_confirm_warning:
    "Désormais, chaque nuit, nous supprimerons définitivement les données des personnes sans compte dès que @{days} jour se sera écoulé. Cette action est irréversible.|Désormais, chaque nuit, nous supprimerons définitivement les données des personnes sans compte dès que @{days} jours se seront écoulés. Cette action est irréversible.",
  privacy_retention_confirm_reenable:
    "L’option était déjà activée depuis le @{date} : elle concerne donc aussi les personnes qui ont réservé sans compte pendant qu’elle était désactivée.",
  privacy_password_card_title: "Mots de passe des clients",
  privacy_password_card_description:
    "Actuellement, le mot de passe d’un client doit comporter au moins 8 caractères, dont une minuscule, une majuscule, un chiffre et un caractère spécial comme ! ou #.",
  privacy_password_switch: "Définir vos propres règles de mot de passe",
  privacy_confirm_title: "Enregistrer les modifications de confidentialité ?",
  profile_account_details: "Informations du compte",
  guest_retention_coverage_on_save:
    "La suppression ne concerne que les personnes dont les données apparaissent après l’enregistrement. Nous ne supprimons pas vos clients actuels.",
  guest_retention_coverage_since:
    "Nous ne supprimons que les personnes dont les données sont apparues à partir du @{date}. Les clients antérieurs à cette date ne sont jamais supprimés, même si vous réactivez l’option.",
  guest_data_purges_title: "Suppressions de données",
  guest_data_purges_description:
    "Chaque suppression nocturne est enregistrée ici. Vous pouvez télécharger la liste en CSV pour votre délégué à la protection des données.",
  guest_data_purges_after_save:
    "La liste apparaîtra après l’enregistrement. Nous vérifions les données chaque nuit, mais les premières personnes ne seront supprimées qu’à partir de la nuit suivant le @{date}.",
  guest_data_purges_status_none:
    "Aucun passage pour l’instant. Nous vérifions les données chaque nuit ; les premières personnes ne seront supprimées qu’à partir de la nuit suivant le @{date}.",
  guest_data_purges_status_last:
    "Dernière exécution : @{date}, @{users} personnes supprimées.",
  guest_data_purges_none: "Aucune exécution pour le moment.",
  guest_data_purges_none_with_changes:
    "Aucune exécution n’a encore rien supprimé. Vous les trouverez toutes dans le fichier CSV.",
  guest_data_purges_rest_in_csv:
    "Les autres exécutions n’ont rien supprimé. Vous les trouverez toutes dans le fichier CSV.",
  guest_data_purges_show_more: "Afficher plus",
  guest_data_purges_export: "Télécharger le CSV",
  guest_data_purges_dry_run: "essai (rien supprimé)",
  guest_data_purges_col_run: "Exécution",
  guest_data_purges_col_users: "Personnes supprimées",
  guest_data_purges_col_bookings: "Réservations anonymisées",
  guest_data_purges_col_excluded: "Ignorées (paiement ou réservation à venir)",
  guest_data_purges_col_errors: "Erreurs",
  privacy_retention_confirm_preview:
    "Cette nuit, nous supprimerons les données de @{users} personnes sans compte.",
  guest_data_purges_load_failed:
    "Impossible de charger la liste des suppressions. Vos paramètres sont enregistrés ; actualisez la page pour voir la liste.",
  guest_data_purges_export_failed:
    "Impossible de télécharger le fichier CSV. Veuillez réessayer.",
  plan_preview_title: "Combien payez-vous aujourd’hui ?",
  plan_preview_subtotal: "Sous-total HT",
  plan_preview_discount: "Remise",
  plan_preview_tax: "TVA",
  plan_preview_credit_used: "Depuis votre solde",
  plan_preview_amount_due: "À payer aujourd’hui",
  plan_preview_credit_after: "Restera sur votre solde : {amount}",
  plan_preview_renews_at: "Prochain paiement : {date}",
  plan_preview_no_change:
    "C’est votre plan actuel. Rien ne change et rien ne vous sera facturé.",
  plan_preview_resume:
    "Vous conservez votre plan actuel et le changement prévu est annulé. Rien ne vous sera facturé aujourd’hui.",
  plan_preview_credit_note:
    "La différence va sur votre solde et couvre vos prochains paiements.",
  plan_preview_credit_covers:
    "Votre solde règle les prochains paiements de {amount}. Votre carte ne sera débitée que le {date}.",
  plan_preview_carried_to_next:
    "Nous ajouterons {amount} à votre prochain paiement. Un montant aussi faible ne peut pas être débité par carte.",
  plan_preview_applied_discount:
    "Votre remise ({discount}) est déjà incluse dans ces prix.",
  plan_preview_loading: "Nous calculons ce que vous payez aujourd’hui…",
  plan_preview_discount_code: "Code {code}",
  plan_preview_discount_forever: "sans date de fin",
  plan_preview_discount_until: "jusqu’au {date}",
  plan_preview_discount_once: "sur le premier paiement uniquement",
  change_plan: "Changer de plan",
  plan_changes_adding: "Vous ajoutez : {items}",
  plan_changes_removing: "Vous désactivez : {items}",
  plan_changes_changing: "Vous modifiez : {items}",
  plan_changes_due_today: "Vous payez aujourd’hui : {amount}",
  max_gap_between_bookings_checkbox_text:
    "Limiter l’écart entre les réservations d’un employé",
  max_gap_between_bookings: "Écart maximal",
  max_gap_between_bookings_info:
    "Si l’employé a déjà une réservation ce jour-là, les clients ne voient en ligne que les créneaux situés à au plus ce nombre de minutes de celle-ci (pauses avant et après la prestation comprises). Un jour sans réservation affiche tous les créneaux du planning. L’écart défini sur l’employé prime sur celui-ci. Dans le panneau d’administration et l’application employé, vous pouvez ajouter des réservations sans cette limite.",
  logs_diff_max_gap_between_bookings: "Écart maximal entre les réservations",
  invoice_not_issued: "Facture non émise",
  invoice_retry_queued: "En attente",
  invoice_retry_button: "Réémettre la facture",
  invoice_retry_confirm_title: "Réémettre la facture ?",
  invoice_retry_confirm_warning:
    "Nous émettrons la facture une nouvelle fois. La date de paiement servira de date de vente et le client la recevra comme toute autre facture.",
  invoice_retry_queued_info:
    "La facture est en file d’attente. Son statut sera actualisé dans un instant.",
  invoice_retry_skipped_already_issued: "Cette facture a déjà été émise.",
  invoice_retry_skipped_in_progress:
    "Cette facture est déjà en cours d’émission.",
  invoice_retry_skipped_not_eligible:
    "Ce paiement ne peut pas être facturé à nouveau.",
  invoice_retry_skipped_forbidden:
    "Vous n’avez pas l’autorisation d’émettre cette facture.",
  event_bulk_count_bookings: "@{count} réservation|@{count} réservations",
  event_bulk_count_blockades: "@{count} date bloquée|@{count} dates bloquées",
  event_bulk_delete_summary:
    "Vous allez supprimer @{bookings} et @{blockades}.",
  event_bulk_delete_summary_bookings: "Vous allez supprimer @{bookings}.",
  event_bulk_delete_summary_blockades: "Vous allez supprimer @{blockades}.",
  event_deleting_bookings_title: "Suppression de réservations",
  event_deleting_blockades_title: "Suppression de dates bloquées",
  event_bulk_status_summary:
    "@{count} réservation passera au statut « @{status} ».|@{count} réservations passeront au statut « @{status} ».",
  event_bulk_status_skipped_blockades:
    "Nous ignorerons @{blockades}, car les dates bloquées n’ont pas de statut.",
  event_bulk_skipped_bookings_no_permission:
    "Nous ignorerons @{bookings}, car vous n’avez pas les droits nécessaires.",
  event_bulk_skipped_blockades_no_permission:
    "Nous ignorerons @{blockades}, car vous n’avez pas les droits nécessaires.",
  event_bulk_skipped_company_blockades:
    "Nous ignorerons @{blockades} pour toute l’entreprise (sans employé attribué), car vous filtrez par employé.",
  event_bulk_no_filters_warning:
    "Aucun filtre n’est défini : l’opération concernera tous les événements du compte.",
  event_bulk_over_limit_delete:
    "Vous pouvez supprimer au maximum @{limit} événements à la fois. Affinez les filtres, par exemple avec une période plus courte.",
  event_bulk_over_limit_update:
    "Vous pouvez changer le statut d’au maximum @{limit} réservations à la fois. Affinez les filtres, par exemple avec une période plus courte.",
  event_bulk_nothing_to_process: "Cette opération ne concerne aucun événement.",
  panel_company_account_not_found:
    "Nous n'avons pas trouvé ce compte d'entreprise. Il a peut-être été supprimé. Reconnectez-vous pour continuer.",
  bulk_operation_completed_with_skipped:
    "Opération terminée. Traités : @{processed}, échecs : @{failed}, ignorés : @{skipped}. Les éléments ignorés étaient déjà supprimés ou hors de vos autorisations.",
  employee_panel_access_title: "Accès au panneau Calendesk",
  employee_public_profile_title: "Profil visible par les clients",
  employee_advanced_settings_title: "Paramètres avancés",
  employee_max_gap_card_info:
    "Le planning de disponibilité décide toujours quand cet employé reçoit des clients. L’écart ne s’applique qu’aux jours où quelqu’un a déjà réservé : le client voit alors les créneaux proches des réservations existantes. Un jour sans réservation, il voit tous les créneaux du planning. « Aucune limite » désactive cette restriction.",
  employee_max_gap_switch: "Écart propre à cet employé",
  employee_max_gap_none: "Aucune limite",
  employee_max_gap_title: "Écart maximal entre les réservations",
  max_gap_timeline_booking: "Réservation",
  max_gap_timeline_open: "Libre",
  max_gap_timeline_closed: "Masqué",
  max_gap_timeline_caption_limited:
    "Le client ne voit que les créneaux situés à @{gap} au plus de la réservation. Les créneaux plus éloignés sont masqués, mais seulement les jours où quelqu’un a déjà réservé. Les horaires de travail restent ceux du planning de disponibilité.",
  max_gap_timeline_caption_unlimited:
    "Sans limite, le client voit tous les créneaux libres du planning, quelles que soient les réservations.",
  employee_services_section_title: "Services et planning de disponibilité",
  employee_availability_scope_from_employee:
    "Créneaux issus du planning de l’employé",
  employee_availability_scope_own_schedule:
    "Créneaux issus du planning du service",
  employee_availability_scope_none_here: "Aucun des services sélectionnés",
  employee_availability_scope_caption:
    "Si un service possède son propre planning, les clients voient les créneaux de ce planning et celui de l’employé est alors ignoré. Pour les autres services, les clients voient les créneaux du planning de disponibilité de l’employé choisi ci-dessus.",
  employee_availability_scope_not_public:
    "Cet employé n’accepte pas les réservations en ligne, les clients ne verront donc ses créneaux dans aucun service.",
  employee_availability_scope_no_services:
    "Sélectionnez les services que cet employé assure. Sans eux, les clients ne pourront pas réserver avec cette personne.",
  employee_availability_scope_no_schedule:
    "Sans planning de disponibilité, les clients ne verront ici aucun créneau libre.",
  employee_legacy_hours_warning:
    "Cet employé utilise encore l’ancien planning de travail. Transférez-le vers un planning de disponibilité : vous pourrez l’attribuer à d’autres personnes et le modifier à un seul endroit.",
  employee_legacy_hours_migrate: "Transférer vers un planning de disponibilité",
  employee_legacy_hours_migrated:
    "Les horaires passeront dans un nouveau planning « @{name} » lorsque vous enregistrerez l’employé.",
  employee_legacy_schedule_name: "@{name} - planning de travail",
  employee_public_preview_caption:
    "Voici ce que verront les clients. Selon le calendrier de réservation choisi, une description plus longue se replie après @{limit} caractères derrière le lien « Afficher plus » ou se trouve, avec les liens, derrière la flèche à côté du nom. La section Équipe de votre site web affiche la description entière.",
  employee_public_preview_name_placeholder: "Prénom et nom",
  employee_public_preview_description_placeholder:
    "La description de l’employé apparaîtra ici.",
  employee_send_set_password_link:
    "Envoyer à l’employé un lien pour définir son mot de passe",
  employee_send_set_password_link_hint:
    "Le lien sera envoyé à @{email} dans la langue de l’employé et reste valable 7 jours.",
  employee_role_matrix_label: "Comparaison des rôles",
  employee_role_matrix_own_calendar: "Calendrier et réservations personnels",
  employee_role_matrix_others_calendars: "Calendriers des autres employés",
  employee_role_matrix_customers: "Données des clients",
  employee_role_matrix_booking_payments: "Paiements des réservations",
  employee_role_matrix_team_services_website: "Employés, services et site web",
  employee_role_matrix_account_settings: "Paramètres du compte",
  employee_role_matrix_plan_invoices: "Forfait Calendesk et factures",
  employee_role_matrix_cell_yes: "Oui",
  employee_role_matrix_cell_no: "Non",
  employee_role_matrix_cell_own: "Uniquement les siens",
  employee_role_matrix_cell_view: "Consultation seule",
  employee_role_matrix_cell_own_customers:
    "Uniquement les siens : ceux des réservations qu’il assure ou auxquelles il participe, et ceux qu’il a ajoutés",
  employee_role_matrix_cell_no_delete: "Oui, sans suppression",
  employee_locale_time_zone_title: "Langue et fuseau horaire",
  employee_locale_time_zone_info:
    "La langue détermine le panneau et les e-mails système que Calendesk envoie à l’employé, par exemple le lien pour définir le mot de passe. Les notifications de réservation partent dans la langue de vos modèles. Le fuseau horaire fixe les heures affichées dans le panneau de l’employé. Les champs vides reprennent les paramètres de l’ensemble du compte.",
  employee_locale_time_zone_locked:
    "Vous pouvez autoriser les employés à choisir leur propre langue et leur propre fuseau horaire dans les paramètres de la plateforme.",
  employee_locale_time_zone_locked_link: "Accéder aux paramètres",
  max_gap_timeline_badge: "Exemple",
  max_gap_timeline_title:
    "Une journée de travail type issue du planning, avec une réservation",
  max_gap_timeline_row_without: "Sans écart",
  max_gap_timeline_row_with: "Avec un écart de @{gap}",
  max_gap_timeline_row_empty: "Journée sans réservation",
  max_gap_timeline_start: "début de journée",
  max_gap_timeline_end: "fin de journée",
  max_gap_timeline_caption_nothing_hidden:
    "Dans cet exemple, un écart de @{gap} ne masque rien, car toute la journée reste à sa portée.",
  max_gap_timeline_empty_note:
    "Tant que personne n’a réservé, l’écart ne change rien : le client voit tous les créneaux du planning.",
  employee_max_gap_subtitle:
    "À quelle distance d’une réservation existante le client peut choisir un créneau.",
  employee_max_gap_switch_hint_off:
    "Pour l’instant, l’écart défini sur chaque prestation s’applique.",
  employee_max_gap_switch_hint_on:
    "Cet écart s’applique à toutes les prestations de cet employé et remplace les réglages des prestations.",
  employee_public_preview_show_more: "Afficher plus",
  employee_public_preview_collapse: "Réduire",
  variable_booking_resources:
    "Ressources de la réservation avec leur ensemble (ex. : Salles › Salle A)",
  variable_booking_resources_block:
    "Ressources de la réservation ou un texte s’il n’y en a aucune",
  booking_resources_block_with: "Ressources attribuées : [BOOKING_RESOURCES]",
  booking_resources_block_without:
    "Nous attribuerons les ressources avant votre réservation.",
  resource_example_name: "Salle A",
  booking_resources_preview_title: "Ressources dans l’aperçu",
  booking_resources_preview_with: "Avec ressource",
  booking_resources_preview_without: "Sans ressource",
  booking_resource_conflicts_dialog_title: "Conflit de ressources",
  booking_resource_conflicts_dialog_message:
    "À ce moment-là, les ressources choisies sont déjà attribuées à d’autres réservations :",
  booking_resource_conflicts_dialog_question:
    "Enregistrer quand même la réservation ?",
  booking_resource_conflicts_other_employee: "Réservation d’un autre employé",
  booking_resource_conflicts_truncated:
    "Seule une partie des conflits est affichée.",
  booking_resources_day_preview_title:
    "Réservations avec ces ressources ce jour-là",
  booking_reminder_custom_content_button: "Modifier le texte",
  booking_reminder_custom_content_chip: "Texte personnalisé",
  booking_reminder_use_default_content_information:
    "Ce rappel enverra de nouveau le texte du modèle « Rappel de réservation ».",
  logs_subject_type_bookingresource:
    "Association d’une ressource à une réservation",
  booking_resources_info:
    "Choisissez ce que vous attribuez à cette réservation, par exemple un cabinet ou une salle. Le client le voit dans sa réservation et reçoit une notification en cas de changement, si vous envoyez les notifications.",
  booking_tags_info:
    "Seuls vous et votre équipe voyez les étiquettes, pas vos clients. Elles servent à marquer les réservations et à filtrer la liste des réservations.",
  resource_type_resource: "Ressource",
  resource_type_pool: "Ensemble",
  resource_group_usage_per_participant: "Chaque participant occupe une place",
  resource_group_usage_per_slot: "Tout le groupe occupe une place",
  resource_assignment_manual_only: "À personne, je l’attribuerai moi-même",
  resource_assignment_always: "À toutes les réservations",
  resource_assignment_by_rule: "Uniquement aux réservations choisies",
  resource_convert_to_pool: "Transformer en ensemble",
  resource_convert_to_pool_info:
    "Indiquez le nom des éléments. La quantité deviendra leur nombre.",
  resource_convert_to_resource: "Transformer en ressource simple",
  resource_convert_to_resource_info:
    "Nous supprimerons tous les éléments de cet ensemble et les retirerons des réservations. Cette action est irréversible.",
  booking_resources_group_locked:
    "Tout le groupe a cet élément. Modifiez-le dans la réservation de groupe.",
  booking_resources_group_single_date:
    "Les ressources du groupe se modifient pour cette date uniquement.",
  booking_resources_awaiting: "aucune pour l’instant, en attente d’attribution",
  booking_resources_awaiting_pool: "« @{pool} » : en attente d’attribution",
  booking_resource_rule_mismatch_title_service:
    "Cet élément n’est pas prévu pour ce service",
  booking_resource_rule_mismatch_title_booking:
    "Cet élément n’est pas prévu pour cette réservation",
  booking_resource_rule_only_services:
    "« @{resource} » (ensemble « @{pool} ») ne s’utilise que pour : @{services}.",
  booking_resource_rule_only_employees:
    "« @{resource} » (ensemble « @{pool} ») ne s’utilise que pour les réservations avec : @{employees}.",
  booking_resource_rule_services_with_employees:
    "« @{resource} » (ensemble « @{pool} ») ne s’utilise que pour : @{services}, et seulement avec : @{employees}.",
  booking_resource_rule_services_or_employees:
    "« @{resource} » (ensemble « @{pool} ») ne s’utilise que pour : @{services} ou pour les réservations avec : @{employees}.",
  booking_resource_rule_other:
    "« @{resource} » (ensemble « @{pool} ») a une règle d’attribution qui ne couvre pas cette réservation.",
  booking_resource_rule_booking: "Cette réservation concerne : @{service}.",
  booking_resource_rule_booking_with_employee:
    "Cette réservation concerne : @{service}, avec : @{employee}.",
  booking_resource_rule_mismatch_question_one:
    "Enregistrer quand même la réservation avec cet élément ?",
  booking_resource_rule_mismatch_question_many:
    "Enregistrer quand même la réservation avec ces éléments ?",
  booking_resource_suggestions_none:
    "Aucun élément n’est libre dans l’ensemble « @{pool} » à ce moment.",
  booking_resource_shortage_title: "Aucune ressource libre à cette heure",
  booking_resource_shortage_title_pool: "Aucun élément libre à cette heure",
  booking_resource_shortage_pool:
    "Tous les éléments de l’ensemble « @{pool} » sont occupés à @{time} (@{used} sur @{capacity}). Si vous enregistrez la réservation, elle ne recevra aucun élément de cet ensemble.",
  booking_resource_shortage_pool_rule:
    "L’ensemble « @{pool} » n’a aucun élément libre pour cette réservation à @{time} : ses éléments libres sont prévus pour d’autres réservations. Si vous enregistrez la réservation, elle ne recevra aucun élément de cet ensemble.",
  booking_resource_shortage_resource:
    "La ressource « @{resource} » est occupée à @{time} (@{used} sur @{capacity}).",
  booking_resource_suggestions_title: "Libres et autorisées à ce moment :",
  availability_schedule_resources_condition_info:
    "Ces horaires ne valent que pour les prestations qui utilisent les ressources choisies. Si vous choisissez des éléments précis, une réservation sur ces horaires en reçoit une.",
  resource_wizard_step_type: "Ce que vous ajoutez",
  resource_wizard_step_names: "Noms",
  resource_wizard_step_quantity: "Quantité",
  resource_wizard_step_services: "Services",
  resource_wizard_step_group: "Réservations de groupe",
  resource_wizard_step_assignment: "Attribution",
  resource_wizard_step_summary: "Vérifier",
  resource_wizard_step_of: "Étape @{step} sur @{total}",
  resource_wizard_steps_label: "Étapes de l’assistant",
  resource_wizard_title_new_pool: "Nouvel ensemble « @{name} »",
  resource_wizard_title_new_resource: "Nouvelle ressource « @{name} »",
  resource_wizard_title_edit: "Modifier « @{name} »",
  resource_wizard_title_add_position: "Ajouter un élément à « @{name} »",
  resource_wizard_type_title: "Que souhaitez-vous ajouter ?",
  resource_wizard_type_subtitle:
    "Choisissez ce qui correspond à votre situation.",
  resource_wizard_type_resource_title: "Plusieurs choses identiques",
  resource_wizard_type_resource_info:
    "Par exemple 2 salles ou 3 vidéoprojecteurs. Peu importe quel exemplaire revient à chaque réservation.",
  resource_wizard_type_pool_title: "Des choses qui ont chacune leur nom",
  resource_wizard_type_pool_info:
    "Par exemple les cabinets 106, 107 et 108. Chaque réservation en reçoit un, et vous voyez lequel.",
  resource_wizard_name_label: "Quel nom lui donner ?",
  resource_wizard_name_hint_pool:
    "Le nom de tout l’ensemble, par exemple « Cabinets ».",
  resource_wizard_name_hint_resource:
    "Par exemple « Salles » ou « Vidéoprojecteurs ».",
  resource_wizard_names_title: "Que contient l’ensemble « @{name} » ?",
  resource_wizard_names_subtitle:
    "Saisissez les noms que vous et votre équipe verrez. Il faut au moins deux éléments différents.",
  resource_wizard_position_name: "Nom",
  resource_wizard_add_position: "Ajouter un élément",
  resource_wizard_empty_rows_skipped: "Les lignes vides seront ignorées.",
  resource_wizard_removed_positions_info:
    "À l'enregistrement, les éléments supprimés sont aussi retirés des réservations auxquelles ils étaient attribués. Les réservations restent.",
  resource_guide_title: "Comment fonctionnent les ressources ?",
  resource_guide_intro:
    "Une ressource est ce dont une réservation a besoin et dont vous avez une quantité limitée : un cabinet, une salle, du matériel. Quand tout est pris, vos clients ne voient plus ce créneau comme libre.",
  resource_guide_resource_text:
    "Vous comptez seulement des unités. Trois vidéoprojecteurs, c’est au plus trois réservations à la même heure, sans préciser lequel.",
  resource_guide_pool_text:
    "Chaque unité porte un nom, par exemple les cabinets 106, 107 et 108. La réservation reçoit un élément précis, visible dans le calendrier et dans la fenêtre de réservation.",
  resource_guide_assignment_title: "Qui reçoit un élément ?",
  resource_guide_assignment_always:
    "Toute réservation d’une prestation qui utilise l’ensemble.",
  resource_guide_assignment_by_rule:
    "Seulement les personnes ou les prestations choisies, par exemple le cabinet 108 uniquement pour la thérapie de couple.",
  resource_guide_assignment_manual_only:
    "La réservation attend que vous choisissiez un élément dans la fenêtre de réservation. Vous retrouvez ces réservations dans la liste des réservations avec le filtre « En attente d’une ressource ».",
  resource_guide_schedules_title: "Les ressources dans les plannings",
  resource_guide_schedules_text:
    "Dans un planning de disponibilité, vous pouvez indiquer un ensemble ou des éléments précis. Une réservation sur ces horaires en reçoit un. Un élément que vous attribuez vous-même n’ouvre aucun créneau : indiquez des éléments attribués automatiquement.",
  resource_guide_groups_title: "Séances de groupe",
  resource_guide_groups_text:
    "Pour chaque ressource, vous choisissez si chaque participant occupe une place ou si tout le groupe en occupe une.",
  resource_delete_pool_info:
    "Supprimer un ensemble supprime aussi ses éléments et les retire des réservations auxquelles ils étaient attribués. Les réservations restent.",
  delete_failed_for:
    "Supprimés : @{deleted}. Impossible de supprimer : @{failed}",
  delete_failed_item: "« @{name} » : @{reason}",
  resource_wizard_quantity_title: "Combien de « @{name} » avez-vous ?",
  resource_wizard_quantity_subtitle:
    "C’est le nombre de réservations que vous pourrez accepter à la même heure.",
  resource_wizard_quantity_less: "Moins",
  resource_wizard_quantity_more: "Plus",
  resource_wizard_services_title: "Quels services utilisent « @{name} » ?",
  resource_wizard_services_subtitle_pool:
    "Chaque réservation d’un service coché occupe un élément de l’ensemble. Vous pourrez le modifier plus tard dans les paramètres du service.",
  resource_wizard_services_subtitle_resource:
    "Chaque réservation d’un service coché occupe une unité. Vous pourrez le modifier plus tard dans les paramètres du service.",
  resource_wizard_no_services:
    "Vous n’avez pas encore de services. Une fois vos services ajoutés, vous choisirez la ressource dans leurs paramètres.",
  resource_wizard_services_online_note:
    "En général, inutile de cocher ici les services en ligne.",
  resource_wizard_service_minutes: "@{minutes} min",
  resource_wizard_service_group: "de groupe, jusqu’à @{max} personnes",
  resource_wizard_group_title:
    "@{service} : combien de places de « @{name} » un groupe occupe-t-il ?",
  resource_wizard_group_subtitle:
    "C’est un service de groupe, il faut donc le préciser.",
  resource_wizard_group_one_position: "un élément de « @{name} »",
  resource_wizard_group_one_unit: "une unité de « @{name} »",
  resource_wizard_group_per_participant_info: "Chaque personne occupe @{unit}.",
  resource_wizard_group_per_slot_info:
    "Tout le groupe occupe @{unit}, quel que soit le nombre de personnes. Le reste demeure disponible pour d’autres réservations.",
  resource_wizard_assignment_title:
    "Comment attribuer les éléments de l’ensemble « @{name} » ?",
  resource_wizard_assignment_subtitle:
    "Le système attribue automatiquement un élément libre à chaque nouvelle réservation. Vous pouvez limiter cela ici. Si peu vous importe quelle réservation reçoit quel élément, ne changez rien.",
  resource_wizard_assignment_question:
    "À qui le système peut-il attribuer « @{name} » ?",
  resource_wizard_assignment_always_info:
    "Le système peut attribuer cet élément à toute réservation des services cochés.",
  resource_wizard_assignment_by_rule_info:
    "Vous choisissez avec qui et pour quels services le système peut attribuer cet élément. Vous pouvez cocher des personnes, des services ou les deux. Les autres réservations recevront un autre élément de l’ensemble.",
  resource_wizard_assignment_manual_only_info:
    "Le système n’attribue jamais cet élément lui-même, vous le faites dans la fenêtre de réservation. Il compte quand même dans la limite : avec @{positions} élément, les clients peuvent faire au plus @{count} réservation à la même heure, même avant toute attribution.|Le système n’attribue jamais cet élément lui-même, vous le faites dans la fenêtre de réservation. Il compte quand même dans la limite : avec @{positions} éléments, les clients peuvent faire au plus @{count} réservations à la même heure, même avant toute attribution.",
  resource_wizard_set_all_always:
    "Choisir « À toutes les réservations » partout",
  resource_wizard_rule_employees: "Avec qui ?",
  resource_wizard_rule_services: "Pour quels services ?",
  resource_wizard_rule_empty_means_all: "Un champ vide signifie « tous ».",
  resource_wizard_rule_match_question:
    "Des personnes et des services sont cochés. Qui peut recevoir cet élément ?",
  resource_wizard_rule_match_all: "Les deux doivent correspondre",
  resource_wizard_rule_match_all_example:
    "Par exemple uniquement « @{service} » quand @{employee} s’en occupe.",
  resource_wizard_rule_match_any: "Un seul suffit",
  resource_wizard_rule_match_any_example:
    "Par exemple toute réservation dont s’occupe @{employee} et toute réservation « @{service} ».",
  resource_wizard_rule_needs_services:
    "Cochez d’abord des services à l’étape « Services ».",
  resource_wizard_rule_pool_without_services:
    "Cet ensemble n’est encore lié à aucun service.",
  resource_wizard_rule_advanced:
    "Cet élément a une règle définie via l’API qui ne peut pas s’afficher ici. Elle reste inchangée tant que vous ne la remplacez pas.",
  resource_wizard_rule_replace: "Remplacer par un choix simple",
  resource_wizard_rule_advanced_short: "règle de l’API",
  resource_wizard_or: "ou",
  resource_wizard_summary_title: "Vérifiez avant d’enregistrer",
  resource_wizard_summary_subtitle:
    "À droite : la même journée type avec vos paramètres.",
  resource_wizard_summary_type: "Type",
  resource_wizard_summary_name: "Nom",
  resource_wizard_summary_positions: "Éléments",
  resource_wizard_summary_quantity: "Quantité",
  resource_wizard_summary_services: "Services",
  resource_wizard_summary_group: "Réservations de groupe",
  resource_wizard_summary_daily_limit: "Limite quotidienne",
  resource_wizard_summary_assignment: "Attribution",
  resource_wizard_summary_no_services:
    "Aucun, vous les ajouterez plus tard dans le service",
  resource_wizard_change: "Modifier",
  resource_wizard_create_pool: "Créer l’ensemble",
  resource_wizard_create_resource: "Créer la ressource",
  resource_wizard_count_positions: "@{count} élément|@{count} éléments",
  resource_wizard_count_units: "@{count} unité|@{count} unités",
  resource_wizard_error_name_required: "Saisissez un nom.",
  resource_wizard_error_name_too_long:
    "Le nom peut contenir au maximum @{max} caractères.",
  resource_wizard_error_name_characters:
    "Le nom ne peut contenir ni crochets, ni accolades, ni les signes < et >.",
  resource_wizard_error_duplicate: "Ce nom figure déjà dans la liste.",
  resource_wizard_error_two_names: "Saisissez au moins deux noms différents.",
  resource_wizard_error_too_many:
    "Un ensemble peut contenir au maximum 200 éléments.",
  resource_wizard_error_quantity: "Saisissez un nombre entre 1 et @{max}.",
  resource_wizard_error_rule_empty:
    "Cochez au moins une personne ou un service.",
  resource_wizard_close_title: "Fermer sans enregistrer ?",
  resource_wizard_close_warning:
    "Les noms et paramètres saisis ne seront pas enregistrés.",
  resource_wizard_close_keep: "Revenir à l’assistant",
  resource_wizard_close_discard: "Fermer sans enregistrer",
  resource_wizard_pool_added: "Ensemble « @{name} » ajouté.",
  resource_wizard_resource_added: "Ressource « @{name} » ajoutée.",
  resource_wizard_saved: "Modifications enregistrées.",
  resource_wizard_in_practice: "Ce que cela donne en pratique",
  resource_wizard_example_always:
    "Toute réservation d’un service qui utilise l’ensemble « @{pool} » peut recevoir « @{name} » si aucune autre réservation n’y est prévue à cette heure-là.",
  resource_wizard_example_manual:
    "Le système n’attribue jamais « @{name} » lui-même. Vous l’attribuez dans la fenêtre de réservation.",
  resource_wizard_example_manual_counts:
    "Une réservation qui attend votre attribution occupe aussi une place dans l’ensemble. Quand tous les éléments sont pris ou en attente d’attribution, les clients ne voient pas cet horaire.",
  resource_wizard_example_fits:
    "@{service} avec @{employee} : peut recevoir « @{name} » si aucune autre réservation n’y est prévue à cette heure-là.",
  resource_wizard_example_misses:
    "@{service} avec @{employee} : ne recevra pas « @{name} ». Le système attribuera un autre élément libre.",
  resource_wizard_preview_example_title: "Avec votre propre exemple",
  resource_wizard_preview_type_name_first:
    "Saisissez un nom à gauche et nous vous montrerons comment il apparaîtra dans la réservation.",
  resource_wizard_preview_label_title:
    "Voici ce que vous verrez dans la réservation",
  resource_wizard_preview_label_caption:
    "Dans la fenêtre de réservation et dans le calendrier.",
  resource_wizard_preview_booking_resources: "Ressources de la réservation",
  resource_wizard_preview_label_pool_note:
    "À la place de « … » s’affichera le nom d’un élément de l’ensemble « @{name} ». Vous les saisirez à l’étape suivante.",
  resource_wizard_preview_label_resource_note:
    "Vous indiquerez à l’étape suivante combien de « @{name} » vous avez.",
  resource_wizard_preview_names_caption:
    "Chaque réservation reçoit l’un de ces éléments. Dans le calendrier et la fenêtre de réservation, vous le voyez avec le nom de l’ensemble.",
  resource_wizard_preview_names_examples:
    "Ressources de la réservation, exemples",
  resource_wizard_preview_names_empty: "Saisissez les noms à gauche.",
  resource_wizard_preview_names_note:
    "@{positions} élément, c’est au plus @{bookings} réservation à la même heure. Vous choisirez qui le reçoit à l’étape « Attribution ».|@{positions} éléments, c’est au plus @{bookings} réservations à la même heure. Vous choisirez qui les reçoit à l’étape « Attribution ».",
  resource_wizard_preview_more_positions:
    "et @{count} autre élément|et @{count} autres éléments",
  resource_wizard_preview_quantity_title: "Combien de réservations à la fois ?",
  resource_wizard_preview_quantity_caption:
    "C’est le nombre de réservations qui peuvent occuper « @{name} » à la même heure.",
  resource_wizard_preview_quantity_at_once:
    "@{count} réservation à la fois|@{count} réservations à la fois",
  resource_wizard_preview_quantity_note:
    "Le calendrier affiche cet horaire comme disponible jusqu’à ce qu’il y ait @{count} réservation.|Le calendrier affiche cet horaire comme disponible jusqu’à ce qu’il y ait @{count} réservations.",
  resource_wizard_preview_services_title:
    "Quelles réservations occupent « @{name} » ?",
  resource_wizard_preview_services_caption:
    "D’après les services que vous cochez.",
  resource_wizard_preview_services_empty: "Cochez des services à gauche.",
  resource_wizard_preview_service_one_place: "Occupe une place.",
  resource_wizard_preview_service_group_one_place:
    "Occupe une place pour tout le groupe.",
  resource_wizard_preview_service_run_by: "Assuré par : @{names}",
  resource_wizard_insight_people_one_service:
    "Ce service est assuré par @{count} personne|Ce service est assuré par @{count} personnes",
  resource_wizard_insight_people_services:
    "Ces services sont assurés par @{count} personne|Ces services sont assurés par @{count} personnes",
  resource_wizard_insight_pool_capacity:
    "et l’ensemble « @{name} » compte @{count} élément.|et l’ensemble « @{name} » compte @{count} éléments.",
  resource_wizard_insight_resource_capacity:
    "et la quantité disponible de « @{name} » est de @{count}.",
  resource_wizard_insight_short:
    "À la même heure, le calendrier ne permettra pas de réserver avec l’une d’elles.|À la même heure, le calendrier ne permettra pas de réserver avec @{count} d’entre elles.",
  resource_wizard_insight_enough_all:
    "Il y a assez de place, même si tout le monde travaille à la même heure.",
  resource_wizard_insight_enough: "Il y a assez de place.",
  resource_wizard_preview_group_caption:
    "Jusqu’à @{max} personnes par séance. « @{name} » : @{units}.",
  resource_wizard_preview_group_slot_box:
    "@{service}, @{max} personnes inscrites",
  resource_wizard_preview_group_slot_takes:
    "occupe 1 des @{capacity} places de « @{name} »",
  resource_wizard_preview_group_left_positions:
    "Pour d’autres réservations à cette heure-là, @{count} élément reste libre.|Pour d’autres réservations à cette heure-là, @{count} éléments restent libres.",
  resource_wizard_preview_group_left_units:
    "Pour d’autres réservations à cette heure-là, @{count} unité reste libre.|Pour d’autres réservations à cette heure-là, @{count} unités restent libres.",
  resource_wizard_preview_group_none_left:
    "Aucune autre réservation n’est possible à cette heure-là.",
  resource_wizard_preview_group_participants_fit:
    "Au plus @{count} personne peut s’inscrire|Au plus @{count} personnes peuvent s’inscrire",
  resource_wizard_preview_group_participants_left:
    "Chaque personne occupe sa propre place. Pour d’autres réservations à cette heure-là, @{count} place reste libre.|Chaque personne occupe sa propre place. Pour d’autres réservations à cette heure-là, @{count} places restent libres.",
  resource_wizard_preview_group_too_small:
    "Le service accepte jusqu’à @{max} personnes, mais chacune a besoin de sa propre place et vous en avez @{capacity}. Si le groupe partage une seule place, choisissez la deuxième option.",
  resource_wizard_preview_day_title: "Une journée type",
  resource_wizard_preview_day_caption:
    "Tout le monde a une réservation à 10:00, et @{first} aussi à 11:00.",
  resource_wizard_preview_bookings_row: "Réservations",
  resource_wizard_preview_legend_gets: "a une place",
  resource_wizard_preview_legend_waits: "attend une attribution",
  resource_wizard_preview_legend_missed:
    "pas de place, les clients ne verront pas cette heure",
  resource_wizard_preview_day_needs_services:
    "Cochez des services à l’étape « Services » et nous vous montrerons une journée type avec vos employés.",
  resource_wizard_preview_taken: "Occupé",
  resource_wizard_preview_customers_see: "Côté clients",
  resource_wizard_preview_free: "libre",
  resource_wizard_preview_gone: "masqué",
  resource_wizard_preview_log_takes:
    "@{employee}, @{hour}, @{service} : occupe une unité de « @{resource} ».",
  resource_wizard_preview_log_gets:
    "@{employee}, @{hour}, @{service} : reçoit « @{unit} ».",
  resource_wizard_preview_log_waits:
    "@{employee}, @{hour}, @{service} : le système n’a rien à attribuer lui-même. La réservation est enregistrée et attend que vous lui attribuiez un élément. En attendant, elle occupe une place, par exemple « @{unit} ».",
  resource_wizard_preview_log_full:
    "@{employee}, @{hour}, @{service} : aucune place libre, les clients ne verront donc pas cet horaire chez cette personne. Dans le panneau, vous pouvez quand même enregistrer une telle réservation.",
  resource_wizard_preview_log_no_match:
    "@{employee}, @{hour}, @{service} : aucun élément libre n’est prévu pour cette réservation, les clients ne verront donc pas cet horaire chez cette personne.",
  resource_wizard_preview_manual_note:
    "Une réservation en attente d’attribution manuelle occupe aussi une place. C’est pourquoi « @{name} » accepte au plus @{count} réservation à la même heure, même avant toute attribution.|Une réservation en attente d’attribution manuelle occupe aussi une place. C’est pourquoi « @{name} » accepte au plus @{count} réservations à la même heure, même avant toute attribution.",
  resource_wizard_preview_order_note:
    "Si plusieurs éléments libres conviennent, le système attribue d’abord celui qui est prévu pour le plus petit groupe de réservations et garde les éléments « À toutes les réservations » pour la fin. Ainsi, les clients voient le plus d’horaires libres possible.",
  resource_wizard_example_no_fit:
    "Pour l’instant, aucune réservation ne correspond à ce choix, le système n’attribuera donc « @{name} » à personne.",
  booking_awaiting_resource: "En attente d’une ressource",
  booking_not_awaiting_resource: "Pas en attente d’une ressource",
  booking_awaiting_resource_info:
    "Le service de cette réservation utilise un ensemble de ressources, mais aucun élément n’est encore attribué. Attribuez-le en modifiant la réservation.",
  availability_schedule_resource_blocked:
    "@{employee} : les clients ne verront aucun créneau disponible sur ces horaires. Les éléments choisis de l’ensemble « @{pool} » sont prévus pour d’autres réservations.",
  availability_schedule_resource_manual:
    "@{employee} : les clients ne verront aucun créneau disponible sur ces horaires, car vous attribuez vous-même les éléments choisis de l’ensemble « @{pool} ». Passez-les sur « À toutes les réservations » ou « Uniquement aux réservations choisies », ou choisissez-en d’autres.",
  resource_wizard_schedule_blocked:
    "Dans le planning « @{schedule} », seuls des éléments de cet ensemble sont indiqués pour @{employee}. Après l’enregistrement, les clients ne verront aucun créneau disponible avec cette personne sur ces horaires.",
  recurring_series_length_locked:
    "Une série existante garde son nombre de répétitions. Pour la raccourcir, supprimez « Cet événement et tous les suivants » à partir de la première date dont vous n’avez plus besoin. Pour la prolonger, créez une nouvelle série.",
  recurring_series_day_move_not_possible:
    "Cette série ne peut pas passer au jour choisi : son rythme (par exemple « le dernier jour ouvré du mois ») ne tiendrait plus après le déplacement. Supprimez « Cet événement et tous les suivants » et créez une nouvelle série à partir du jour souhaité.",
  recurring_series_changed_meanwhile:
    "Cette série a changé entre-temps. Actualisez le calendrier et réessayez.",
  class_capacity_exceeded:
    "Ce cours accueille @{max} personnes. Après cette modification, il y en aurait @{total}.",
  remove_tag_title: "Supprimer l’étiquette",
  remove_tag_named:
    "L’étiquette « @{name} » disparaîtra de toutes les réservations et de tous les clients qui l’ont.",
  remove_group_title: "Supprimer le groupe",
  remove_group_named:
    "Les clients du groupe « @{name} » n’en feront plus partie. Les clients restent.",
  remove_resource_title: "Supprimer la ressource",
  remove_resource_named:
    "La ressource « @{name} » disparaîtra de ses services et de toutes les réservations qui l’ont. Les réservations restent.",
  remove_pool_title: "Supprimer l’ensemble",
  remove_pool_named:
    "L’ensemble « @{name} » disparaîtra de ses services avec ses éléments, et les éléments disparaîtront des réservations auxquelles ils étaient attribués. Les réservations restent.",
  remove_position_title: "Supprimer l’élément",
  remove_position_named:
    "L’élément « @{name} » disparaîtra de toutes les réservations qui l’ont. Les réservations restent.",
  resource_wizard_remove_positions_title: "Supprimer les éléments ?",
  resource_wizard_remove_positions_warning:
    "Vous allez supprimer : @{names}. Réservations à partir d’aujourd’hui qui les ont : @{count}. Elles perdent ces éléments mais restent.",
  resource_wizard_remove_positions_button: "Supprimer les éléments",
  resource_wizard_remove_positions_warning_no_count:
    "Vous allez supprimer : @{names}. Les réservations qui les ont perdent ces éléments mais restent.",
  service_description_title: "Description du service",
  service_description_hint:
    "Les clients la voient lorsqu’ils choisissent le service.",
  service_description_placeholder: "Décrivez brièvement le service",
  service_advanced_texts_title: "Textes pour les clients",
  service_advanced_texts_hint:
    "Contenus supplémentaires pendant la réservation et dans les e-mails de réservation.",
  upselling_description_placeholder:
    "Par exemple, une recommandation de produit complémentaire",
  additional_information_after_booking_placeholder:
    "Par exemple, l’accès au lieu ou ce qu’il faut apporter",
  additional_information_after_booking_variable_info:
    "Si vos notifications ont un contenu personnalisé, ajoutez-y la variable [ADDITIONAL_INFORMATION_AFTER_BOOKING]. Sans elle, ces informations n’apparaîtront pas.",
  service_advanced_availability_title: "Disponibilité et ressources",
  service_advanced_availability_hint:
    "Limites supplémentaires des créneaux et ressources nécessaires au service.",
  service_advanced_resources_title: "Ressources",
  service_advanced_resources_hint: "Salles et matériel nécessaires au service.",
  recurrence_too_long:
    "Cette série compte trop de répétitions. Choisissez une date de fin plus proche ou moins de répétitions.",
  overlap_check_occurrences_truncated:
    "Seules les 1000 premières répétitions de cette série ont été vérifiées.",
  series_saved_occurrences_truncated:
    "Enregistré. Les conflits n’ont été vérifiés que sur les 1000 premières répétitions de cette série.",
  location_skype_retired_info:
    "Skype ne fonctionne plus depuis mai 2025. Choisissez Microsoft Teams ou un autre lieu.",
  service_resource_hold_checkbox:
    "Libérer les ressources avant la fin de la réservation",
  service_resource_hold_label: "Temps d’occupation",
  service_resource_hold_whole: "Toute la réservation",
  service_resource_hold_too_long:
    "Au plus la durée de la prestation : @{duration}",
  service_resource_hold_info:
    "Passé ce délai, la ressource redevient disponible pour d’autres réservations, même si celle-ci continue. L’employé reste occupé jusqu’à la fin. Le changement s’applique aussi aux réservations déjà présentes dans le calendrier.",
  resource_daily_limit_checkbox: "Définir une limite quotidienne",
  resource_daily_limit_label: "Limite",
  resource_daily_limit_unit_minutes: "minutes",
  resource_daily_limit_unit_bookings: "réservations",
  resource_daily_limit_per_day: "par jour",
  resource_daily_limit_per_position: "pour chaque élément",
  resource_daily_limit_per_unit: "pour chaque unité",
  resource_daily_limit_total:
    "Au total, @{total} par jour (@{units} × @{limit})",
  resource_daily_limit_bookings_count:
    "@{count} réservation|@{count} réservations",
  resource_daily_limit_caption: "limite de @{limit} par jour",
  resource_wizard_error_daily_limit_minutes:
    "Saisissez entre 1 et 1440 minutes.",
  resource_wizard_error_daily_limit_bookings:
    "Saisissez entre 1 et 100 réservations.",
  resource_daily_usage_minutes: "@{used} sur @{limit} min",
  resource_daily_usage_bookings: "@{used} sur @{limit} réservations",
  resource_daily_over_limit: "au-delà de la limite",
  resource_limit_warning_title: "Limite quotidienne de la ressource",
  resource_limit_warning_minutes:
    "Cette réservation dépasse la limite quotidienne de « @{label} » le @{date} : il ne reste que @{left} min sur @{limit}, et elle en demande @{needed}.",
  resource_limit_warning_minutes_full:
    "Cette réservation dépasse la limite quotidienne de « @{label} » le @{date} : les @{limit} min de la limite sont déjà utilisées, et elle en ajoute @{needed}.",
  resource_limit_warning_bookings:
    "Cette réservation dépasse la limite quotidienne de « @{label} » le @{date} : il ne reste de la place que pour @{left} réservations sur @{limit}, et celle-ci compte pour @{needed}.",
  resource_limit_warning_bookings_full:
    "Cette réservation dépasse la limite quotidienne de « @{label} » le @{date} : la limite de @{limit} réservations est déjà atteinte.",
  resource_limit_warnings_truncated:
    "D’autres dates dépassent la limite, seules les premières sont listées.",
  booking_helper_tile: "Renfort",
  booking_helper_led_by: "responsable :",
  booking_helpers_preview_label: "En renfort",
  booking_helpers_title: "Employés sur cette réservation",
  booking_helpers_role_lead: "Responsable",
  booking_helpers_role_helper: "En renfort",
  booking_helpers_window_whole_booking: "Toute la réservation",
  booking_helpers_window_outside: "Hors réservation",
  booking_helpers_window_title: "Temps de renfort",
  booking_helpers_time_from: "Aide à partir de",
  booking_helpers_time_to: "Aide jusqu’à",
  booking_helpers_time_outside:
    "Choisissez un temps d’aide pendant la réservation (@{start}-@{end}), d’au moins 5 minutes.",
  booking_helpers_help_one:
    "Le créneau @{window} sera bloqué pour @{name}, visible dans le calendrier Calendesk.",
  booking_helpers_help_outside:
    "Le renfort commence après la fin de la réservation, aucun créneau ne sera donc bloqué. Modifiez le début du renfort.",
  booking_helpers_remove: "Retirer l’employé",
  booking_helpers_hint:
    "La dernière fois pour ce service : @{names} (@{window}). Les ajouter à nouveau ?",
  booking_helpers_hint_dismiss: "Pas maintenant",
  booking_helpers_window_whole: "toute la réservation",
  booking_helpers_window_first: "les @{minutes} premières minutes",
  booking_helpers_window_from_for:
    "@{minutes} min à partir de la minute @{offset}",
  booking_helpers_window_from_to_end: "de la minute @{offset} jusqu’à la fin",
  booking_helpers_add_another: "Ajouter un autre employé en renfort",
  booking_helpers_add: "Ajouter un employé en renfort",
  booking_helper_busy_chip: "Renfort indisponible",
  booking_helper_conflicts_title: "Tout le monde n’est pas disponible",
  booking_helper_conflict_outside_hours:
    "@{name} : @{when}-@{end}, en dehors des heures de travail.",
  booking_helper_conflict_booking:
    "@{name} : @{when}-@{end}, a une autre réservation.",
  booking_helper_conflict_booking_details:
    "@{name} : @{when}-@{end}, a une réservation : @{details}.",
  booking_helper_conflict_blockade:
    "@{name} : @{when}-@{end}, a un blocage dans le calendrier.",
  booking_helper_conflict_helper_time:
    "@{name} : @{when}-@{end}, déjà en renfort sur une autre réservation.",
  booking_helper_conflict_helper_time_details:
    "@{name} : @{when}-@{end}, déjà en renfort sur une réservation : @{details}.",
  booking_helper_conflicts_truncated:
    "Seuls les premiers conflits sont affichés.",
  booking_helper_conflicts_question: "Enregistrer quand même ?",
  helper_time_overlaps_count: "Renfort sur d’autres réservations",
  helper_notifications_headline: "Notifications pour les employés en renfort",
  helper_notifications_checkbox:
    "Prévenir les employés en renfort sur une réservation",
  helper_notifications_info:
    "Un employé en renfort est un membre de votre équipe qui travaille sur une réservation avec le responsable, par exemple une co-thérapeute pour une séance de couple. Vous l’ajoutez dans la fenêtre de réservation, dans « Employés sur cette réservation », pour toute la réservation ou une partie. Une fois l’option activée, il reçoit les mêmes messages que le responsable : nouvelle réservation, modification, annulation et rappel. Nous les envoyons par e-mail, SMS et notification push dans l’application mobile, selon vos canaux pour les employés. Les SMS sont décomptés du forfait du compte.",
  resource_example_label: "Salles › Salle A",
  variable_booking_resource_names:
    "Noms des ressources sans ensemble (ex. : Salle A)",
  booking_helpers_add_label: "Qui est en renfort ?",
  cookie_settings: "Paramètres des cookies",
  cookie_settings_description:
    "Consultez ou modifiez les cookies que vous autorisez dans ce panneau.",
  cookie_settings_button: "Ouvrir les paramètres",
  event_filter_helper: "Employé en renfort",
  helper_conflict_reason_outside_hours: "Hors des heures de travail",
  helper_conflict_reason_booking: "A une réservation",
  helper_conflict_reason_blockade: "A un créneau bloqué",
  helper_conflict_reason_helper_time: "En renfort sur une autre réservation",
  helper_conflicts_back: "Revenir et modifier",
  helper_conflicts_save_anyway: "Enregistrer quand même",
  event_customer_hidden: "Données du client non disponibles",
  payment_paid_info_invoice:
    "Nous marquerons la réservation comme payée et émettrons la facture.",
  payment_paid_info: "Nous marquerons la réservation comme payée.",
  payment_unpaid_info_invoice:
    "Nous enregistrerons uniquement le paiement. La réservation restera non payée et aucune facture ne sera émise, même si vous la marquez comme payée plus tard. Si le client a besoin d’une facture, cochez « @{label} ».",
  payment_unpaid_info:
    "Nous enregistrerons uniquement le paiement. La réservation restera non payée.",
  invoice_state_issuing: "Émission de la facture…",
  invoice_state_blocked: "Sans facture",
  invoice_customer_data_missing:
    "Il manque des données de facturation du client : @{fields}. Complétez-les, puis émettez la facture.",
  invoice_customer_data_complete:
    "Les données du client sont complètes. Vous pouvez émettre la facture.",
  invoice_customer_data_edit: "Corriger les données de facturation du client",
  invoice_issue_button: "Émettre la facture",
  invoice_issue_confirm_title: "Émettre la facture ?",
  invoice_issue_confirm_warning:
    "Nous émettrons la facture avec les données actuelles du client. La date de paiement devient la date de vente, et le client la reçoit comme toute autre facture.",
  invoice_failure_authorization:
    "@{invoicing} n’a pas accepté la clé API. Saisissez-en une nouvelle dans Intégrations › @{invoicing}, champ « Token API », puis réémettez la facture.",
  invoice_failure_rejected:
    "@{invoicing} a refusé la facture, le plus souvent à cause des données du client, comme le numéro de TVA. Corrigez-les, puis réémettez la facture.",
  invoice_failure_unreachable:
    "Nous avons essayé de joindre @{invoicing} plusieurs fois, sans réponse. Réémettez la facture dans quelques minutes.",
  invoice_failure_account_url:
    "L’adresse du compte dans l’intégration ne mène pas à @{invoicing}. Dans Intégrations › @{invoicing}, saisissez l’adresse avec laquelle vous vous connectez, puis réémettez la facture.",
  invoice_customer_field_name: "nom de l’entreprise ou nom complet",
  invoice_customer_field_street: "rue",
  invoice_customer_field_post_code: "code postal",
  invoice_customer_field_city: "ville",
  invoice_customer_field_country: "pays",
  invoice_retry_skipped_customer_data_incomplete:
    "Les données de facturation du client sont encore incomplètes. Il manque : @{fields}.",
  invoice_failure_unknown:
    "Nous n’avons pas pu émettre la facture. Réémettez-la et, si l’erreur se répète, écrivez-nous.",
  invoice_failure_authorization_chip: "Clé API incorrecte",
  invoice_failure_rejected_chip: "Refusée par @{invoicing}",
  invoice_failure_unreachable_chip: "Pas de connexion",
  invoice_failure_account_url_chip: "Adresse incorrecte",
  invoice_fix_integration: "Corriger l’intégration @{invoicing}",
  delete_payment_invoice_issued:
    "La facture @{number} reste dans @{invoicing}. Supprimer le paiement ne l’annule pas. Si nécessaire, émettez une facture rectificative dans @{invoicing}.",
  delete_payment_invoice_issued_no_number:
    "La facture de ce paiement reste dans @{invoicing}. Supprimer le paiement ne l’annule pas. Si nécessaire, émettez une facture rectificative dans @{invoicing}.",
  delete_payment_invoice_pending:
    "La facture de ce paiement est en cours d’émission et restera dans @{invoicing}.",
  delete_payments_invoice_count:
    "@{amount} des paiements sélectionnés a une facture dans @{invoicing}. Supprimer le paiement ne l’annule pas. Si nécessaire, émettez une facture rectificative dans @{invoicing}.|@{amount} des paiements sélectionnés ont des factures dans @{invoicing}. Supprimer les paiements ne les annule pas. Si nécessaire, émettez des factures rectificatives dans @{invoicing}.",
  delete_payments_invoice_any:
    "Si l’un de ces paiements a une facture, elle reste dans @{invoicing}. Supprimer le paiement ne l’annule pas.",
  subscription_payment_invoice_issued:
    "Cet abonnement a déjà un paiement avec la facture @{number} du @{date}. Le nouveau paiement aura sa propre facture.",
  subscription_payment_invoice_issued_no_number:
    "Cet abonnement a déjà un paiement facturé du @{date}. Le nouveau paiement aura sa propre facture.",
  subscription_payment_invoice_pending:
    "Cet abonnement a déjà un paiement du @{date} dont la facture est en cours d’émission. Le nouveau paiement aura sa propre facture.",
  group_count: "@{name} ×@{count} sur @{total}",
  group_count_all: "@{name} ×@{count}",
  select_service_variant: "Choisissez une option de service.",
  booking_accept: "Accepter",
  booking_reject: "Refuser",
  booking_accept_this: "Accepter cette réservation",
  booking_accept_series: "Accepter toute la série",
  booking_waiting_banner: "Cette réservation attend votre acceptation.",
  booking_waiting_banner_series:
    "Elle fait partie d’une série. Si vous acceptez seulement cette réservation, elle sortira de la série.",
  accept_waiting_bookings: "Accepter les réservations en attente",
  accept_selected_bookings: "Accepter les réservations sélectionnées",
  reject_selected_bookings: "Refuser les réservations sélectionnées",
  no_waiting_bookings_selected:
    "Aucune des réservations sélectionnées n’attend d’acceptation.",
  waiting_bookings_banner: "Réservations en attente d’acceptation : @{count}",
  waiting_bookings_show: "Afficher",
  service_requires_acceptance_label:
    "Exiger l’acceptation des réservations en ligne",
  service_requires_acceptance_info:
    "Les réservations faites en ligne par vos clients attendent qu’un membre de votre équipe les accepte ou les refuse. Le client reçoit un message indiquant que sa réservation attend une confirmation (si cette notification est activée).",
  service_default_booking_status_disabled:
    "Lorsque le paiement en ligne est obligatoire ou que la prestation est réservée aux abonnés, le paiement ou l’abonnement confirme la réservation. Elle ne peut donc pas attendre d’acceptation.",
  booking_waiting_participant_fixed:
    "En attente d’acceptation : acceptez ou refusez ce participant dans l’aperçu de la réservation.",
  booking_waiting: "Réservation en attente d’acceptation",
  booking_waiting_info:
    "Envoyée au client et au personnel lorsqu’une réservation en attente d’acceptation est créée. Une fois la réservation acceptée, ils reçoivent la notification « Confirmation de réservation ». Elle n’est pas envoyée si ce type de notification est désactivé ou si l’option « Ne pas envoyer de notification après la création de la visite » a été choisie.",
  booking_waiting_email_subject_client:
    "Réservation en attente de confirmation : [BOOKING_START_DATE] [BOOKING_START_TIME] - [SERVICE_NAME]",
  booking_waiting_email_text_client:
    '<h1>Numéro de réservation: [BOOKING_ID]</h1><hr/><p>Bonjour,</p><p>Nous avons bien reçu votre réservation pour <b>[SERVICE_NAME]</b>. Elle sera valable dès que nous l’aurons confirmée.</p><p><b>Date et heure:</b><br>[BOOKING_START_DATE] [BOOKING_START_TIME] ([BOOKING_TIME_ZONE])</p>[BOOKING_CUSTOM_FIELDS] [ADDITIONAL_INFORMATION_AFTER_BOOKING]<p class="cd-paragraph"></p>[MANAGE_CUSTOMER_BOOKING_BUTTON]',
  booking_waiting_sms_text_client:
    "[COMPANY_NAME] : votre réservation pour [SERVICE_NAME] le [BOOKING_START_DATE] à [BOOKING_START_TIME] est en attente de confirmation.",
  booking_waiting_email_subject_tenant:
    "Réservation à accepter : [BOOKING_START_DATE] [BOOKING_START_TIME] - [SERVICE_NAME]",
  booking_waiting_email_text_tenant:
    '<h1>Numéro de réservation : [BOOKING_ID]</h1><hr/><p>Bonjour,</p><p><b>Une nouvelle réservation a été effectuée pour le service :</b><br> [SERVICE_NAME]</p><p><b>La réservation est en attente d’acceptation. Acceptez-la ou refusez-la dans le panneau.</b></p><p><b>Client :</b><br>[CUSTOMER_FULL_NAME]</p><p><b>Employé :</b><br>[EMPLOYEE_FULL_NAME]</p><p><b>Date et heure :</b><br>[BOOKING_START_DATE] [BOOKING_START_TIME] ([BOOKING_TIME_ZONE])</p><p><b>Lieu :</b><br>[BOOKING_LOCATION] [BOOKING_ONLINE_MEETING_URL]</p>[BOOKING_CUSTOM_FIELDS] [ADDITIONAL_INFORMATION_AFTER_BOOKING]<p class="cd-paragraph"></p>[MANAGE_EMPLOYEE_BOOKING_BUTTON]',
  booking_waiting_sms_text_tenant:
    "[COMPANY_NAME] - Réservation à accepter : [SERVICE_NAME]. Client : [CUSTOMER_FULL_NAME], date : [BOOKING_START_DATE], heure : [BOOKING_START_TIME].",
  notification_category_15: "Réservation en attente d’acceptation",
  service_waiting_slot_label:
    "Une réservation en attente bloque-t-elle le créneau ?",
  service_waiting_slot_held: "Oui, le créneau est pris jusqu’à votre décision",
  service_waiting_slot_held_description:
    "Les autres clients ne peuvent pas réserver ce créneau tant que vous n’avez pas accepté ou refusé la réservation.",
  service_waiting_slot_free: "Non, le créneau reste libre",
  service_waiting_slot_free_description:
    "D’autres clients peuvent encore le réserver. Lors de l’acceptation, vous verrez si le créneau est déjà pris.",
  accept_conflicts_title: "Certains de ces créneaux sont déjà pris :",
  accept_conflicts_line:
    "Réservation @{id} (@{date}) : autres réservations à ce moment : @{count}",
  accept_selection_overlaps_title:
    "Les réservations sélectionnées se chevauchent :",
  accept_selection_overlap_line: "@{date}, @{employee} : @{bookings}",
  booking_accept_anyway: "Accepter quand même",
  resources_filter_whole_pool:
    "Tout l’ensemble, @{count} élément|Tout l’ensemble, @{count} éléments",
  resources_filter_in_whole_pool: "Dans tout l’ensemble",
  resources_filter_pool_chip: "Ensemble : @{name}",
  resources_filter_label: "Ressources et ensembles",
  accept_effects_intro: "Après l’acceptation :",
  accept_channel_email: "par e-mail",
  accept_channel_sms: "par SMS",
  accept_channel_push: "dans l’application mobile",
  accept_effect_customer:
    "@{name} recevra la confirmation de la réservation @{channels}.",
  accept_effect_customers:
    "Les clients recevront la confirmation de réservation @{channels}.",
  accept_effect_employee:
    "@{name} recevra une notification de nouvelle réservation @{channels}.",
  accept_effect_employees:
    "Les employés recevront des notifications de nouvelles réservations @{channels}.",
  accept_effect_company:
    "Votre entreprise recevra une notification de nouvelle réservation @{channels}.",
  accept_effect_silent: "Nous n’enverrons aucune notification.",
  accept_effect_calendar:
    "La réservation sera ajoutée au calendrier connecté (@{calendars}).",
  accept_effect_calendars:
    "Les réservations seront ajoutées aux calendriers connectés (@{calendars}).",
  accept_effect_meeting: "Un lien de réunion en ligne sera créé (@{meeting}).",
  accept_effect_meetings:
    "Des liens de réunion en ligne seront créés (@{meeting}).",
  accept_effect_reminders:
    "Les rappels seront envoyés comme pour toute réservation.",
  accept_effect_generic:
    "Nous enverrons les confirmations prévues par vos paramètres de notification.",
  accept_footer_sent:
    "Une notification envoyée ne peut pas être reprise. Vous pourrez toujours annuler la réservation plus tard.|Une notification envoyée ne peut pas être reprise. Vous pourrez toujours annuler les réservations plus tard.",
  accept_footer:
    "Vous pourrez toujours annuler la réservation plus tard.|Vous pourrez toujours annuler les réservations plus tard.",
  accept_title_one: "Accepter la réservation ?",
  accept_title_many:
    "Accepter @{count} réservation ?|Accepter @{count} réservations ?",
  accept_title_series: "Accepter toutes les réservations de la série ?",
  accept_conflict_info: "Autres réservations au même moment :",
  waiting_to_accept: "À accepter",
  waiting_to_accept_count: "À accepter (@{count})",
};
